/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: subscriptions/subscriptions.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../google/api/annotations";
import * as dependency_2 from "./../google/protobuf/timestamp";
import * as dependency_3 from "./../payments/payments";
import * as dependency_4 from "./../checkout/checkout";
import * as dependency_5 from "./members";
import * as dependency_6 from "./../auth/status";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace subscriptions.v1 {
    export enum CycleStepStatus {
        CYCLE_STEP_STATUS_UNSPECIFIED = 0,
        CYCLE_STEP_STATUS_STARTED = 1,
        CYCLE_STEP_STATUS_SUCCEEDED = 2,
        CYCLE_STEP_STATUS_FAILED = 3
    }
    export enum CompanySize {
        COMPANY_SIZE_UNSPECIFIED = 0,
        COMPANY_SIZE_6_10 = 1,
        COMPANY_SIZE_11_50 = 2,
        COMPANY_SIZE_51_200 = 3,
        COMPANY_SIZE_201_500 = 4,
        COMPANY_SIZE_501_1000 = 5,
        COMPANY_SIZE_1001_5000 = 6,
        COMPANY_SIZE_OVER_5000 = 7
    }
    export enum SubscriptionExportSource {
        SUBSCRIPTION_EXPORT_UNSPECIFIED = 0,
        SUBSCRIPTION_EXPORT_PENDING = 1,
        SUBSCRIPTION_EXPORT_FAILED = 2,
        SUBSCRIPTION_EXPORT_FINISHED = 3
    }
    export enum SubscriptionSource {
        SUBSCRIPTION_SOURCE_UNSPECIFIED = 0,
        SUBSCRIPTION_SOURCE_MANUAL_BANKSLIP = 1,
        SUBSCRIPTION_SOURCE_MANUAL_PURCHASE_COMMITMENT = 2,
        SUBSCRIPTION_SOURCE_COURTESY = 3
    }
    export enum ErrorUpgradePlan {
        ERROR_UPGRADE_PLAN_UNSPECIFIED = 0,
        ERROR_UPGRADE_PLAN_WALLET_IS_EMPTY = 1
    }
    export enum CycleStatus {
        CYCLE_STATUS_UNSPECIFIED = 0,
        CYCLE_STATUS_PENDING = 1,
        CYCLE_STATUS_PAID = 2,
        CYCLE_STATUS_CANCELED = 3,
        CYCLE_STATUS_EXPIRED = 4
    }
    export enum Status {
        STATUS_UNSPECIFIED = 0,
        STATUS_CREATED = 1,
        STATUS_ACTIVE = 2,
        STATUS_PAST_DUE = 3,
        STATUS_CANCELED = 4,
        STATUS_PAUSED = 5,
        STATUS_EXPIRED = 6,
        STATUS_SCHEDULED_CANCELLATION = 7,
        STATUS_SCHEDULED_DOWNGRADE = 8,
        STATUS_PENDING_ACTIVATION = 9,
        STATUS_UPGRADE_PLAN = 10,
        STATUS_SCHEDULED = 11,
        STATUS_BLOCKED_FOR_INCONSISTENCY = 12
    }
    export enum SubscribersReportStatus {
        SUBSCRIBERS_REPORT_STATUS_UNSPECIFIED = 0,
        SUBSCRIBERS_REPORT_STATUS_IN_PROGRESS = 1,
        SUBSCRIBERS_REPORT_STATUS_DONE = 2,
        SUBSCRIBERS_REPORT_STATUS_FAILED = 3
    }
    export enum SubscriptionEventType {
        SUBSCRIPTION_EVENT_TYPE_UNSPECIFIED = 0,
        SUBSCRIPTION_EVENT_TYPE_NEW_PURCHASE = 1,
        SUBSCRIPTION_EVENT_TYPE_RENEWAL = 2
    }
    export enum CycleProblemType {
        CYCLE_PROBLEM_TYPE_UNSPECIFIED = 0,
        CYCLE_PROBLEM_TYPE_FAILED = 1,
        CYCLE_PROBLEM_TYPE_STUCK = 2
    }
    export class Address extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("zipCode" in data && data.zipCode != undefined) {
                    this.zipCode = data.zipCode;
                }
                if ("street" in data && data.street != undefined) {
                    this.street = data.street;
                }
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
                if ("complement" in data && data.complement != undefined) {
                    this.complement = data.complement;
                }
                if ("neighborhood" in data && data.neighborhood != undefined) {
                    this.neighborhood = data.neighborhood;
                }
                if ("city" in data && data.city != undefined) {
                    this.city = data.city;
                }
                if ("state" in data && data.state != undefined) {
                    this.state = data.state;
                }
                if ("country" in data && data.country != undefined) {
                    this.country = data.country;
                }
            }
        }
        get zipCode() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set zipCode(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get street() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set street(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set number(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get complement() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set complement(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get neighborhood() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set neighborhood(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get city() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set city(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get state() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set state(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get country() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set country(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            zipCode?: string;
            street?: string;
            number?: string;
            complement?: string;
            neighborhood?: string;
            city?: string;
            state?: string;
            country?: string;
        }): Address {
            const message = new Address({});
            if (data.zipCode != null) {
                message.zipCode = data.zipCode;
            }
            if (data.street != null) {
                message.street = data.street;
            }
            if (data.number != null) {
                message.number = data.number;
            }
            if (data.complement != null) {
                message.complement = data.complement;
            }
            if (data.neighborhood != null) {
                message.neighborhood = data.neighborhood;
            }
            if (data.city != null) {
                message.city = data.city;
            }
            if (data.state != null) {
                message.state = data.state;
            }
            if (data.country != null) {
                message.country = data.country;
            }
            return message;
        }
        toObject() {
            const data: {
                zipCode?: string;
                street?: string;
                number?: string;
                complement?: string;
                neighborhood?: string;
                city?: string;
                state?: string;
                country?: string;
            } = {};
            if (this.zipCode != null) {
                data.zipCode = this.zipCode;
            }
            if (this.street != null) {
                data.street = this.street;
            }
            if (this.number != null) {
                data.number = this.number;
            }
            if (this.complement != null) {
                data.complement = this.complement;
            }
            if (this.neighborhood != null) {
                data.neighborhood = this.neighborhood;
            }
            if (this.city != null) {
                data.city = this.city;
            }
            if (this.state != null) {
                data.state = this.state;
            }
            if (this.country != null) {
                data.country = this.country;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.zipCode.length)
                writer.writeString(1, this.zipCode);
            if (this.street.length)
                writer.writeString(2, this.street);
            if (this.number.length)
                writer.writeString(3, this.number);
            if (this.complement.length)
                writer.writeString(4, this.complement);
            if (this.neighborhood.length)
                writer.writeString(5, this.neighborhood);
            if (this.city.length)
                writer.writeString(6, this.city);
            if (this.state.length)
                writer.writeString(7, this.state);
            if (this.country.length)
                writer.writeString(8, this.country);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Address {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Address();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.zipCode = reader.readString();
                        break;
                    case 2:
                        message.street = reader.readString();
                        break;
                    case 3:
                        message.number = reader.readString();
                        break;
                    case 4:
                        message.complement = reader.readString();
                        break;
                    case 5:
                        message.neighborhood = reader.readString();
                        break;
                    case 6:
                        message.city = reader.readString();
                        break;
                    case 7:
                        message.state = reader.readString();
                        break;
                    case 8:
                        message.country = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Address {
            return Address.deserialize(bytes);
        }
    }
    export class GetUserSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): GetUserSubscriptionRequest {
            const message = new GetUserSubscriptionRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserSubscriptionRequest {
            return GetUserSubscriptionRequest.deserialize(bytes);
        }
    }
    export class GetUserSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            userId?: string;
            planSummary?: PlanSummary;
            status?: Status;
            userName?: string;
            userEmail?: string;
            document?: string;
            address?: Address;
            currentCycle?: CycleSummary;
            createdAt?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("planSummary" in data && data.planSummary != undefined) {
                    this.planSummary = data.planSummary;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("userName" in data && data.userName != undefined) {
                    this.userName = data.userName;
                }
                if ("userEmail" in data && data.userEmail != undefined) {
                    this.userEmail = data.userEmail;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
                if ("address" in data && data.address != undefined) {
                    this.address = data.address;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get planSummary() {
            return pb_1.Message.getWrapperField(this, PlanSummary, 3) as PlanSummary;
        }
        set planSummary(value: PlanSummary) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPlanSummary() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 4, value);
        }
        get userName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set userName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get userEmail() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set userEmail(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get address() {
            return pb_1.Message.getWrapperField(this, Address, 8) as Address;
        }
        set address(value: Address) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasAddress() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, CycleSummary, 9) as CycleSummary;
        }
        set currentCycle(value: CycleSummary) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 10) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 10) != null;
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
            planSummary?: ReturnType<typeof PlanSummary.prototype.toObject>;
            status?: Status;
            userName?: string;
            userEmail?: string;
            document?: string;
            address?: ReturnType<typeof Address.prototype.toObject>;
            currentCycle?: ReturnType<typeof CycleSummary.prototype.toObject>;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): GetUserSubscriptionResponse {
            const message = new GetUserSubscriptionResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.planSummary != null) {
                message.planSummary = PlanSummary.fromObject(data.planSummary);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.userName != null) {
                message.userName = data.userName;
            }
            if (data.userEmail != null) {
                message.userEmail = data.userEmail;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            if (data.address != null) {
                message.address = Address.fromObject(data.address);
            }
            if (data.currentCycle != null) {
                message.currentCycle = CycleSummary.fromObject(data.currentCycle);
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
                planSummary?: ReturnType<typeof PlanSummary.prototype.toObject>;
                status?: Status;
                userName?: string;
                userEmail?: string;
                document?: string;
                address?: ReturnType<typeof Address.prototype.toObject>;
                currentCycle?: ReturnType<typeof CycleSummary.prototype.toObject>;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.planSummary != null) {
                data.planSummary = this.planSummary.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.userName != null) {
                data.userName = this.userName;
            }
            if (this.userEmail != null) {
                data.userEmail = this.userEmail;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            if (this.address != null) {
                data.address = this.address.toObject();
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.hasPlanSummary)
                writer.writeMessage(3, this.planSummary, () => this.planSummary.serialize(writer));
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(4, this.status);
            if (this.userName.length)
                writer.writeString(5, this.userName);
            if (this.userEmail.length)
                writer.writeString(6, this.userEmail);
            if (this.document.length)
                writer.writeString(7, this.document);
            if (this.hasAddress)
                writer.writeMessage(8, this.address, () => this.address.serialize(writer));
            if (this.hasCurrentCycle)
                writer.writeMessage(9, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (this.hasCreatedAt)
                writer.writeMessage(10, this.createdAt, () => this.createdAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetUserSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetUserSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.planSummary, () => message.planSummary = PlanSummary.deserialize(reader));
                        break;
                    case 4:
                        message.status = reader.readEnum();
                        break;
                    case 5:
                        message.userName = reader.readString();
                        break;
                    case 6:
                        message.userEmail = reader.readString();
                        break;
                    case 7:
                        message.document = reader.readString();
                        break;
                    case 8:
                        reader.readMessage(message.address, () => message.address = Address.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = CycleSummary.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetUserSubscriptionResponse {
            return GetUserSubscriptionResponse.deserialize(bytes);
        }
    }
    export class UpdateCurrentCycleRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1]];
        constructor(data?: any[] | ({
            cycleId?: string;
            metadata?: Map<string, string>;
        } & (({
            invoice?: Invoice;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("invoice" in data && data.invoice != undefined) {
                    this.invoice = data.invoice;
                }
                if ("cycleId" in data && data.cycleId != undefined) {
                    this.cycleId = data.cycleId;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get invoice() {
            return pb_1.Message.getWrapperField(this, Invoice, 1) as Invoice;
        }
        set invoice(value: Invoice) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasInvoice() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get cycleId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set cycleId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 3) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        get _invoice() {
            const cases: {
                [index: number]: "none" | "invoice";
            } = {
                0: "none",
                1: "invoice"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        static fromObject(data: {
            invoice?: ReturnType<typeof Invoice.prototype.toObject>;
            cycleId?: string;
            metadata?: {
                [key: string]: string;
            };
        }): UpdateCurrentCycleRequest {
            const message = new UpdateCurrentCycleRequest({});
            if (data.invoice != null) {
                message.invoice = Invoice.fromObject(data.invoice);
            }
            if (data.cycleId != null) {
                message.cycleId = data.cycleId;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            return message;
        }
        toObject() {
            const data: {
                invoice?: ReturnType<typeof Invoice.prototype.toObject>;
                cycleId?: string;
                metadata?: {
                    [key: string]: string;
                };
            } = {};
            if (this.invoice != null) {
                data.invoice = this.invoice.toObject();
            }
            if (this.cycleId != null) {
                data.cycleId = this.cycleId;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasInvoice)
                writer.writeMessage(1, this.invoice, () => this.invoice.serialize(writer));
            if (this.cycleId.length)
                writer.writeString(2, this.cycleId);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(3, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateCurrentCycleRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateCurrentCycleRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.invoice, () => message.invoice = Invoice.deserialize(reader));
                        break;
                    case 2:
                        message.cycleId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateCurrentCycleRequest {
            return UpdateCurrentCycleRequest.deserialize(bytes);
        }
    }
    export class Invoice extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            number?: string;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            billingReference?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("billingReference" in data && data.billingReference != undefined) {
                    this.billingReference = data.billingReference;
                }
            }
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set number(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get billingReference() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set billingReference(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            number?: string;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            billingReference?: string;
        }): Invoice {
            const message = new Invoice({});
            if (data.number != null) {
                message.number = data.number;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.billingReference != null) {
                message.billingReference = data.billingReference;
            }
            return message;
        }
        toObject() {
            const data: {
                number?: string;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                billingReference?: string;
            } = {};
            if (this.number != null) {
                data.number = this.number;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.billingReference != null) {
                data.billingReference = this.billingReference;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.number.length)
                writer.writeString(1, this.number);
            if (this.hasCreatedAt)
                writer.writeMessage(2, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.billingReference.length)
                writer.writeString(3, this.billingReference);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Invoice {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Invoice();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.number = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        message.billingReference = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Invoice {
            return Invoice.deserialize(bytes);
        }
    }
    export class UpdateCurrentCycleResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdateCurrentCycleResponse {
            const message = new UpdateCurrentCycleResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateCurrentCycleResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateCurrentCycleResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateCurrentCycleResponse {
            return UpdateCurrentCycleResponse.deserialize(bytes);
        }
    }
    export class CycleStepHistoryEntry extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            step?: string;
            stepDescription?: string;
            status?: CycleStepStatus;
            startedAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
            attempts?: number;
            error?: string;
            requestPayload?: string;
            responseBody?: string;
            statusCode?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("step" in data && data.step != undefined) {
                    this.step = data.step;
                }
                if ("stepDescription" in data && data.stepDescription != undefined) {
                    this.stepDescription = data.stepDescription;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("startedAt" in data && data.startedAt != undefined) {
                    this.startedAt = data.startedAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("attempts" in data && data.attempts != undefined) {
                    this.attempts = data.attempts;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("requestPayload" in data && data.requestPayload != undefined) {
                    this.requestPayload = data.requestPayload;
                }
                if ("responseBody" in data && data.responseBody != undefined) {
                    this.responseBody = data.responseBody;
                }
                if ("statusCode" in data && data.statusCode != undefined) {
                    this.statusCode = data.statusCode;
                }
            }
        }
        get step() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set step(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get stepDescription() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set stepDescription(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 3, CycleStepStatus.CYCLE_STEP_STATUS_UNSPECIFIED) as CycleStepStatus;
        }
        set status(value: CycleStepStatus) {
            pb_1.Message.setField(this, 3, value);
        }
        get startedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set startedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasStartedAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 5) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get attempts() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set attempts(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set error(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get requestPayload() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set requestPayload(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get responseBody() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set responseBody(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get statusCode() {
            return pb_1.Message.getFieldWithDefault(this, 10, 0) as number;
        }
        set statusCode(value: number) {
            pb_1.Message.setField(this, 10, value);
        }
        static fromObject(data: {
            step?: string;
            stepDescription?: string;
            status?: CycleStepStatus;
            startedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            attempts?: number;
            error?: string;
            requestPayload?: string;
            responseBody?: string;
            statusCode?: number;
        }): CycleStepHistoryEntry {
            const message = new CycleStepHistoryEntry({});
            if (data.step != null) {
                message.step = data.step;
            }
            if (data.stepDescription != null) {
                message.stepDescription = data.stepDescription;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.startedAt != null) {
                message.startedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.startedAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.attempts != null) {
                message.attempts = data.attempts;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.requestPayload != null) {
                message.requestPayload = data.requestPayload;
            }
            if (data.responseBody != null) {
                message.responseBody = data.responseBody;
            }
            if (data.statusCode != null) {
                message.statusCode = data.statusCode;
            }
            return message;
        }
        toObject() {
            const data: {
                step?: string;
                stepDescription?: string;
                status?: CycleStepStatus;
                startedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                attempts?: number;
                error?: string;
                requestPayload?: string;
                responseBody?: string;
                statusCode?: number;
            } = {};
            if (this.step != null) {
                data.step = this.step;
            }
            if (this.stepDescription != null) {
                data.stepDescription = this.stepDescription;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.startedAt != null) {
                data.startedAt = this.startedAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.attempts != null) {
                data.attempts = this.attempts;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.requestPayload != null) {
                data.requestPayload = this.requestPayload;
            }
            if (this.responseBody != null) {
                data.responseBody = this.responseBody;
            }
            if (this.statusCode != null) {
                data.statusCode = this.statusCode;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.step.length)
                writer.writeString(1, this.step);
            if (this.stepDescription.length)
                writer.writeString(2, this.stepDescription);
            if (this.status != CycleStepStatus.CYCLE_STEP_STATUS_UNSPECIFIED)
                writer.writeEnum(3, this.status);
            if (this.hasStartedAt)
                writer.writeMessage(4, this.startedAt, () => this.startedAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(5, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.attempts != 0)
                writer.writeInt32(6, this.attempts);
            if (this.error.length)
                writer.writeString(7, this.error);
            if (this.requestPayload.length)
                writer.writeString(8, this.requestPayload);
            if (this.responseBody.length)
                writer.writeString(9, this.responseBody);
            if (this.statusCode != 0)
                writer.writeInt32(10, this.statusCode);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CycleStepHistoryEntry {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CycleStepHistoryEntry();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.step = reader.readString();
                        break;
                    case 2:
                        message.stepDescription = reader.readString();
                        break;
                    case 3:
                        message.status = reader.readEnum();
                        break;
                    case 4:
                        reader.readMessage(message.startedAt, () => message.startedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 6:
                        message.attempts = reader.readInt32();
                        break;
                    case 7:
                        message.error = reader.readString();
                        break;
                    case 8:
                        message.requestPayload = reader.readString();
                        break;
                    case 9:
                        message.responseBody = reader.readString();
                        break;
                    case 10:
                        message.statusCode = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CycleStepHistoryEntry {
            return CycleStepHistoryEntry.deserialize(bytes);
        }
    }
    export class AppendCycleStepHistoryRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cycleId?: string;
            subscriptionId?: string;
            entry?: CycleStepHistoryEntry;
            source?: string;
            eventId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cycleId" in data && data.cycleId != undefined) {
                    this.cycleId = data.cycleId;
                }
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("entry" in data && data.entry != undefined) {
                    this.entry = data.entry;
                }
                if ("source" in data && data.source != undefined) {
                    this.source = data.source;
                }
                if ("eventId" in data && data.eventId != undefined) {
                    this.eventId = data.eventId;
                }
            }
        }
        get cycleId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set cycleId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get entry() {
            return pb_1.Message.getWrapperField(this, CycleStepHistoryEntry, 3) as CycleStepHistoryEntry;
        }
        set entry(value: CycleStepHistoryEntry) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasEntry() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get source() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set source(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get eventId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set eventId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            cycleId?: string;
            subscriptionId?: string;
            entry?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>;
            source?: string;
            eventId?: string;
        }): AppendCycleStepHistoryRequest {
            const message = new AppendCycleStepHistoryRequest({});
            if (data.cycleId != null) {
                message.cycleId = data.cycleId;
            }
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.entry != null) {
                message.entry = CycleStepHistoryEntry.fromObject(data.entry);
            }
            if (data.source != null) {
                message.source = data.source;
            }
            if (data.eventId != null) {
                message.eventId = data.eventId;
            }
            return message;
        }
        toObject() {
            const data: {
                cycleId?: string;
                subscriptionId?: string;
                entry?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>;
                source?: string;
                eventId?: string;
            } = {};
            if (this.cycleId != null) {
                data.cycleId = this.cycleId;
            }
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.entry != null) {
                data.entry = this.entry.toObject();
            }
            if (this.source != null) {
                data.source = this.source;
            }
            if (this.eventId != null) {
                data.eventId = this.eventId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cycleId.length)
                writer.writeString(1, this.cycleId);
            if (this.subscriptionId.length)
                writer.writeString(2, this.subscriptionId);
            if (this.hasEntry)
                writer.writeMessage(3, this.entry, () => this.entry.serialize(writer));
            if (this.source.length)
                writer.writeString(4, this.source);
            if (this.eventId.length)
                writer.writeString(5, this.eventId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AppendCycleStepHistoryRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AppendCycleStepHistoryRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.cycleId = reader.readString();
                        break;
                    case 2:
                        message.subscriptionId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.entry, () => message.entry = CycleStepHistoryEntry.deserialize(reader));
                        break;
                    case 4:
                        message.source = reader.readString();
                        break;
                    case 5:
                        message.eventId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AppendCycleStepHistoryRequest {
            return AppendCycleStepHistoryRequest.deserialize(bytes);
        }
    }
    export class AppendCycleStepHistoryResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cycle?: Cycle;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cycle" in data && data.cycle != undefined) {
                    this.cycle = data.cycle;
                }
            }
        }
        get cycle() {
            return pb_1.Message.getWrapperField(this, Cycle, 1) as Cycle;
        }
        set cycle(value: Cycle) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasCycle() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            cycle?: ReturnType<typeof Cycle.prototype.toObject>;
        }): AppendCycleStepHistoryResponse {
            const message = new AppendCycleStepHistoryResponse({});
            if (data.cycle != null) {
                message.cycle = Cycle.fromObject(data.cycle);
            }
            return message;
        }
        toObject() {
            const data: {
                cycle?: ReturnType<typeof Cycle.prototype.toObject>;
            } = {};
            if (this.cycle != null) {
                data.cycle = this.cycle.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasCycle)
                writer.writeMessage(1, this.cycle, () => this.cycle.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AppendCycleStepHistoryResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AppendCycleStepHistoryResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.cycle, () => message.cycle = Cycle.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AppendCycleStepHistoryResponse {
            return AppendCycleStepHistoryResponse.deserialize(bytes);
        }
    }
    export class SubmitLeadInquiryRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            firstName?: string;
            lastName?: string;
            corporateEmail?: string;
            companyName?: string;
            companySize?: CompanySize;
            phoneNumber?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("firstName" in data && data.firstName != undefined) {
                    this.firstName = data.firstName;
                }
                if ("lastName" in data && data.lastName != undefined) {
                    this.lastName = data.lastName;
                }
                if ("corporateEmail" in data && data.corporateEmail != undefined) {
                    this.corporateEmail = data.corporateEmail;
                }
                if ("companyName" in data && data.companyName != undefined) {
                    this.companyName = data.companyName;
                }
                if ("companySize" in data && data.companySize != undefined) {
                    this.companySize = data.companySize;
                }
                if ("phoneNumber" in data && data.phoneNumber != undefined) {
                    this.phoneNumber = data.phoneNumber;
                }
            }
        }
        get firstName() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set firstName(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get lastName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set lastName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get corporateEmail() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set corporateEmail(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get companyName() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set companyName(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get companySize() {
            return pb_1.Message.getFieldWithDefault(this, 5, CompanySize.COMPANY_SIZE_UNSPECIFIED) as CompanySize;
        }
        set companySize(value: CompanySize) {
            pb_1.Message.setField(this, 5, value);
        }
        get phoneNumber() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set phoneNumber(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        static fromObject(data: {
            firstName?: string;
            lastName?: string;
            corporateEmail?: string;
            companyName?: string;
            companySize?: CompanySize;
            phoneNumber?: string;
        }): SubmitLeadInquiryRequest {
            const message = new SubmitLeadInquiryRequest({});
            if (data.firstName != null) {
                message.firstName = data.firstName;
            }
            if (data.lastName != null) {
                message.lastName = data.lastName;
            }
            if (data.corporateEmail != null) {
                message.corporateEmail = data.corporateEmail;
            }
            if (data.companyName != null) {
                message.companyName = data.companyName;
            }
            if (data.companySize != null) {
                message.companySize = data.companySize;
            }
            if (data.phoneNumber != null) {
                message.phoneNumber = data.phoneNumber;
            }
            return message;
        }
        toObject() {
            const data: {
                firstName?: string;
                lastName?: string;
                corporateEmail?: string;
                companyName?: string;
                companySize?: CompanySize;
                phoneNumber?: string;
            } = {};
            if (this.firstName != null) {
                data.firstName = this.firstName;
            }
            if (this.lastName != null) {
                data.lastName = this.lastName;
            }
            if (this.corporateEmail != null) {
                data.corporateEmail = this.corporateEmail;
            }
            if (this.companyName != null) {
                data.companyName = this.companyName;
            }
            if (this.companySize != null) {
                data.companySize = this.companySize;
            }
            if (this.phoneNumber != null) {
                data.phoneNumber = this.phoneNumber;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.firstName.length)
                writer.writeString(1, this.firstName);
            if (this.lastName.length)
                writer.writeString(2, this.lastName);
            if (this.corporateEmail.length)
                writer.writeString(3, this.corporateEmail);
            if (this.companyName.length)
                writer.writeString(4, this.companyName);
            if (this.companySize != CompanySize.COMPANY_SIZE_UNSPECIFIED)
                writer.writeEnum(5, this.companySize);
            if (this.phoneNumber.length)
                writer.writeString(6, this.phoneNumber);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitLeadInquiryRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubmitLeadInquiryRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.firstName = reader.readString();
                        break;
                    case 2:
                        message.lastName = reader.readString();
                        break;
                    case 3:
                        message.corporateEmail = reader.readString();
                        break;
                    case 4:
                        message.companyName = reader.readString();
                        break;
                    case 5:
                        message.companySize = reader.readEnum();
                        break;
                    case 6:
                        message.phoneNumber = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubmitLeadInquiryRequest {
            return SubmitLeadInquiryRequest.deserialize(bytes);
        }
    }
    export class SubmitLeadInquiryResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): SubmitLeadInquiryResponse {
            const message = new SubmitLeadInquiryResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitLeadInquiryResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubmitLeadInquiryResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubmitLeadInquiryResponse {
            return SubmitLeadInquiryResponse.deserialize(bytes);
        }
    }
    export class UpdateDefaultPaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            pix?: PaymentTypePIX;
            creditCard?: never;
        } | {
            pix?: never;
            creditCard?: PaymentTypeCreditCard;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("creditCard" in data && data.creditCard != undefined) {
                    this.creditCard = data.creditCard;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PaymentTypePIX, 1) as PaymentTypePIX;
        }
        set pix(value: PaymentTypePIX) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get creditCard() {
            return pb_1.Message.getWrapperField(this, PaymentTypeCreditCard, 2) as PaymentTypeCreditCard;
        }
        set creditCard(value: PaymentTypeCreditCard) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasCreditCard() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get payment_type() {
            const cases: {
                [index: number]: "none" | "pix" | "creditCard";
            } = {
                0: "none",
                1: "pix",
                2: "creditCard"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PaymentTypePIX.prototype.toObject>;
            creditCard?: ReturnType<typeof PaymentTypeCreditCard.prototype.toObject>;
        }): UpdateDefaultPaymentRequest {
            const message = new UpdateDefaultPaymentRequest({});
            if (data.pix != null) {
                message.pix = PaymentTypePIX.fromObject(data.pix);
            }
            if (data.creditCard != null) {
                message.creditCard = PaymentTypeCreditCard.fromObject(data.creditCard);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PaymentTypePIX.prototype.toObject>;
                creditCard?: ReturnType<typeof PaymentTypeCreditCard.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.creditCard != null) {
                data.creditCard = this.creditCard.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(1, this.pix, () => this.pix.serialize(writer));
            if (this.hasCreditCard)
                writer.writeMessage(2, this.creditCard, () => this.creditCard.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateDefaultPaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateDefaultPaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pix, () => message.pix = PaymentTypePIX.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.creditCard, () => message.creditCard = PaymentTypeCreditCard.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateDefaultPaymentRequest {
            return UpdateDefaultPaymentRequest.deserialize(bytes);
        }
    }
    export class PaymentTypePIX extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            enable?: boolean;
        }): PaymentTypePIX {
            const message = new PaymentTypePIX({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentTypePIX {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentTypePIX();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentTypePIX {
            return PaymentTypePIX.deserialize(bytes);
        }
    }
    export class PaymentTypeCreditCard extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            enable?: boolean;
            cardId?: string;
            installments?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("enable" in data && data.enable != undefined) {
                    this.enable = data.enable;
                }
                if ("cardId" in data && data.cardId != undefined) {
                    this.cardId = data.cardId;
                }
                if ("installments" in data && data.installments != undefined) {
                    this.installments = data.installments;
                }
            }
        }
        get enable() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set enable(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        get cardId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set cardId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get installments() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set installments(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            enable?: boolean;
            cardId?: string;
            installments?: number;
        }): PaymentTypeCreditCard {
            const message = new PaymentTypeCreditCard({});
            if (data.enable != null) {
                message.enable = data.enable;
            }
            if (data.cardId != null) {
                message.cardId = data.cardId;
            }
            if (data.installments != null) {
                message.installments = data.installments;
            }
            return message;
        }
        toObject() {
            const data: {
                enable?: boolean;
                cardId?: string;
                installments?: number;
            } = {};
            if (this.enable != null) {
                data.enable = this.enable;
            }
            if (this.cardId != null) {
                data.cardId = this.cardId;
            }
            if (this.installments != null) {
                data.installments = this.installments;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.enable != false)
                writer.writeBool(1, this.enable);
            if (this.cardId.length)
                writer.writeString(2, this.cardId);
            if (this.installments != 0)
                writer.writeInt32(3, this.installments);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PaymentTypeCreditCard {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PaymentTypeCreditCard();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.enable = reader.readBool();
                        break;
                    case 2:
                        message.cardId = reader.readString();
                        break;
                    case 3:
                        message.installments = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PaymentTypeCreditCard {
            return PaymentTypeCreditCard.deserialize(bytes);
        }
    }
    export class GetSubscriptionExportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetSubscriptionExportRequest {
            const message = new GetSubscriptionExportRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionExportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionExportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionExportRequest {
            return GetSubscriptionExportRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionExportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            status?: SubscriptionExportSource;
            url?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("url" in data && data.url != undefined) {
                    this.url = data.url;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, SubscriptionExportSource.SUBSCRIPTION_EXPORT_UNSPECIFIED) as SubscriptionExportSource;
        }
        set status(value: SubscriptionExportSource) {
            pb_1.Message.setField(this, 2, value);
        }
        get url() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set url(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            id?: string;
            status?: SubscriptionExportSource;
            url?: string;
        }): GetSubscriptionExportResponse {
            const message = new GetSubscriptionExportResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.url != null) {
                message.url = data.url;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                status?: SubscriptionExportSource;
                url?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.url != null) {
                data.url = this.url;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.status != SubscriptionExportSource.SUBSCRIPTION_EXPORT_UNSPECIFIED)
                writer.writeEnum(2, this.status);
            if (this.url.length)
                writer.writeString(3, this.url);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionExportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionExportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readEnum();
                        break;
                    case 3:
                        message.url = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionExportResponse {
            return GetSubscriptionExportResponse.deserialize(bytes);
        }
    }
    export class RequestSubscriptionExportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[5], [6]];
        constructor(data?: any[] | ({
            userName?: string;
            userEmail?: string;
            planId?: string[];
            status?: Status[];
        } & (({
            createdAfter?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            createdBefore?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3, 4], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userName" in data && data.userName != undefined) {
                    this.userName = data.userName;
                }
                if ("userEmail" in data && data.userEmail != undefined) {
                    this.userEmail = data.userEmail;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("createdAfter" in data && data.createdAfter != undefined) {
                    this.createdAfter = data.createdAfter;
                }
                if ("createdBefore" in data && data.createdBefore != undefined) {
                    this.createdBefore = data.createdBefore;
                }
            }
        }
        get userName() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userName(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userEmail() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userEmail(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 3, []) as string[];
        }
        set planId(value: string[]) {
            pb_1.Message.setField(this, 3, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as Status[];
        }
        set status(value: Status[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get createdAfter() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 5) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAfter(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
        }
        get hasCreatedAfter() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get createdBefore() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set createdBefore(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[1], value);
        }
        get hasCreatedBefore() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get _created_after() {
            const cases: {
                [index: number]: "none" | "createdAfter";
            } = {
                0: "none",
                5: "createdAfter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _created_before() {
            const cases: {
                [index: number]: "none" | "createdBefore";
            } = {
                0: "none",
                6: "createdBefore"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        static fromObject(data: {
            userName?: string;
            userEmail?: string;
            planId?: string[];
            status?: Status[];
            createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): RequestSubscriptionExportRequest {
            const message = new RequestSubscriptionExportRequest({});
            if (data.userName != null) {
                message.userName = data.userName;
            }
            if (data.userEmail != null) {
                message.userEmail = data.userEmail;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.createdAfter != null) {
                message.createdAfter = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAfter);
            }
            if (data.createdBefore != null) {
                message.createdBefore = dependency_2.google.protobuf.Timestamp.fromObject(data.createdBefore);
            }
            return message;
        }
        toObject() {
            const data: {
                userName?: string;
                userEmail?: string;
                planId?: string[];
                status?: Status[];
                createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.userName != null) {
                data.userName = this.userName;
            }
            if (this.userEmail != null) {
                data.userEmail = this.userEmail;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.createdAfter != null) {
                data.createdAfter = this.createdAfter.toObject();
            }
            if (this.createdBefore != null) {
                data.createdBefore = this.createdBefore.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userName.length)
                writer.writeString(1, this.userName);
            if (this.userEmail.length)
                writer.writeString(2, this.userEmail);
            if (this.planId.length)
                writer.writeRepeatedString(3, this.planId);
            if (this.status.length)
                writer.writePackedEnum(4, this.status);
            if (this.hasCreatedAfter)
                writer.writeMessage(5, this.createdAfter, () => this.createdAfter.serialize(writer));
            if (this.hasCreatedBefore)
                writer.writeMessage(6, this.createdBefore, () => this.createdBefore.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RequestSubscriptionExportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RequestSubscriptionExportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userName = reader.readString();
                        break;
                    case 2:
                        message.userEmail = reader.readString();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    case 4:
                        message.status = reader.readPackedEnum();
                        break;
                    case 5:
                        reader.readMessage(message.createdAfter, () => message.createdAfter = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.createdBefore, () => message.createdBefore = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RequestSubscriptionExportRequest {
            return RequestSubscriptionExportRequest.deserialize(bytes);
        }
    }
    export class RequestSubscriptionExportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            status?: SubscriptionExportSource;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, SubscriptionExportSource.SUBSCRIPTION_EXPORT_UNSPECIFIED) as SubscriptionExportSource;
        }
        set status(value: SubscriptionExportSource) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            id?: string;
            status?: SubscriptionExportSource;
        }): RequestSubscriptionExportResponse {
            const message = new RequestSubscriptionExportResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                status?: SubscriptionExportSource;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.status != SubscriptionExportSource.SUBSCRIPTION_EXPORT_UNSPECIFIED)
                writer.writeEnum(2, this.status);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RequestSubscriptionExportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RequestSubscriptionExportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RequestSubscriptionExportResponse {
            return RequestSubscriptionExportResponse.deserialize(bytes);
        }
    }
    export class UpdateDefaultPaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): UpdateDefaultPaymentResponse {
            const message = new UpdateDefaultPaymentResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateDefaultPaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateDefaultPaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateDefaultPaymentResponse {
            return UpdateDefaultPaymentResponse.deserialize(bytes);
        }
    }
    export class GetDefaultPaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetDefaultPaymentRequest {
            const message = new GetDefaultPaymentRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetDefaultPaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetDefaultPaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetDefaultPaymentRequest {
            return GetDefaultPaymentRequest.deserialize(bytes);
        }
    }
    export class GetDefaultPaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[1, 2]];
        constructor(data?: any[] | ({} & (({
            pix?: PaymentTypePIX;
            creditCard?: never;
        } | {
            pix?: never;
            creditCard?: PaymentTypeCreditCard;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("pix" in data && data.pix != undefined) {
                    this.pix = data.pix;
                }
                if ("creditCard" in data && data.creditCard != undefined) {
                    this.creditCard = data.creditCard;
                }
            }
        }
        get pix() {
            return pb_1.Message.getWrapperField(this, PaymentTypePIX, 1) as PaymentTypePIX;
        }
        set pix(value: PaymentTypePIX) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasPix() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get creditCard() {
            return pb_1.Message.getWrapperField(this, PaymentTypeCreditCard, 2) as PaymentTypeCreditCard;
        }
        set creditCard(value: PaymentTypeCreditCard) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasCreditCard() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get payment_type() {
            const cases: {
                [index: number]: "none" | "pix" | "creditCard";
            } = {
                0: "none",
                1: "pix",
                2: "creditCard"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1, 2])];
        }
        static fromObject(data: {
            pix?: ReturnType<typeof PaymentTypePIX.prototype.toObject>;
            creditCard?: ReturnType<typeof PaymentTypeCreditCard.prototype.toObject>;
        }): GetDefaultPaymentResponse {
            const message = new GetDefaultPaymentResponse({});
            if (data.pix != null) {
                message.pix = PaymentTypePIX.fromObject(data.pix);
            }
            if (data.creditCard != null) {
                message.creditCard = PaymentTypeCreditCard.fromObject(data.creditCard);
            }
            return message;
        }
        toObject() {
            const data: {
                pix?: ReturnType<typeof PaymentTypePIX.prototype.toObject>;
                creditCard?: ReturnType<typeof PaymentTypeCreditCard.prototype.toObject>;
            } = {};
            if (this.pix != null) {
                data.pix = this.pix.toObject();
            }
            if (this.creditCard != null) {
                data.creditCard = this.creditCard.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPix)
                writer.writeMessage(1, this.pix, () => this.pix.serialize(writer));
            if (this.hasCreditCard)
                writer.writeMessage(2, this.creditCard, () => this.creditCard.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetDefaultPaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetDefaultPaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.pix, () => message.pix = PaymentTypePIX.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.creditCard, () => message.creditCard = PaymentTypeCreditCard.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetDefaultPaymentResponse {
            return GetDefaultPaymentResponse.deserialize(bytes);
        }
    }
    export class UpgradePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planId?: string;
            metadata?: Map<string, string>;
            customer?: dependency_4.checkout.v1.CustomerInfo;
            paymentType?: dependency_3.payments.v1.PaymentType;
            amount?: number;
            campaignDiscount?: CampaignDiscount;
            campaignOffer?: CampaignOffer;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("campaignDiscount" in data && data.campaignDiscount != undefined) {
                    this.campaignDiscount = data.campaignDiscount;
                }
                if ("campaignOffer" in data && data.campaignOffer != undefined) {
                    this.campaignOffer = data.campaignOffer;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 2) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 2, value as any);
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, dependency_4.checkout.v1.CustomerInfo, 3) as dependency_4.checkout.v1.CustomerInfo;
        }
        set customer(value: dependency_4.checkout.v1.CustomerInfo) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentType, 4) as dependency_3.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_3.payments.v1.PaymentType) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get campaignDiscount() {
            return pb_1.Message.getWrapperField(this, CampaignDiscount, 6) as CampaignDiscount;
        }
        set campaignDiscount(value: CampaignDiscount) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasCampaignDiscount() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get campaignOffer() {
            return pb_1.Message.getWrapperField(this, CampaignOffer, 7) as CampaignOffer;
        }
        set campaignOffer(value: CampaignOffer) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasCampaignOffer() {
            return pb_1.Message.getField(this, 7) != null;
        }
        static fromObject(data: {
            planId?: string;
            metadata?: {
                [key: string]: string;
            };
            customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
            paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
            amount?: number;
            campaignDiscount?: ReturnType<typeof CampaignDiscount.prototype.toObject>;
            campaignOffer?: ReturnType<typeof CampaignOffer.prototype.toObject>;
        }): UpgradePlanRequest {
            const message = new UpgradePlanRequest({});
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.customer != null) {
                message.customer = dependency_4.checkout.v1.CustomerInfo.fromObject(data.customer);
            }
            if (data.paymentType != null) {
                message.paymentType = dependency_3.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.campaignDiscount != null) {
                message.campaignDiscount = CampaignDiscount.fromObject(data.campaignDiscount);
            }
            if (data.campaignOffer != null) {
                message.campaignOffer = CampaignOffer.fromObject(data.campaignOffer);
            }
            return message;
        }
        toObject() {
            const data: {
                planId?: string;
                metadata?: {
                    [key: string]: string;
                };
                customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
                paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
                amount?: number;
                campaignDiscount?: ReturnType<typeof CampaignDiscount.prototype.toObject>;
                campaignOffer?: ReturnType<typeof CampaignOffer.prototype.toObject>;
            } = {};
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.campaignDiscount != null) {
                data.campaignDiscount = this.campaignDiscount.toObject();
            }
            if (this.campaignOffer != null) {
                data.campaignOffer = this.campaignOffer.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planId.length)
                writer.writeString(1, this.planId);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(2, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCustomer)
                writer.writeMessage(3, this.customer, () => this.customer.serialize(writer));
            if (this.hasPaymentType)
                writer.writeMessage(4, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.amount != 0)
                writer.writeInt64(5, this.amount);
            if (this.hasCampaignDiscount)
                writer.writeMessage(6, this.campaignDiscount, () => this.campaignDiscount.serialize(writer));
            if (this.hasCampaignOffer)
                writer.writeMessage(7, this.campaignOffer, () => this.campaignOffer.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpgradePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpgradePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 3:
                        reader.readMessage(message.customer, () => message.customer = dependency_4.checkout.v1.CustomerInfo.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_3.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 5:
                        message.amount = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.campaignDiscount, () => message.campaignDiscount = CampaignDiscount.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.campaignOffer, () => message.campaignOffer = CampaignOffer.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpgradePlanRequest {
            return UpgradePlanRequest.deserialize(bytes);
        }
    }
    export class CampaignOffer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            percent?: number;
            maxAmountCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("percent" in data && data.percent != undefined) {
                    this.percent = data.percent;
                }
                if ("maxAmountCents" in data && data.maxAmountCents != undefined) {
                    this.maxAmountCents = data.maxAmountCents;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get percent() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set percent(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get maxAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set maxAmountCents(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            campaignId?: string;
            percent?: number;
            maxAmountCents?: number;
        }): CampaignOffer {
            const message = new CampaignOffer({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.percent != null) {
                message.percent = data.percent;
            }
            if (data.maxAmountCents != null) {
                message.maxAmountCents = data.maxAmountCents;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                percent?: number;
                maxAmountCents?: number;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.percent != null) {
                data.percent = this.percent;
            }
            if (this.maxAmountCents != null) {
                data.maxAmountCents = this.maxAmountCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.percent != 0)
                writer.writeInt32(2, this.percent);
            if (this.maxAmountCents != 0)
                writer.writeInt64(3, this.maxAmountCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CampaignOffer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CampaignOffer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.percent = reader.readInt32();
                        break;
                    case 3:
                        message.maxAmountCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CampaignOffer {
            return CampaignOffer.deserialize(bytes);
        }
    }
    export class CampaignDiscount extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            percent?: number;
            maxAmountCents?: number;
            validUntil?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("percent" in data && data.percent != undefined) {
                    this.percent = data.percent;
                }
                if ("maxAmountCents" in data && data.maxAmountCents != undefined) {
                    this.maxAmountCents = data.maxAmountCents;
                }
                if ("validUntil" in data && data.validUntil != undefined) {
                    this.validUntil = data.validUntil;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get percent() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set percent(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get maxAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set maxAmountCents(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get validUntil() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set validUntil(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasValidUntil() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            campaignId?: string;
            percent?: number;
            maxAmountCents?: number;
            validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): CampaignDiscount {
            const message = new CampaignDiscount({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.percent != null) {
                message.percent = data.percent;
            }
            if (data.maxAmountCents != null) {
                message.maxAmountCents = data.maxAmountCents;
            }
            if (data.validUntil != null) {
                message.validUntil = dependency_2.google.protobuf.Timestamp.fromObject(data.validUntil);
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                percent?: number;
                maxAmountCents?: number;
                validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.percent != null) {
                data.percent = this.percent;
            }
            if (this.maxAmountCents != null) {
                data.maxAmountCents = this.maxAmountCents;
            }
            if (this.validUntil != null) {
                data.validUntil = this.validUntil.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.percent != 0)
                writer.writeInt32(2, this.percent);
            if (this.maxAmountCents != 0)
                writer.writeInt64(3, this.maxAmountCents);
            if (this.hasValidUntil)
                writer.writeMessage(4, this.validUntil, () => this.validUntil.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CampaignDiscount {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CampaignDiscount();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.percent = reader.readInt32();
                        break;
                    case 3:
                        message.maxAmountCents = reader.readInt64();
                        break;
                    case 4:
                        reader.readMessage(message.validUntil, () => message.validUntil = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CampaignDiscount {
            return CampaignDiscount.deserialize(bytes);
        }
    }
    export class UpgradePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            errorUpgradePlan?: ErrorUpgradePlan;
            errorDetails?: string;
            paymentInfo?: dependency_3.payments.v1.PaymentDetails;
            expiresAt?: dependency_2.google.protobuf.Timestamp;
            amount?: number;
            creditsEndsAt?: dependency_2.google.protobuf.Timestamp;
            creditsEndsInDays?: number;
            settled?: boolean;
            discountDeferred?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("errorUpgradePlan" in data && data.errorUpgradePlan != undefined) {
                    this.errorUpgradePlan = data.errorUpgradePlan;
                }
                if ("errorDetails" in data && data.errorDetails != undefined) {
                    this.errorDetails = data.errorDetails;
                }
                if ("paymentInfo" in data && data.paymentInfo != undefined) {
                    this.paymentInfo = data.paymentInfo;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("creditsEndsAt" in data && data.creditsEndsAt != undefined) {
                    this.creditsEndsAt = data.creditsEndsAt;
                }
                if ("creditsEndsInDays" in data && data.creditsEndsInDays != undefined) {
                    this.creditsEndsInDays = data.creditsEndsInDays;
                }
                if ("settled" in data && data.settled != undefined) {
                    this.settled = data.settled;
                }
                if ("discountDeferred" in data && data.discountDeferred != undefined) {
                    this.discountDeferred = data.discountDeferred;
                }
            }
        }
        get errorUpgradePlan() {
            return pb_1.Message.getFieldWithDefault(this, 1, ErrorUpgradePlan.ERROR_UPGRADE_PLAN_UNSPECIFIED) as ErrorUpgradePlan;
        }
        set errorUpgradePlan(value: ErrorUpgradePlan) {
            pb_1.Message.setField(this, 1, value);
        }
        get errorDetails() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set errorDetails(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get paymentInfo() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentDetails, 3) as dependency_3.payments.v1.PaymentDetails;
        }
        set paymentInfo(value: dependency_3.payments.v1.PaymentDetails) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPaymentInfo() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get creditsEndsAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set creditsEndsAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasCreditsEndsAt() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get creditsEndsInDays() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set creditsEndsInDays(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get settled() {
            return pb_1.Message.getFieldWithDefault(this, 8, false) as boolean;
        }
        set settled(value: boolean) {
            pb_1.Message.setField(this, 8, value);
        }
        get discountDeferred() {
            return pb_1.Message.getFieldWithDefault(this, 9, false) as boolean;
        }
        set discountDeferred(value: boolean) {
            pb_1.Message.setField(this, 9, value);
        }
        static fromObject(data: {
            errorUpgradePlan?: ErrorUpgradePlan;
            errorDetails?: string;
            paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
            expiresAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            amount?: number;
            creditsEndsAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            creditsEndsInDays?: number;
            settled?: boolean;
            discountDeferred?: boolean;
        }): UpgradePlanResponse {
            const message = new UpgradePlanResponse({});
            if (data.errorUpgradePlan != null) {
                message.errorUpgradePlan = data.errorUpgradePlan;
            }
            if (data.errorDetails != null) {
                message.errorDetails = data.errorDetails;
            }
            if (data.paymentInfo != null) {
                message.paymentInfo = dependency_3.payments.v1.PaymentDetails.fromObject(data.paymentInfo);
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_2.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.creditsEndsAt != null) {
                message.creditsEndsAt = dependency_2.google.protobuf.Timestamp.fromObject(data.creditsEndsAt);
            }
            if (data.creditsEndsInDays != null) {
                message.creditsEndsInDays = data.creditsEndsInDays;
            }
            if (data.settled != null) {
                message.settled = data.settled;
            }
            if (data.discountDeferred != null) {
                message.discountDeferred = data.discountDeferred;
            }
            return message;
        }
        toObject() {
            const data: {
                errorUpgradePlan?: ErrorUpgradePlan;
                errorDetails?: string;
                paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
                expiresAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                amount?: number;
                creditsEndsAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                creditsEndsInDays?: number;
                settled?: boolean;
                discountDeferred?: boolean;
            } = {};
            if (this.errorUpgradePlan != null) {
                data.errorUpgradePlan = this.errorUpgradePlan;
            }
            if (this.errorDetails != null) {
                data.errorDetails = this.errorDetails;
            }
            if (this.paymentInfo != null) {
                data.paymentInfo = this.paymentInfo.toObject();
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.creditsEndsAt != null) {
                data.creditsEndsAt = this.creditsEndsAt.toObject();
            }
            if (this.creditsEndsInDays != null) {
                data.creditsEndsInDays = this.creditsEndsInDays;
            }
            if (this.settled != null) {
                data.settled = this.settled;
            }
            if (this.discountDeferred != null) {
                data.discountDeferred = this.discountDeferred;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.errorUpgradePlan != ErrorUpgradePlan.ERROR_UPGRADE_PLAN_UNSPECIFIED)
                writer.writeEnum(1, this.errorUpgradePlan);
            if (this.errorDetails.length)
                writer.writeString(2, this.errorDetails);
            if (this.hasPaymentInfo)
                writer.writeMessage(3, this.paymentInfo, () => this.paymentInfo.serialize(writer));
            if (this.hasExpiresAt)
                writer.writeMessage(4, this.expiresAt, () => this.expiresAt.serialize(writer));
            if (this.amount != 0)
                writer.writeInt64(5, this.amount);
            if (this.hasCreditsEndsAt)
                writer.writeMessage(6, this.creditsEndsAt, () => this.creditsEndsAt.serialize(writer));
            if (this.creditsEndsInDays != 0)
                writer.writeInt64(7, this.creditsEndsInDays);
            if (this.settled != false)
                writer.writeBool(8, this.settled);
            if (this.discountDeferred != false)
                writer.writeBool(9, this.discountDeferred);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpgradePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpgradePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.errorUpgradePlan = reader.readEnum();
                        break;
                    case 2:
                        message.errorDetails = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.paymentInfo, () => message.paymentInfo = dependency_3.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        message.amount = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.creditsEndsAt, () => message.creditsEndsAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.creditsEndsInDays = reader.readInt64();
                        break;
                    case 8:
                        message.settled = reader.readBool();
                        break;
                    case 9:
                        message.discountDeferred = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpgradePlanResponse {
            return UpgradePlanResponse.deserialize(bytes);
        }
    }
    export class DowngradePlanRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
            }
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            planId?: string;
        }): DowngradePlanRequest {
            const message = new DowngradePlanRequest({});
            if (data.planId != null) {
                message.planId = data.planId;
            }
            return message;
        }
        toObject() {
            const data: {
                planId?: string;
            } = {};
            if (this.planId != null) {
                data.planId = this.planId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planId.length)
                writer.writeString(1, this.planId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DowngradePlanRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DowngradePlanRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DowngradePlanRequest {
            return DowngradePlanRequest.deserialize(bytes);
        }
    }
    export class DowngradePlanResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DowngradePlanResponse {
            const message = new DowngradePlanResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DowngradePlanResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DowngradePlanResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DowngradePlanResponse {
            return DowngradePlanResponse.deserialize(bytes);
        }
    }
    export class DeactivateSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            reason?: string;
            subjectId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("reason" in data && data.reason != undefined) {
                    this.reason = data.reason;
                }
                if ("subjectId" in data && data.subjectId != undefined) {
                    this.subjectId = data.subjectId;
                }
            }
        }
        get reason() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set reason(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subjectId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set subjectId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            reason?: string;
            subjectId?: string;
        }): DeactivateSubscriptionRequest {
            const message = new DeactivateSubscriptionRequest({});
            if (data.reason != null) {
                message.reason = data.reason;
            }
            if (data.subjectId != null) {
                message.subjectId = data.subjectId;
            }
            return message;
        }
        toObject() {
            const data: {
                reason?: string;
                subjectId?: string;
            } = {};
            if (this.reason != null) {
                data.reason = this.reason;
            }
            if (this.subjectId != null) {
                data.subjectId = this.subjectId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.reason.length)
                writer.writeString(1, this.reason);
            if (this.subjectId.length)
                writer.writeString(2, this.subjectId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeactivateSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeactivateSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.reason = reader.readString();
                        break;
                    case 2:
                        message.subjectId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeactivateSubscriptionRequest {
            return DeactivateSubscriptionRequest.deserialize(bytes);
        }
    }
    export class DeactivateSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeactivateSubscriptionResponse {
            const message = new DeactivateSubscriptionResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeactivateSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeactivateSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeactivateSubscriptionResponse {
            return DeactivateSubscriptionResponse.deserialize(bytes);
        }
    }
    export class UpdateSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            paymentType?: dependency_3.payments.v1.PaymentType;
            customer?: dependency_4.checkout.v1.CustomerInfo;
            metadata?: Map<string, string>;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentType, 1) as dependency_3.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_3.payments.v1.PaymentType) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, dependency_4.checkout.v1.CustomerInfo, 2) as dependency_4.checkout.v1.CustomerInfo;
        }
        set customer(value: dependency_4.checkout.v1.CustomerInfo) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 3) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        static fromObject(data: {
            paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
            customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
        }): UpdateSubscriptionRequest {
            const message = new UpdateSubscriptionRequest({});
            if (data.paymentType != null) {
                message.paymentType = dependency_3.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (data.customer != null) {
                message.customer = dependency_4.checkout.v1.CustomerInfo.fromObject(data.customer);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            return message;
        }
        toObject() {
            const data: {
                paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
                customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
            } = {};
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasPaymentType)
                writer.writeMessage(1, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.hasCustomer)
                writer.writeMessage(2, this.customer, () => this.customer.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(3, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_3.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.customer, () => message.customer = dependency_4.checkout.v1.CustomerInfo.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateSubscriptionRequest {
            return UpdateSubscriptionRequest.deserialize(bytes);
        }
    }
    export class UpdateSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
        }): UpdateSubscriptionResponse {
            const message = new UpdateSubscriptionResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UpdateSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UpdateSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UpdateSubscriptionResponse {
            return UpdateSubscriptionResponse.deserialize(bytes);
        }
    }
    export class MergeSubscriptionMetadataRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
            metadata?: Map<string, string>;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 2) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 2, value as any);
        }
        static fromObject(data: {
            subscriptionId?: string;
            metadata?: {
                [key: string]: string;
            };
        }): MergeSubscriptionMetadataRequest {
            const message = new MergeSubscriptionMetadataRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                metadata?: {
                    [key: string]: string;
                };
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(2, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MergeSubscriptionMetadataRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MergeSubscriptionMetadataRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MergeSubscriptionMetadataRequest {
            return MergeSubscriptionMetadataRequest.deserialize(bytes);
        }
    }
    export class MergeSubscriptionMetadataResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
        }): MergeSubscriptionMetadataResponse {
            const message = new MergeSubscriptionMetadataResponse({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MergeSubscriptionMetadataResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MergeSubscriptionMetadataResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MergeSubscriptionMetadataResponse {
            return MergeSubscriptionMetadataResponse.deserialize(bytes);
        }
    }
    export class GetSubscriptionInvitationRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            invitationId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("invitationId" in data && data.invitationId != undefined) {
                    this.invitationId = data.invitationId;
                }
            }
        }
        get invitationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set invitationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            invitationId?: string;
        }): GetSubscriptionInvitationRequest {
            const message = new GetSubscriptionInvitationRequest({});
            if (data.invitationId != null) {
                message.invitationId = data.invitationId;
            }
            return message;
        }
        toObject() {
            const data: {
                invitationId?: string;
            } = {};
            if (this.invitationId != null) {
                data.invitationId = this.invitationId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.invitationId.length)
                writer.writeString(1, this.invitationId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionInvitationRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionInvitationRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.invitationId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionInvitationRequest {
            return GetSubscriptionInvitationRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionInvitationResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            invitation?: dependency_5.subscriptions.v1.SubscriptionInvitation;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("invitation" in data && data.invitation != undefined) {
                    this.invitation = data.invitation;
                }
            }
        }
        get invitation() {
            return pb_1.Message.getWrapperField(this, dependency_5.subscriptions.v1.SubscriptionInvitation, 1) as dependency_5.subscriptions.v1.SubscriptionInvitation;
        }
        set invitation(value: dependency_5.subscriptions.v1.SubscriptionInvitation) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasInvitation() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            invitation?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionInvitation.prototype.toObject>;
        }): GetSubscriptionInvitationResponse {
            const message = new GetSubscriptionInvitationResponse({});
            if (data.invitation != null) {
                message.invitation = dependency_5.subscriptions.v1.SubscriptionInvitation.fromObject(data.invitation);
            }
            return message;
        }
        toObject() {
            const data: {
                invitation?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionInvitation.prototype.toObject>;
            } = {};
            if (this.invitation != null) {
                data.invitation = this.invitation.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasInvitation)
                writer.writeMessage(1, this.invitation, () => this.invitation.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionInvitationResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionInvitationResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.invitation, () => message.invitation = dependency_5.subscriptions.v1.SubscriptionInvitation.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionInvitationResponse {
            return GetSubscriptionInvitationResponse.deserialize(bytes);
        }
    }
    export class CancelSubscriptionInvitationRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            invitationId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("invitationId" in data && data.invitationId != undefined) {
                    this.invitationId = data.invitationId;
                }
            }
        }
        get invitationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set invitationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            invitationId?: string;
        }): CancelSubscriptionInvitationRequest {
            const message = new CancelSubscriptionInvitationRequest({});
            if (data.invitationId != null) {
                message.invitationId = data.invitationId;
            }
            return message;
        }
        toObject() {
            const data: {
                invitationId?: string;
            } = {};
            if (this.invitationId != null) {
                data.invitationId = this.invitationId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.invitationId.length)
                writer.writeString(1, this.invitationId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelSubscriptionInvitationRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelSubscriptionInvitationRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.invitationId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CancelSubscriptionInvitationRequest {
            return CancelSubscriptionInvitationRequest.deserialize(bytes);
        }
    }
    export class CancelSubscriptionInvitationResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): CancelSubscriptionInvitationResponse {
            const message = new CancelSubscriptionInvitationResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelSubscriptionInvitationResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelSubscriptionInvitationResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CancelSubscriptionInvitationResponse {
            return CancelSubscriptionInvitationResponse.deserialize(bytes);
        }
    }
    export class CreateSubscriptionAdminRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[3], [4], [5]];
        constructor(data?: any[] | ({
            email?: string;
            planId?: string;
            source?: SubscriptionSource;
            startDate?: string;
            document?: string;
        } & (({
            bankSlip?: BankSlipPaymentData;
        }) | ({
            courtesy?: CourtesyData;
        }) | ({
            commitmentNumber?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("bankSlip" in data && data.bankSlip != undefined) {
                    this.bankSlip = data.bankSlip;
                }
                if ("courtesy" in data && data.courtesy != undefined) {
                    this.courtesy = data.courtesy;
                }
                if ("commitmentNumber" in data && data.commitmentNumber != undefined) {
                    this.commitmentNumber = data.commitmentNumber;
                }
                if ("source" in data && data.source != undefined) {
                    this.source = data.source;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("document" in data && data.document != undefined) {
                    this.document = data.document;
                }
            }
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get bankSlip() {
            return pb_1.Message.getWrapperField(this, BankSlipPaymentData, 3) as BankSlipPaymentData;
        }
        set bankSlip(value: BankSlipPaymentData) {
            pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
        }
        get hasBankSlip() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get courtesy() {
            return pb_1.Message.getWrapperField(this, CourtesyData, 4) as CourtesyData;
        }
        set courtesy(value: CourtesyData) {
            pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[1], value);
        }
        get hasCourtesy() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get commitmentNumber() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set commitmentNumber(value: string) {
            pb_1.Message.setOneofField(this, 5, this.#one_of_decls[2], value);
        }
        get hasCommitmentNumber() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get source() {
            return pb_1.Message.getFieldWithDefault(this, 6, SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED) as SubscriptionSource;
        }
        set source(value: SubscriptionSource) {
            pb_1.Message.setField(this, 6, value);
        }
        get startDate() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set startDate(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get document() {
            return pb_1.Message.getFieldWithDefault(this, 8, "") as string;
        }
        set document(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        get _bank_slip() {
            const cases: {
                [index: number]: "none" | "bankSlip";
            } = {
                0: "none",
                3: "bankSlip"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _courtesy() {
            const cases: {
                [index: number]: "none" | "courtesy";
            } = {
                0: "none",
                4: "courtesy"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _commitment_number() {
            const cases: {
                [index: number]: "none" | "commitmentNumber";
            } = {
                0: "none",
                5: "commitmentNumber"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        static fromObject(data: {
            email?: string;
            planId?: string;
            bankSlip?: ReturnType<typeof BankSlipPaymentData.prototype.toObject>;
            courtesy?: ReturnType<typeof CourtesyData.prototype.toObject>;
            commitmentNumber?: string;
            source?: SubscriptionSource;
            startDate?: string;
            document?: string;
        }): CreateSubscriptionAdminRequest {
            const message = new CreateSubscriptionAdminRequest({});
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.bankSlip != null) {
                message.bankSlip = BankSlipPaymentData.fromObject(data.bankSlip);
            }
            if (data.courtesy != null) {
                message.courtesy = CourtesyData.fromObject(data.courtesy);
            }
            if (data.commitmentNumber != null) {
                message.commitmentNumber = data.commitmentNumber;
            }
            if (data.source != null) {
                message.source = data.source;
            }
            if (data.startDate != null) {
                message.startDate = data.startDate;
            }
            if (data.document != null) {
                message.document = data.document;
            }
            return message;
        }
        toObject() {
            const data: {
                email?: string;
                planId?: string;
                bankSlip?: ReturnType<typeof BankSlipPaymentData.prototype.toObject>;
                courtesy?: ReturnType<typeof CourtesyData.prototype.toObject>;
                commitmentNumber?: string;
                source?: SubscriptionSource;
                startDate?: string;
                document?: string;
            } = {};
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.bankSlip != null) {
                data.bankSlip = this.bankSlip.toObject();
            }
            if (this.courtesy != null) {
                data.courtesy = this.courtesy.toObject();
            }
            if (this.commitmentNumber != null) {
                data.commitmentNumber = this.commitmentNumber;
            }
            if (this.source != null) {
                data.source = this.source;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate;
            }
            if (this.document != null) {
                data.document = this.document;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.email.length)
                writer.writeString(1, this.email);
            if (this.planId.length)
                writer.writeString(2, this.planId);
            if (this.hasBankSlip)
                writer.writeMessage(3, this.bankSlip, () => this.bankSlip.serialize(writer));
            if (this.hasCourtesy)
                writer.writeMessage(4, this.courtesy, () => this.courtesy.serialize(writer));
            if (this.hasCommitmentNumber)
                writer.writeString(5, this.commitmentNumber);
            if (this.source != SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED)
                writer.writeEnum(6, this.source);
            if (this.startDate.length)
                writer.writeString(7, this.startDate);
            if (this.document.length)
                writer.writeString(8, this.document);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionAdminRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionAdminRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.email = reader.readString();
                        break;
                    case 2:
                        message.planId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.bankSlip, () => message.bankSlip = BankSlipPaymentData.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.courtesy, () => message.courtesy = CourtesyData.deserialize(reader));
                        break;
                    case 5:
                        message.commitmentNumber = reader.readString();
                        break;
                    case 6:
                        message.source = reader.readEnum();
                        break;
                    case 7:
                        message.startDate = reader.readString();
                        break;
                    case 8:
                        message.document = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionAdminRequest {
            return CreateSubscriptionAdminRequest.deserialize(bytes);
        }
    }
    export class CreateSubscriptionFreeAdminRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            email?: string;
            name?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            userId?: string;
            email?: string;
            name?: string;
        }): CreateSubscriptionFreeAdminRequest {
            const message = new CreateSubscriptionFreeAdminRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                email?: string;
                name?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.email.length)
                writer.writeString(2, this.email);
            if (this.name.length)
                writer.writeString(3, this.name);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionFreeAdminRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionFreeAdminRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.email = reader.readString();
                        break;
                    case 3:
                        message.name = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionFreeAdminRequest {
            return CreateSubscriptionFreeAdminRequest.deserialize(bytes);
        }
    }
    export class CreateSubscriptionFreeAdminResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): CreateSubscriptionFreeAdminResponse {
            const message = new CreateSubscriptionFreeAdminResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionFreeAdminResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionFreeAdminResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionFreeAdminResponse {
            return CreateSubscriptionFreeAdminResponse.deserialize(bytes);
        }
    }
    export class BankSlipPaymentData extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            invoiceNumber?: string;
            dueDate?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("invoiceNumber" in data && data.invoiceNumber != undefined) {
                    this.invoiceNumber = data.invoiceNumber;
                }
                if ("dueDate" in data && data.dueDate != undefined) {
                    this.dueDate = data.dueDate;
                }
            }
        }
        get invoiceNumber() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set invoiceNumber(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get dueDate() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set dueDate(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            invoiceNumber?: string;
            dueDate?: string;
        }): BankSlipPaymentData {
            const message = new BankSlipPaymentData({});
            if (data.invoiceNumber != null) {
                message.invoiceNumber = data.invoiceNumber;
            }
            if (data.dueDate != null) {
                message.dueDate = data.dueDate;
            }
            return message;
        }
        toObject() {
            const data: {
                invoiceNumber?: string;
                dueDate?: string;
            } = {};
            if (this.invoiceNumber != null) {
                data.invoiceNumber = this.invoiceNumber;
            }
            if (this.dueDate != null) {
                data.dueDate = this.dueDate;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.invoiceNumber.length)
                writer.writeString(1, this.invoiceNumber);
            if (this.dueDate.length)
                writer.writeString(2, this.dueDate);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): BankSlipPaymentData {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new BankSlipPaymentData();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.invoiceNumber = reader.readString();
                        break;
                    case 2:
                        message.dueDate = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): BankSlipPaymentData {
            return BankSlipPaymentData.deserialize(bytes);
        }
    }
    export class CourtesyData extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            reason?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("reason" in data && data.reason != undefined) {
                    this.reason = data.reason;
                }
            }
        }
        get reason() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set reason(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            reason?: string;
        }): CourtesyData {
            const message = new CourtesyData({});
            if (data.reason != null) {
                message.reason = data.reason;
            }
            return message;
        }
        toObject() {
            const data: {
                reason?: string;
            } = {};
            if (this.reason != null) {
                data.reason = this.reason;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.reason.length)
                writer.writeString(1, this.reason);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CourtesyData {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CourtesyData();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.reason = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CourtesyData {
            return CourtesyData.deserialize(bytes);
        }
    }
    export class CreateSubscriptionAdminResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
        }): CreateSubscriptionAdminResponse {
            const message = new CreateSubscriptionAdminResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionAdminResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionAdminResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionAdminResponse {
            return CreateSubscriptionAdminResponse.deserialize(bytes);
        }
    }
    export class Event extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            type?: string;
            raw?: Map<string, string>;
            createdAt?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
                if ("raw" in data && data.raw != undefined) {
                    this.raw = data.raw;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
            }
            if (!this.raw)
                this.raw = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set type(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get raw() {
            return pb_1.Message.getField(this, 3) as any as Map<string, string>;
        }
        set raw(value: Map<string, string>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            id?: string;
            type?: string;
            raw?: {
                [key: string]: string;
            };
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): Event {
            const message = new Event({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.type != null) {
                message.type = data.type;
            }
            if (typeof data.raw == "object") {
                message.raw = new Map(Object.entries(data.raw));
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                type?: string;
                raw?: {
                    [key: string]: string;
                };
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.type != null) {
                data.type = this.type;
            }
            if (this.raw != null) {
                data.raw = (Object.fromEntries)(this.raw);
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.type.length)
                writer.writeString(2, this.type);
            for (const [key, value] of this.raw) {
                writer.writeMessage(3, this.raw, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCreatedAt)
                writer.writeMessage(4, this.createdAt, () => this.createdAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Event {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Event();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.type = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.raw as any, reader, reader.readString, reader.readString));
                        break;
                    case 4:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Event {
            return Event.deserialize(bytes);
        }
    }
    export class Plan extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            description?: string;
            resources?: string[];
            mainAction?: boolean;
            maxUsers?: number;
            price?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
                if ("mainAction" in data && data.mainAction != undefined) {
                    this.mainAction = data.mainAction;
                }
                if ("maxUsers" in data && data.maxUsers != undefined) {
                    this.maxUsers = data.maxUsers;
                }
                if ("price" in data && data.price != undefined) {
                    this.price = data.price;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get resources() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as string[];
        }
        set resources(value: string[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get mainAction() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set mainAction(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get maxUsers() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set maxUsers(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get price() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set price(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            description?: string;
            resources?: string[];
            mainAction?: boolean;
            maxUsers?: number;
            price?: number;
        }): Plan {
            const message = new Plan({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.resources != null) {
                message.resources = data.resources;
            }
            if (data.mainAction != null) {
                message.mainAction = data.mainAction;
            }
            if (data.maxUsers != null) {
                message.maxUsers = data.maxUsers;
            }
            if (data.price != null) {
                message.price = data.price;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                description?: string;
                resources?: string[];
                mainAction?: boolean;
                maxUsers?: number;
                price?: number;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.resources != null) {
                data.resources = this.resources;
            }
            if (this.mainAction != null) {
                data.mainAction = this.mainAction;
            }
            if (this.maxUsers != null) {
                data.maxUsers = this.maxUsers;
            }
            if (this.price != null) {
                data.price = this.price;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.description.length)
                writer.writeString(3, this.description);
            if (this.resources.length)
                writer.writeRepeatedString(4, this.resources);
            if (this.mainAction != false)
                writer.writeBool(5, this.mainAction);
            if (this.maxUsers != 0)
                writer.writeInt32(6, this.maxUsers);
            if (this.price != 0)
                writer.writeInt64(7, this.price);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Plan {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Plan();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.description = reader.readString();
                        break;
                    case 4:
                        pb_1.Message.addToRepeatedField(message, 4, reader.readString());
                        break;
                    case 5:
                        message.mainAction = reader.readBool();
                        break;
                    case 6:
                        message.maxUsers = reader.readInt32();
                        break;
                    case 7:
                        message.price = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Plan {
            return Plan.deserialize(bytes);
        }
    }
    export class PlanSummary extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            name?: string;
            description?: string;
            resources?: string[];
            removeAds?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
                if ("removeAds" in data && data.removeAds != undefined) {
                    this.removeAds = data.removeAds;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get resources() {
            return pb_1.Message.getFieldWithDefault(this, 4, []) as string[];
        }
        set resources(value: string[]) {
            pb_1.Message.setField(this, 4, value);
        }
        get removeAds() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set removeAds(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            id?: string;
            name?: string;
            description?: string;
            resources?: string[];
            removeAds?: boolean;
        }): PlanSummary {
            const message = new PlanSummary({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.resources != null) {
                message.resources = data.resources;
            }
            if (data.removeAds != null) {
                message.removeAds = data.removeAds;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                name?: string;
                description?: string;
                resources?: string[];
                removeAds?: boolean;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.resources != null) {
                data.resources = this.resources;
            }
            if (this.removeAds != null) {
                data.removeAds = this.removeAds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.name.length)
                writer.writeString(2, this.name);
            if (this.description.length)
                writer.writeString(3, this.description);
            if (this.resources.length)
                writer.writeRepeatedString(4, this.resources);
            if (this.removeAds != false)
                writer.writeBool(5, this.removeAds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanSummary {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanSummary();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.name = reader.readString();
                        break;
                    case 3:
                        message.description = reader.readString();
                        break;
                    case 4:
                        pb_1.Message.addToRepeatedField(message, 4, reader.readString());
                        break;
                    case 5:
                        message.removeAds = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanSummary {
            return PlanSummary.deserialize(bytes);
        }
    }
    export class Cycle extends pb_1.Message {
        #one_of_decls: number[][] = [[3], [7]];
        constructor(data?: any[] | ({
            id?: string;
            startDate?: string;
            status?: CycleStatus;
            planName?: string;
            amount?: number;
            source?: SubscriptionSource;
            paymentLabel?: string;
            invoice?: Invoice;
            stepHistory?: CycleStepHistoryEntry[];
            metadata?: Map<string, string>;
            paymentId?: string;
        } & (({
            endDate?: string;
        }) | ({
            paymentInfo?: dependency_3.payments.v1.PaymentDetails;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [11], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("paymentInfo" in data && data.paymentInfo != undefined) {
                    this.paymentInfo = data.paymentInfo;
                }
                if ("source" in data && data.source != undefined) {
                    this.source = data.source;
                }
                if ("paymentLabel" in data && data.paymentLabel != undefined) {
                    this.paymentLabel = data.paymentLabel;
                }
                if ("invoice" in data && data.invoice != undefined) {
                    this.invoice = data.invoice;
                }
                if ("stepHistory" in data && data.stepHistory != undefined) {
                    this.stepHistory = data.stepHistory;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("paymentId" in data && data.paymentId != undefined) {
                    this.paymentId = data.paymentId;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get startDate() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set startDate(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get endDate() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set endDate(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[0], value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, CycleStatus.CYCLE_STATUS_UNSPECIFIED) as CycleStatus;
        }
        set status(value: CycleStatus) {
            pb_1.Message.setField(this, 4, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get paymentInfo() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentDetails, 7) as dependency_3.payments.v1.PaymentDetails;
        }
        set paymentInfo(value: dependency_3.payments.v1.PaymentDetails) {
            pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[1], value);
        }
        get hasPaymentInfo() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get source() {
            return pb_1.Message.getFieldWithDefault(this, 8, SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED) as SubscriptionSource;
        }
        set source(value: SubscriptionSource) {
            pb_1.Message.setField(this, 8, value);
        }
        get paymentLabel() {
            return pb_1.Message.getFieldWithDefault(this, 9, "") as string;
        }
        set paymentLabel(value: string) {
            pb_1.Message.setField(this, 9, value);
        }
        get invoice() {
            return pb_1.Message.getWrapperField(this, Invoice, 10) as Invoice;
        }
        set invoice(value: Invoice) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasInvoice() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get stepHistory() {
            return pb_1.Message.getRepeatedWrapperField(this, CycleStepHistoryEntry, 11) as CycleStepHistoryEntry[];
        }
        set stepHistory(value: CycleStepHistoryEntry[]) {
            pb_1.Message.setRepeatedWrapperField(this, 11, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 12) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 12, value as any);
        }
        get paymentId() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set paymentId(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get _end_date() {
            const cases: {
                [index: number]: "none" | "endDate";
            } = {
                0: "none",
                3: "endDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _payment_info() {
            const cases: {
                [index: number]: "none" | "paymentInfo";
            } = {
                0: "none",
                7: "paymentInfo"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        static fromObject(data: {
            id?: string;
            startDate?: string;
            endDate?: string;
            status?: CycleStatus;
            planName?: string;
            amount?: number;
            paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
            source?: SubscriptionSource;
            paymentLabel?: string;
            invoice?: ReturnType<typeof Invoice.prototype.toObject>;
            stepHistory?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>[];
            metadata?: {
                [key: string]: string;
            };
            paymentId?: string;
        }): Cycle {
            const message = new Cycle({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.startDate != null) {
                message.startDate = data.startDate;
            }
            if (data.endDate != null) {
                message.endDate = data.endDate;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.paymentInfo != null) {
                message.paymentInfo = dependency_3.payments.v1.PaymentDetails.fromObject(data.paymentInfo);
            }
            if (data.source != null) {
                message.source = data.source;
            }
            if (data.paymentLabel != null) {
                message.paymentLabel = data.paymentLabel;
            }
            if (data.invoice != null) {
                message.invoice = Invoice.fromObject(data.invoice);
            }
            if (data.stepHistory != null) {
                message.stepHistory = data.stepHistory.map(item => CycleStepHistoryEntry.fromObject(item));
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.paymentId != null) {
                message.paymentId = data.paymentId;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                startDate?: string;
                endDate?: string;
                status?: CycleStatus;
                planName?: string;
                amount?: number;
                paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
                source?: SubscriptionSource;
                paymentLabel?: string;
                invoice?: ReturnType<typeof Invoice.prototype.toObject>;
                stepHistory?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>[];
                metadata?: {
                    [key: string]: string;
                };
                paymentId?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate;
            }
            if (this.endDate != null) {
                data.endDate = this.endDate;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.paymentInfo != null) {
                data.paymentInfo = this.paymentInfo.toObject();
            }
            if (this.source != null) {
                data.source = this.source;
            }
            if (this.paymentLabel != null) {
                data.paymentLabel = this.paymentLabel;
            }
            if (this.invoice != null) {
                data.invoice = this.invoice.toObject();
            }
            if (this.stepHistory != null) {
                data.stepHistory = this.stepHistory.map((item: CycleStepHistoryEntry) => item.toObject());
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.paymentId != null) {
                data.paymentId = this.paymentId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.startDate.length)
                writer.writeString(2, this.startDate);
            if (this.hasEndDate)
                writer.writeString(3, this.endDate);
            if (this.status != CycleStatus.CYCLE_STATUS_UNSPECIFIED)
                writer.writeEnum(4, this.status);
            if (this.planName.length)
                writer.writeString(5, this.planName);
            if (this.amount != 0)
                writer.writeInt64(6, this.amount);
            if (this.hasPaymentInfo)
                writer.writeMessage(7, this.paymentInfo, () => this.paymentInfo.serialize(writer));
            if (this.source != SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED)
                writer.writeEnum(8, this.source);
            if (this.paymentLabel.length)
                writer.writeString(9, this.paymentLabel);
            if (this.hasInvoice)
                writer.writeMessage(10, this.invoice, () => this.invoice.serialize(writer));
            if (this.stepHistory.length)
                writer.writeRepeatedMessage(11, this.stepHistory, (item: CycleStepHistoryEntry) => item.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(12, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.paymentId.length)
                writer.writeString(13, this.paymentId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Cycle {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Cycle();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.startDate = reader.readString();
                        break;
                    case 3:
                        message.endDate = reader.readString();
                        break;
                    case 4:
                        message.status = reader.readEnum();
                        break;
                    case 5:
                        message.planName = reader.readString();
                        break;
                    case 6:
                        message.amount = reader.readInt64();
                        break;
                    case 7:
                        reader.readMessage(message.paymentInfo, () => message.paymentInfo = dependency_3.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 8:
                        message.source = reader.readEnum();
                        break;
                    case 9:
                        message.paymentLabel = reader.readString();
                        break;
                    case 10:
                        reader.readMessage(message.invoice, () => message.invoice = Invoice.deserialize(reader));
                        break;
                    case 11:
                        reader.readMessage(message.stepHistory, () => pb_1.Message.addToRepeatedWrapperField(message, 11, CycleStepHistoryEntry.deserialize(reader), CycleStepHistoryEntry));
                        break;
                    case 12:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 13:
                        message.paymentId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Cycle {
            return Cycle.deserialize(bytes);
        }
    }
    export class CycleSummary extends pb_1.Message {
        #one_of_decls: number[][] = [[3]];
        constructor(data?: any[] | ({
            id?: string;
            startDate?: string;
        } & (({
            endDate?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get startDate() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set startDate(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get endDate() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set endDate(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[0], value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get _end_date() {
            const cases: {
                [index: number]: "none" | "endDate";
            } = {
                0: "none",
                3: "endDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            id?: string;
            startDate?: string;
            endDate?: string;
        }): CycleSummary {
            const message = new CycleSummary({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.startDate != null) {
                message.startDate = data.startDate;
            }
            if (data.endDate != null) {
                message.endDate = data.endDate;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                startDate?: string;
                endDate?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate;
            }
            if (this.endDate != null) {
                data.endDate = this.endDate;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.startDate.length)
                writer.writeString(2, this.startDate);
            if (this.hasEndDate)
                writer.writeString(3, this.endDate);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CycleSummary {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CycleSummary();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.startDate = reader.readString();
                        break;
                    case 3:
                        message.endDate = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CycleSummary {
            return CycleSummary.deserialize(bytes);
        }
    }
    export class Subscription extends pb_1.Message {
        #one_of_decls: number[][] = [[13], [22], [25]];
        constructor(data?: any[] | ({
            id?: string;
            userId?: string;
            plan?: Plan;
            status?: Status;
            autoRenewal?: boolean;
            events?: Event[];
            organizationId?: string;
            trial?: boolean;
            members?: dependency_5.subscriptions.v1.SubscriptionMember[];
            name?: string;
            email?: string;
            userExternalId?: string;
            resources?: string[];
            currentCycle?: Cycle;
            isFree?: boolean;
            source?: SubscriptionSource;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
            orderId?: string;
            metadata?: Map<string, string>;
            amount?: number;
            paymentLabel?: string;
        } & (({
            paymentType?: dependency_3.payments.v1.PaymentType;
        }) | ({
            finishDate?: string;
        }) | ({
            nextChargeDate?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6, 9, 14], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("autoRenewal" in data && data.autoRenewal != undefined) {
                    this.autoRenewal = data.autoRenewal;
                }
                if ("events" in data && data.events != undefined) {
                    this.events = data.events;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("trial" in data && data.trial != undefined) {
                    this.trial = data.trial;
                }
                if ("members" in data && data.members != undefined) {
                    this.members = data.members;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("userExternalId" in data && data.userExternalId != undefined) {
                    this.userExternalId = data.userExternalId;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("resources" in data && data.resources != undefined) {
                    this.resources = data.resources;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
                if ("isFree" in data && data.isFree != undefined) {
                    this.isFree = data.isFree;
                }
                if ("source" in data && data.source != undefined) {
                    this.source = data.source;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("finishDate" in data && data.finishDate != undefined) {
                    this.finishDate = data.finishDate;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("paymentLabel" in data && data.paymentLabel != undefined) {
                    this.paymentLabel = data.paymentLabel;
                }
                if ("nextChargeDate" in data && data.nextChargeDate != undefined) {
                    this.nextChargeDate = data.nextChargeDate;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 3) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 4, value);
        }
        get autoRenewal() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set autoRenewal(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get events() {
            return pb_1.Message.getRepeatedWrapperField(this, Event, 6) as Event[];
        }
        set events(value: Event[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 7, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 7, value);
        }
        get trial() {
            return pb_1.Message.getFieldWithDefault(this, 8, false) as boolean;
        }
        set trial(value: boolean) {
            pb_1.Message.setField(this, 8, value);
        }
        get members() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_5.subscriptions.v1.SubscriptionMember, 9) as dependency_5.subscriptions.v1.SubscriptionMember[];
        }
        set members(value: dependency_5.subscriptions.v1.SubscriptionMember[]) {
            pb_1.Message.setRepeatedWrapperField(this, 9, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get userExternalId() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set userExternalId(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentType, 13) as dependency_3.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_3.payments.v1.PaymentType) {
            pb_1.Message.setOneofWrapperField(this, 13, this.#one_of_decls[0], value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get resources() {
            return pb_1.Message.getFieldWithDefault(this, 14, []) as string[];
        }
        set resources(value: string[]) {
            pb_1.Message.setField(this, 14, value);
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, Cycle, 15) as Cycle;
        }
        set currentCycle(value: Cycle) {
            pb_1.Message.setWrapperField(this, 15, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 15) != null;
        }
        get isFree() {
            return pb_1.Message.getFieldWithDefault(this, 16, false) as boolean;
        }
        set isFree(value: boolean) {
            pb_1.Message.setField(this, 16, value);
        }
        get source() {
            return pb_1.Message.getFieldWithDefault(this, 17, SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED) as SubscriptionSource;
        }
        set source(value: SubscriptionSource) {
            pb_1.Message.setField(this, 17, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 18) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 18, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 18) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 19) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 19, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 19) != null;
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 20, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 20, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 21) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 21, value as any);
        }
        get finishDate() {
            return pb_1.Message.getFieldWithDefault(this, 22, "") as string;
        }
        set finishDate(value: string) {
            pb_1.Message.setOneofField(this, 22, this.#one_of_decls[1], value);
        }
        get hasFinishDate() {
            return pb_1.Message.getField(this, 22) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 23, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 23, value);
        }
        get paymentLabel() {
            return pb_1.Message.getFieldWithDefault(this, 24, "") as string;
        }
        set paymentLabel(value: string) {
            pb_1.Message.setField(this, 24, value);
        }
        get nextChargeDate() {
            return pb_1.Message.getFieldWithDefault(this, 25, "") as string;
        }
        set nextChargeDate(value: string) {
            pb_1.Message.setOneofField(this, 25, this.#one_of_decls[2], value);
        }
        get hasNextChargeDate() {
            return pb_1.Message.getField(this, 25) != null;
        }
        get _payment_type() {
            const cases: {
                [index: number]: "none" | "paymentType";
            } = {
                0: "none",
                13: "paymentType"
            };
            return cases[pb_1.Message.computeOneofCase(this, [13])];
        }
        get _finish_date() {
            const cases: {
                [index: number]: "none" | "finishDate";
            } = {
                0: "none",
                22: "finishDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [22])];
        }
        get _next_charge_date() {
            const cases: {
                [index: number]: "none" | "nextChargeDate";
            } = {
                0: "none",
                25: "nextChargeDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [25])];
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
            plan?: ReturnType<typeof Plan.prototype.toObject>;
            status?: Status;
            autoRenewal?: boolean;
            events?: ReturnType<typeof Event.prototype.toObject>[];
            organizationId?: string;
            trial?: boolean;
            members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
            name?: string;
            email?: string;
            userExternalId?: string;
            paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
            resources?: string[];
            currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
            isFree?: boolean;
            source?: SubscriptionSource;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            orderId?: string;
            metadata?: {
                [key: string]: string;
            };
            finishDate?: string;
            amount?: number;
            paymentLabel?: string;
            nextChargeDate?: string;
        }): Subscription {
            const message = new Subscription({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.autoRenewal != null) {
                message.autoRenewal = data.autoRenewal;
            }
            if (data.events != null) {
                message.events = data.events.map(item => Event.fromObject(item));
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.trial != null) {
                message.trial = data.trial;
            }
            if (data.members != null) {
                message.members = data.members.map(item => dependency_5.subscriptions.v1.SubscriptionMember.fromObject(item));
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.userExternalId != null) {
                message.userExternalId = data.userExternalId;
            }
            if (data.paymentType != null) {
                message.paymentType = dependency_3.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (data.resources != null) {
                message.resources = data.resources;
            }
            if (data.currentCycle != null) {
                message.currentCycle = Cycle.fromObject(data.currentCycle);
            }
            if (data.isFree != null) {
                message.isFree = data.isFree;
            }
            if (data.source != null) {
                message.source = data.source;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.finishDate != null) {
                message.finishDate = data.finishDate;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.paymentLabel != null) {
                message.paymentLabel = data.paymentLabel;
            }
            if (data.nextChargeDate != null) {
                message.nextChargeDate = data.nextChargeDate;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
                plan?: ReturnType<typeof Plan.prototype.toObject>;
                status?: Status;
                autoRenewal?: boolean;
                events?: ReturnType<typeof Event.prototype.toObject>[];
                organizationId?: string;
                trial?: boolean;
                members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
                name?: string;
                email?: string;
                userExternalId?: string;
                paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
                resources?: string[];
                currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
                isFree?: boolean;
                source?: SubscriptionSource;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                orderId?: string;
                metadata?: {
                    [key: string]: string;
                };
                finishDate?: string;
                amount?: number;
                paymentLabel?: string;
                nextChargeDate?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.autoRenewal != null) {
                data.autoRenewal = this.autoRenewal;
            }
            if (this.events != null) {
                data.events = this.events.map((item: Event) => item.toObject());
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.trial != null) {
                data.trial = this.trial;
            }
            if (this.members != null) {
                data.members = this.members.map((item: dependency_5.subscriptions.v1.SubscriptionMember) => item.toObject());
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.userExternalId != null) {
                data.userExternalId = this.userExternalId;
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.resources != null) {
                data.resources = this.resources;
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            if (this.isFree != null) {
                data.isFree = this.isFree;
            }
            if (this.source != null) {
                data.source = this.source;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.finishDate != null) {
                data.finishDate = this.finishDate;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.paymentLabel != null) {
                data.paymentLabel = this.paymentLabel;
            }
            if (this.nextChargeDate != null) {
                data.nextChargeDate = this.nextChargeDate;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.hasPlan)
                writer.writeMessage(3, this.plan, () => this.plan.serialize(writer));
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(4, this.status);
            if (this.autoRenewal != false)
                writer.writeBool(5, this.autoRenewal);
            if (this.events.length)
                writer.writeRepeatedMessage(6, this.events, (item: Event) => item.serialize(writer));
            if (this.organizationId.length)
                writer.writeString(7, this.organizationId);
            if (this.trial != false)
                writer.writeBool(8, this.trial);
            if (this.members.length)
                writer.writeRepeatedMessage(9, this.members, (item: dependency_5.subscriptions.v1.SubscriptionMember) => item.serialize(writer));
            if (this.name.length)
                writer.writeString(10, this.name);
            if (this.email.length)
                writer.writeString(11, this.email);
            if (this.userExternalId.length)
                writer.writeString(12, this.userExternalId);
            if (this.hasPaymentType)
                writer.writeMessage(13, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.resources.length)
                writer.writeRepeatedString(14, this.resources);
            if (this.hasCurrentCycle)
                writer.writeMessage(15, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (this.isFree != false)
                writer.writeBool(16, this.isFree);
            if (this.source != SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED)
                writer.writeEnum(17, this.source);
            if (this.hasCreatedAt)
                writer.writeMessage(18, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(19, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.orderId.length)
                writer.writeString(20, this.orderId);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(21, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasFinishDate)
                writer.writeString(22, this.finishDate);
            if (this.amount != 0)
                writer.writeInt64(23, this.amount);
            if (this.paymentLabel.length)
                writer.writeString(24, this.paymentLabel);
            if (this.hasNextChargeDate)
                writer.writeString(25, this.nextChargeDate);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Subscription {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Subscription();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    case 4:
                        message.status = reader.readEnum();
                        break;
                    case 5:
                        message.autoRenewal = reader.readBool();
                        break;
                    case 6:
                        reader.readMessage(message.events, () => pb_1.Message.addToRepeatedWrapperField(message, 6, Event.deserialize(reader), Event));
                        break;
                    case 7:
                        message.organizationId = reader.readString();
                        break;
                    case 8:
                        message.trial = reader.readBool();
                        break;
                    case 9:
                        reader.readMessage(message.members, () => pb_1.Message.addToRepeatedWrapperField(message, 9, dependency_5.subscriptions.v1.SubscriptionMember.deserialize(reader), dependency_5.subscriptions.v1.SubscriptionMember));
                        break;
                    case 10:
                        message.name = reader.readString();
                        break;
                    case 11:
                        message.email = reader.readString();
                        break;
                    case 12:
                        message.userExternalId = reader.readString();
                        break;
                    case 13:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_3.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 14:
                        pb_1.Message.addToRepeatedField(message, 14, reader.readString());
                        break;
                    case 15:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = Cycle.deserialize(reader));
                        break;
                    case 16:
                        message.isFree = reader.readBool();
                        break;
                    case 17:
                        message.source = reader.readEnum();
                        break;
                    case 18:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 19:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 20:
                        message.orderId = reader.readString();
                        break;
                    case 21:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 22:
                        message.finishDate = reader.readString();
                        break;
                    case 23:
                        message.amount = reader.readInt64();
                        break;
                    case 24:
                        message.paymentLabel = reader.readString();
                        break;
                    case 25:
                        message.nextChargeDate = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Subscription {
            return Subscription.deserialize(bytes);
        }
    }
    export class GetCurrentSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetCurrentSubscriptionRequest {
            const message = new GetCurrentSubscriptionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCurrentSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCurrentSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCurrentSubscriptionRequest {
            return GetCurrentSubscriptionRequest.deserialize(bytes);
        }
    }
    export class GetCurrentSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
            paidSince?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
                if ("paidSince" in data && data.paidSince != undefined) {
                    this.paidSince = data.paidSince;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get paidSince() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set paidSince(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasPaidSince() {
            return pb_1.Message.getField(this, 2) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            paidSince?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): GetCurrentSubscriptionResponse {
            const message = new GetCurrentSubscriptionResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            if (data.paidSince != null) {
                message.paidSince = dependency_2.google.protobuf.Timestamp.fromObject(data.paidSince);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
                paidSince?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            if (this.paidSince != null) {
                data.paidSince = this.paidSince.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (this.hasPaidSince)
                writer.writeMessage(2, this.paidSince, () => this.paidSince.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCurrentSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCurrentSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.paidSince, () => message.paidSince = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCurrentSubscriptionResponse {
            return GetCurrentSubscriptionResponse.deserialize(bytes);
        }
    }
    export class GetActiveSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetActiveSubscriptionRequest {
            const message = new GetActiveSubscriptionRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetActiveSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetActiveSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetActiveSubscriptionRequest {
            return GetActiveSubscriptionRequest.deserialize(bytes);
        }
    }
    export class GetActiveSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
        }): GetActiveSubscriptionResponse {
            const message = new GetActiveSubscriptionResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetActiveSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetActiveSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetActiveSubscriptionResponse {
            return GetActiveSubscriptionResponse.deserialize(bytes);
        }
    }
    export class RequestPaymentRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            amount?: number;
            userId?: string;
            metadata?: Map<string, string>;
            paymentType?: dependency_3.payments.v1.PaymentType;
            customer?: dependency_4.checkout.v1.CustomerInfo;
            campaignDiscount?: CampaignDiscount;
            campaignOffer?: CampaignOffer;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("paymentType" in data && data.paymentType != undefined) {
                    this.paymentType = data.paymentType;
                }
                if ("customer" in data && data.customer != undefined) {
                    this.customer = data.customer;
                }
                if ("campaignDiscount" in data && data.campaignDiscount != undefined) {
                    this.campaignDiscount = data.campaignDiscount;
                }
                if ("campaignOffer" in data && data.campaignOffer != undefined) {
                    this.campaignOffer = data.campaignOffer;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 4) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 4, value as any);
        }
        get paymentType() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentType, 5) as dependency_3.payments.v1.PaymentType;
        }
        set paymentType(value: dependency_3.payments.v1.PaymentType) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasPaymentType() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get customer() {
            return pb_1.Message.getWrapperField(this, dependency_4.checkout.v1.CustomerInfo, 6) as dependency_4.checkout.v1.CustomerInfo;
        }
        set customer(value: dependency_4.checkout.v1.CustomerInfo) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasCustomer() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get campaignDiscount() {
            return pb_1.Message.getWrapperField(this, CampaignDiscount, 7) as CampaignDiscount;
        }
        set campaignDiscount(value: CampaignDiscount) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasCampaignDiscount() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get campaignOffer() {
            return pb_1.Message.getWrapperField(this, CampaignOffer, 8) as CampaignOffer;
        }
        set campaignOffer(value: CampaignOffer) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasCampaignOffer() {
            return pb_1.Message.getField(this, 8) != null;
        }
        static fromObject(data: {
            id?: string;
            amount?: number;
            userId?: string;
            metadata?: {
                [key: string]: string;
            };
            paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
            customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
            campaignDiscount?: ReturnType<typeof CampaignDiscount.prototype.toObject>;
            campaignOffer?: ReturnType<typeof CampaignOffer.prototype.toObject>;
        }): RequestPaymentRequest {
            const message = new RequestPaymentRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.paymentType != null) {
                message.paymentType = dependency_3.payments.v1.PaymentType.fromObject(data.paymentType);
            }
            if (data.customer != null) {
                message.customer = dependency_4.checkout.v1.CustomerInfo.fromObject(data.customer);
            }
            if (data.campaignDiscount != null) {
                message.campaignDiscount = CampaignDiscount.fromObject(data.campaignDiscount);
            }
            if (data.campaignOffer != null) {
                message.campaignOffer = CampaignOffer.fromObject(data.campaignOffer);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                amount?: number;
                userId?: string;
                metadata?: {
                    [key: string]: string;
                };
                paymentType?: ReturnType<typeof dependency_3.payments.v1.PaymentType.prototype.toObject>;
                customer?: ReturnType<typeof dependency_4.checkout.v1.CustomerInfo.prototype.toObject>;
                campaignDiscount?: ReturnType<typeof CampaignDiscount.prototype.toObject>;
                campaignOffer?: ReturnType<typeof CampaignOffer.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.paymentType != null) {
                data.paymentType = this.paymentType.toObject();
            }
            if (this.customer != null) {
                data.customer = this.customer.toObject();
            }
            if (this.campaignDiscount != null) {
                data.campaignDiscount = this.campaignDiscount.toObject();
            }
            if (this.campaignOffer != null) {
                data.campaignOffer = this.campaignOffer.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.amount != 0)
                writer.writeInt64(2, this.amount);
            if (this.userId.length)
                writer.writeString(3, this.userId);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(4, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasPaymentType)
                writer.writeMessage(5, this.paymentType, () => this.paymentType.serialize(writer));
            if (this.hasCustomer)
                writer.writeMessage(6, this.customer, () => this.customer.serialize(writer));
            if (this.hasCampaignDiscount)
                writer.writeMessage(7, this.campaignDiscount, () => this.campaignDiscount.serialize(writer));
            if (this.hasCampaignOffer)
                writer.writeMessage(8, this.campaignOffer, () => this.campaignOffer.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RequestPaymentRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RequestPaymentRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.amount = reader.readInt64();
                        break;
                    case 3:
                        message.userId = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 5:
                        reader.readMessage(message.paymentType, () => message.paymentType = dependency_3.payments.v1.PaymentType.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.customer, () => message.customer = dependency_4.checkout.v1.CustomerInfo.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.campaignDiscount, () => message.campaignDiscount = CampaignDiscount.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.campaignOffer, () => message.campaignOffer = CampaignOffer.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RequestPaymentRequest {
            return RequestPaymentRequest.deserialize(bytes);
        }
    }
    export class RequestPaymentResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            status?: string;
            paymentInfo?: dependency_3.payments.v1.PaymentDetails;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            settled?: boolean;
            expiresAt?: dependency_2.google.protobuf.Timestamp;
            amount?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("paymentInfo" in data && data.paymentInfo != undefined) {
                    this.paymentInfo = data.paymentInfo;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("settled" in data && data.settled != undefined) {
                    this.settled = data.settled;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get paymentInfo() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentDetails, 3) as dependency_3.payments.v1.PaymentDetails;
        }
        set paymentInfo(value: dependency_3.payments.v1.PaymentDetails) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasPaymentInfo() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get settled() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set settled(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get expiresAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set expiresAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasExpiresAt() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            id?: string;
            status?: string;
            paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            settled?: boolean;
            expiresAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            amount?: number;
        }): RequestPaymentResponse {
            const message = new RequestPaymentResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.paymentInfo != null) {
                message.paymentInfo = dependency_3.payments.v1.PaymentDetails.fromObject(data.paymentInfo);
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.settled != null) {
                message.settled = data.settled;
            }
            if (data.expiresAt != null) {
                message.expiresAt = dependency_2.google.protobuf.Timestamp.fromObject(data.expiresAt);
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                status?: string;
                paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                settled?: boolean;
                expiresAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                amount?: number;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.paymentInfo != null) {
                data.paymentInfo = this.paymentInfo.toObject();
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.settled != null) {
                data.settled = this.settled;
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt.toObject();
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.status.length)
                writer.writeString(2, this.status);
            if (this.hasPaymentInfo)
                writer.writeMessage(3, this.paymentInfo, () => this.paymentInfo.serialize(writer));
            if (this.hasCreatedAt)
                writer.writeMessage(4, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.settled != false)
                writer.writeBool(5, this.settled);
            if (this.hasExpiresAt)
                writer.writeMessage(6, this.expiresAt, () => this.expiresAt.serialize(writer));
            if (this.amount != 0)
                writer.writeInt64(7, this.amount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RequestPaymentResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RequestPaymentResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readString();
                        break;
                    case 3:
                        reader.readMessage(message.paymentInfo, () => message.paymentInfo = dependency_3.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        message.settled = reader.readBool();
                        break;
                    case 6:
                        reader.readMessage(message.expiresAt, () => message.expiresAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.amount = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RequestPaymentResponse {
            return RequestPaymentResponse.deserialize(bytes);
        }
    }
    export class CreateSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planId?: string;
            autoRenewal?: boolean;
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("autoRenewal" in data && data.autoRenewal != undefined) {
                    this.autoRenewal = data.autoRenewal;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get autoRenewal() {
            return pb_1.Message.getFieldWithDefault(this, 2, false) as boolean;
        }
        set autoRenewal(value: boolean) {
            pb_1.Message.setField(this, 2, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            planId?: string;
            autoRenewal?: boolean;
            userId?: string;
        }): CreateSubscriptionRequest {
            const message = new CreateSubscriptionRequest({});
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.autoRenewal != null) {
                message.autoRenewal = data.autoRenewal;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                planId?: string;
                autoRenewal?: boolean;
                userId?: string;
            } = {};
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.autoRenewal != null) {
                data.autoRenewal = this.autoRenewal;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planId.length)
                writer.writeString(1, this.planId);
            if (this.autoRenewal != false)
                writer.writeBool(2, this.autoRenewal);
            if (this.userId.length)
                writer.writeString(3, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planId = reader.readString();
                        break;
                    case 2:
                        message.autoRenewal = reader.readBool();
                        break;
                    case 3:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionRequest {
            return CreateSubscriptionRequest.deserialize(bytes);
        }
    }
    export class CreateSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
        }): CreateSubscriptionResponse {
            const message = new CreateSubscriptionResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CreateSubscriptionResponse {
            return CreateSubscriptionResponse.deserialize(bytes);
        }
    }
    export class GetSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            userId?: string;
            orderId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("orderId" in data && data.orderId != undefined) {
                    this.orderId = data.orderId;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get orderId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set orderId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
            orderId?: string;
        }): GetSubscriptionRequest {
            const message = new GetSubscriptionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.orderId != null) {
                message.orderId = data.orderId;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
                orderId?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.orderId != null) {
                data.orderId = this.orderId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.orderId.length)
                writer.writeString(4, this.orderId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 4:
                        message.orderId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionRequest {
            return GetSubscriptionRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscription?: Subscription;
            currentCycle?: Cycle;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscription" in data && data.subscription != undefined) {
                    this.subscription = data.subscription;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
            }
        }
        get subscription() {
            return pb_1.Message.getWrapperField(this, Subscription, 1) as Subscription;
        }
        set subscription(value: Subscription) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasSubscription() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, Cycle, 2) as Cycle;
        }
        set currentCycle(value: Cycle) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 2) != null;
        }
        static fromObject(data: {
            subscription?: ReturnType<typeof Subscription.prototype.toObject>;
            currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
        }): GetSubscriptionResponse {
            const message = new GetSubscriptionResponse({});
            if (data.subscription != null) {
                message.subscription = Subscription.fromObject(data.subscription);
            }
            if (data.currentCycle != null) {
                message.currentCycle = Cycle.fromObject(data.currentCycle);
            }
            return message;
        }
        toObject() {
            const data: {
                subscription?: ReturnType<typeof Subscription.prototype.toObject>;
                currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
            } = {};
            if (this.subscription != null) {
                data.subscription = this.subscription.toObject();
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasSubscription)
                writer.writeMessage(1, this.subscription, () => this.subscription.serialize(writer));
            if (this.hasCurrentCycle)
                writer.writeMessage(2, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscription, () => message.subscription = Subscription.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = Cycle.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionResponse {
            return GetSubscriptionResponse.deserialize(bytes);
        }
    }
    export class DeleteSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
        }): DeleteSubscriptionRequest {
            const message = new DeleteSubscriptionRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteSubscriptionRequest {
            return DeleteSubscriptionRequest.deserialize(bytes);
        }
    }
    export class DeleteSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            success?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("success" in data && data.success != undefined) {
                    this.success = data.success;
                }
            }
        }
        get success() {
            return pb_1.Message.getFieldWithDefault(this, 1, false) as boolean;
        }
        set success(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            success?: boolean;
        }): DeleteSubscriptionResponse {
            const message = new DeleteSubscriptionResponse({});
            if (data.success != null) {
                message.success = data.success;
            }
            return message;
        }
        toObject() {
            const data: {
                success?: boolean;
            } = {};
            if (this.success != null) {
                data.success = this.success;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.success != false)
                writer.writeBool(1, this.success);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.success = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteSubscriptionResponse {
            return DeleteSubscriptionResponse.deserialize(bytes);
        }
    }
    export class ListSubscriptionRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[7], [8]];
        constructor(data?: any[] | ({
            id?: string;
            userId?: string;
            userName?: string;
            userEmail?: string;
            planId?: string[];
            status?: Status[];
            page?: number;
            pageSize?: number;
        } & (({
            createdAfter?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            createdBefore?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5, 6], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("userName" in data && data.userName != undefined) {
                    this.userName = data.userName;
                }
                if ("userEmail" in data && data.userEmail != undefined) {
                    this.userEmail = data.userEmail;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("createdAfter" in data && data.createdAfter != undefined) {
                    this.createdAfter = data.createdAfter;
                }
                if ("createdBefore" in data && data.createdBefore != undefined) {
                    this.createdBefore = data.createdBefore;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get userName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set userName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get userEmail() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set userEmail(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 5, []) as string[];
        }
        set planId(value: string[]) {
            pb_1.Message.setField(this, 5, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, []) as Status[];
        }
        set status(value: Status[]) {
            pb_1.Message.setField(this, 6, value);
        }
        get createdAfter() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 7) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAfter(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[0], value);
        }
        get hasCreatedAfter() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get createdBefore() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 8) as dependency_2.google.protobuf.Timestamp;
        }
        set createdBefore(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 8, this.#one_of_decls[1], value);
        }
        get hasCreatedBefore() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 10, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 10, value);
        }
        get _created_after() {
            const cases: {
                [index: number]: "none" | "createdAfter";
            } = {
                0: "none",
                7: "createdAfter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        get _created_before() {
            const cases: {
                [index: number]: "none" | "createdBefore";
            } = {
                0: "none",
                8: "createdBefore"
            };
            return cases[pb_1.Message.computeOneofCase(this, [8])];
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
            userName?: string;
            userEmail?: string;
            planId?: string[];
            status?: Status[];
            createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            page?: number;
            pageSize?: number;
        }): ListSubscriptionRequest {
            const message = new ListSubscriptionRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.userName != null) {
                message.userName = data.userName;
            }
            if (data.userEmail != null) {
                message.userEmail = data.userEmail;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.createdAfter != null) {
                message.createdAfter = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAfter);
            }
            if (data.createdBefore != null) {
                message.createdBefore = dependency_2.google.protobuf.Timestamp.fromObject(data.createdBefore);
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
                userName?: string;
                userEmail?: string;
                planId?: string[];
                status?: Status[];
                createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                page?: number;
                pageSize?: number;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.userName != null) {
                data.userName = this.userName;
            }
            if (this.userEmail != null) {
                data.userEmail = this.userEmail;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.createdAfter != null) {
                data.createdAfter = this.createdAfter.toObject();
            }
            if (this.createdBefore != null) {
                data.createdBefore = this.createdBefore.toObject();
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.userName.length)
                writer.writeString(3, this.userName);
            if (this.userEmail.length)
                writer.writeString(4, this.userEmail);
            if (this.planId.length)
                writer.writeRepeatedString(5, this.planId);
            if (this.status.length)
                writer.writePackedEnum(6, this.status);
            if (this.hasCreatedAfter)
                writer.writeMessage(7, this.createdAfter, () => this.createdAfter.serialize(writer));
            if (this.hasCreatedBefore)
                writer.writeMessage(8, this.createdBefore, () => this.createdBefore.serialize(writer));
            if (this.page != 0)
                writer.writeInt64(9, this.page);
            if (this.pageSize != 0)
                writer.writeInt64(10, this.pageSize);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        message.userName = reader.readString();
                        break;
                    case 4:
                        message.userEmail = reader.readString();
                        break;
                    case 5:
                        pb_1.Message.addToRepeatedField(message, 5, reader.readString());
                        break;
                    case 6:
                        message.status = reader.readPackedEnum();
                        break;
                    case 7:
                        reader.readMessage(message.createdAfter, () => message.createdAfter = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.createdBefore, () => message.createdBefore = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 9:
                        message.page = reader.readInt64();
                        break;
                    case 10:
                        message.pageSize = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionRequest {
            return ListSubscriptionRequest.deserialize(bytes);
        }
    }
    export class ListSubscriptionResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptions?: Subscription[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptions" in data && data.subscriptions != undefined) {
                    this.subscriptions = data.subscriptions;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
            }
        }
        get subscriptions() {
            return pb_1.Message.getRepeatedWrapperField(this, Subscription, 1) as Subscription[];
        }
        set subscriptions(value: Subscription[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            subscriptions?: ReturnType<typeof Subscription.prototype.toObject>[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }): ListSubscriptionResponse {
            const message = new ListSubscriptionResponse({});
            if (data.subscriptions != null) {
                message.subscriptions = data.subscriptions.map(item => Subscription.fromObject(item));
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptions?: ReturnType<typeof Subscription.prototype.toObject>[];
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            } = {};
            if (this.subscriptions != null) {
                data.subscriptions = this.subscriptions.map((item: Subscription) => item.toObject());
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptions.length)
                writer.writeRepeatedMessage(1, this.subscriptions, (item: Subscription) => item.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(2, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(4, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(5, this.hasPrev);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscriptions, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Subscription.deserialize(reader), Subscription));
                        break;
                    case 2:
                        message.totalCount = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.hasNext = reader.readBool();
                        break;
                    case 5:
                        message.hasPrev = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionResponse {
            return ListSubscriptionResponse.deserialize(bytes);
        }
    }
    export class ListSubscriptionsSlimRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[6], [7]];
        constructor(data?: any[] | ({
            id?: string;
            userId?: string;
            email?: string;
            planId?: string;
            status?: Status;
        } & (({
            createdAfter?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            createdBefore?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("createdAfter" in data && data.createdAfter != undefined) {
                    this.createdAfter = data.createdAfter;
                }
                if ("createdBefore" in data && data.createdBefore != undefined) {
                    this.createdBefore = data.createdBefore;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 5, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 5, value);
        }
        get createdAfter() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAfter(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 6, this.#one_of_decls[0], value);
        }
        get hasCreatedAfter() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get createdBefore() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 7) as dependency_2.google.protobuf.Timestamp;
        }
        set createdBefore(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 7, this.#one_of_decls[1], value);
        }
        get hasCreatedBefore() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get _created_after() {
            const cases: {
                [index: number]: "none" | "createdAfter";
            } = {
                0: "none",
                6: "createdAfter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [6])];
        }
        get _created_before() {
            const cases: {
                [index: number]: "none" | "createdBefore";
            } = {
                0: "none",
                7: "createdBefore"
            };
            return cases[pb_1.Message.computeOneofCase(this, [7])];
        }
        static fromObject(data: {
            id?: string;
            userId?: string;
            email?: string;
            planId?: string;
            status?: Status;
            createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): ListSubscriptionsSlimRequest {
            const message = new ListSubscriptionsSlimRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.createdAfter != null) {
                message.createdAfter = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAfter);
            }
            if (data.createdBefore != null) {
                message.createdBefore = dependency_2.google.protobuf.Timestamp.fromObject(data.createdBefore);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                userId?: string;
                email?: string;
                planId?: string;
                status?: Status;
                createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.createdAfter != null) {
                data.createdAfter = this.createdAfter.toObject();
            }
            if (this.createdBefore != null) {
                data.createdBefore = this.createdBefore.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.email.length)
                writer.writeString(3, this.email);
            if (this.planId.length)
                writer.writeString(4, this.planId);
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(5, this.status);
            if (this.hasCreatedAfter)
                writer.writeMessage(6, this.createdAfter, () => this.createdAfter.serialize(writer));
            if (this.hasCreatedBefore)
                writer.writeMessage(7, this.createdBefore, () => this.createdBefore.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionsSlimRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionsSlimRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        message.email = reader.readString();
                        break;
                    case 4:
                        message.planId = reader.readString();
                        break;
                    case 5:
                        message.status = reader.readEnum();
                        break;
                    case 6:
                        reader.readMessage(message.createdAfter, () => message.createdAfter = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        reader.readMessage(message.createdBefore, () => message.createdBefore = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionsSlimRequest {
            return ListSubscriptionsSlimRequest.deserialize(bytes);
        }
    }
    export class SubscriptionSlim extends pb_1.Message {
        #one_of_decls: number[][] = [[9]];
        constructor(data?: any[] | ({
            id?: string;
            status?: Status;
            ownerName?: string;
            ownerEmail?: string;
            planName?: string;
            currentUsers?: number;
            maxUsers?: number;
            metadata?: Map<string, string>;
        } & (({
            createdAt?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("ownerName" in data && data.ownerName != undefined) {
                    this.ownerName = data.ownerName;
                }
                if ("ownerEmail" in data && data.ownerEmail != undefined) {
                    this.ownerEmail = data.ownerEmail;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("currentUsers" in data && data.currentUsers != undefined) {
                    this.currentUsers = data.currentUsers;
                }
                if ("maxUsers" in data && data.maxUsers != undefined) {
                    this.maxUsers = data.maxUsers;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 2, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 2, value);
        }
        get ownerName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set ownerName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get ownerEmail() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set ownerEmail(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get currentUsers() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set currentUsers(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get maxUsers() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set maxUsers(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 8) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 8, value as any);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 9) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 9, this.#one_of_decls[0], value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get _created_at() {
            const cases: {
                [index: number]: "none" | "createdAt";
            } = {
                0: "none",
                9: "createdAt"
            };
            return cases[pb_1.Message.computeOneofCase(this, [9])];
        }
        static fromObject(data: {
            id?: string;
            status?: Status;
            ownerName?: string;
            ownerEmail?: string;
            planName?: string;
            currentUsers?: number;
            maxUsers?: number;
            metadata?: {
                [key: string]: string;
            };
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): SubscriptionSlim {
            const message = new SubscriptionSlim({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.ownerName != null) {
                message.ownerName = data.ownerName;
            }
            if (data.ownerEmail != null) {
                message.ownerEmail = data.ownerEmail;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.currentUsers != null) {
                message.currentUsers = data.currentUsers;
            }
            if (data.maxUsers != null) {
                message.maxUsers = data.maxUsers;
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                status?: Status;
                ownerName?: string;
                ownerEmail?: string;
                planName?: string;
                currentUsers?: number;
                maxUsers?: number;
                metadata?: {
                    [key: string]: string;
                };
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.ownerName != null) {
                data.ownerName = this.ownerName;
            }
            if (this.ownerEmail != null) {
                data.ownerEmail = this.ownerEmail;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.currentUsers != null) {
                data.currentUsers = this.currentUsers;
            }
            if (this.maxUsers != null) {
                data.maxUsers = this.maxUsers;
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(2, this.status);
            if (this.ownerName.length)
                writer.writeString(3, this.ownerName);
            if (this.ownerEmail.length)
                writer.writeString(4, this.ownerEmail);
            if (this.planName.length)
                writer.writeString(5, this.planName);
            if (this.currentUsers != 0)
                writer.writeInt32(6, this.currentUsers);
            if (this.maxUsers != 0)
                writer.writeInt32(7, this.maxUsers);
            for (const [key, value] of this.metadata) {
                writer.writeMessage(8, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCreatedAt)
                writer.writeMessage(9, this.createdAt, () => this.createdAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionSlim {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionSlim();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.status = reader.readEnum();
                        break;
                    case 3:
                        message.ownerName = reader.readString();
                        break;
                    case 4:
                        message.ownerEmail = reader.readString();
                        break;
                    case 5:
                        message.planName = reader.readString();
                        break;
                    case 6:
                        message.currentUsers = reader.readInt32();
                        break;
                    case 7:
                        message.maxUsers = reader.readInt32();
                        break;
                    case 8:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 9:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionSlim {
            return SubscriptionSlim.deserialize(bytes);
        }
    }
    export class ListSubscriptionsSlimResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptions?: SubscriptionSlim[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptions" in data && data.subscriptions != undefined) {
                    this.subscriptions = data.subscriptions;
                }
            }
        }
        get subscriptions() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionSlim, 1) as SubscriptionSlim[];
        }
        set subscriptions(value: SubscriptionSlim[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            subscriptions?: ReturnType<typeof SubscriptionSlim.prototype.toObject>[];
        }): ListSubscriptionsSlimResponse {
            const message = new ListSubscriptionsSlimResponse({});
            if (data.subscriptions != null) {
                message.subscriptions = data.subscriptions.map(item => SubscriptionSlim.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptions?: ReturnType<typeof SubscriptionSlim.prototype.toObject>[];
            } = {};
            if (this.subscriptions != null) {
                data.subscriptions = this.subscriptions.map((item: SubscriptionSlim) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptions.length)
                writer.writeRepeatedMessage(1, this.subscriptions, (item: SubscriptionSlim) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionsSlimResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionsSlimResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.subscriptions, () => pb_1.Message.addToRepeatedWrapperField(message, 1, SubscriptionSlim.deserialize(reader), SubscriptionSlim));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionsSlimResponse {
            return ListSubscriptionsSlimResponse.deserialize(bytes);
        }
    }
    export class GetSubscriptionDetailsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetSubscriptionDetailsRequest {
            const message = new GetSubscriptionDetailsRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionDetailsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionDetailsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionDetailsRequest {
            return GetSubscriptionDetailsRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionDetailsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[5], [10], [13], [14]];
        constructor(data?: any[] | ({
            subscriptionId?: string;
            plan?: Plan;
            cycles?: Cycle[];
            currentCycle?: Cycle;
            metadata?: Map<string, string>;
            source?: SubscriptionSource;
            status?: Status;
            members?: dependency_5.subscriptions.v1.SubscriptionMember[];
            amount?: number;
            paymentLabel?: string;
        } & (({
            paymentInfo?: dependency_3.payments.v1.PaymentDetails;
        }) | ({
            finishDate?: string;
        }) | ({
            nextChargeDate?: string;
        }) | ({
            canceledAt?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3, 9], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
                if ("cycles" in data && data.cycles != undefined) {
                    this.cycles = data.cycles;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
                if ("paymentInfo" in data && data.paymentInfo != undefined) {
                    this.paymentInfo = data.paymentInfo;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("source" in data && data.source != undefined) {
                    this.source = data.source;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("members" in data && data.members != undefined) {
                    this.members = data.members;
                }
                if ("finishDate" in data && data.finishDate != undefined) {
                    this.finishDate = data.finishDate;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("paymentLabel" in data && data.paymentLabel != undefined) {
                    this.paymentLabel = data.paymentLabel;
                }
                if ("nextChargeDate" in data && data.nextChargeDate != undefined) {
                    this.nextChargeDate = data.nextChargeDate;
                }
                if ("canceledAt" in data && data.canceledAt != undefined) {
                    this.canceledAt = data.canceledAt;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 2) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get cycles() {
            return pb_1.Message.getRepeatedWrapperField(this, Cycle, 3) as Cycle[];
        }
        set cycles(value: Cycle[]) {
            pb_1.Message.setRepeatedWrapperField(this, 3, value);
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, Cycle, 4) as Cycle;
        }
        set currentCycle(value: Cycle) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get paymentInfo() {
            return pb_1.Message.getWrapperField(this, dependency_3.payments.v1.PaymentDetails, 5) as dependency_3.payments.v1.PaymentDetails;
        }
        set paymentInfo(value: dependency_3.payments.v1.PaymentDetails) {
            pb_1.Message.setOneofWrapperField(this, 5, this.#one_of_decls[0], value);
        }
        get hasPaymentInfo() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get metadata() {
            return pb_1.Message.getField(this, 6) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 6, value as any);
        }
        get source() {
            return pb_1.Message.getFieldWithDefault(this, 7, SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED) as SubscriptionSource;
        }
        set source(value: SubscriptionSource) {
            pb_1.Message.setField(this, 7, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 8, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 8, value);
        }
        get members() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_5.subscriptions.v1.SubscriptionMember, 9) as dependency_5.subscriptions.v1.SubscriptionMember[];
        }
        set members(value: dependency_5.subscriptions.v1.SubscriptionMember[]) {
            pb_1.Message.setRepeatedWrapperField(this, 9, value);
        }
        get finishDate() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set finishDate(value: string) {
            pb_1.Message.setOneofField(this, 10, this.#one_of_decls[1], value);
        }
        get hasFinishDate() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 11, value);
        }
        get paymentLabel() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set paymentLabel(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get nextChargeDate() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set nextChargeDate(value: string) {
            pb_1.Message.setOneofField(this, 13, this.#one_of_decls[2], value);
        }
        get hasNextChargeDate() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get canceledAt() {
            return pb_1.Message.getFieldWithDefault(this, 14, "") as string;
        }
        set canceledAt(value: string) {
            pb_1.Message.setOneofField(this, 14, this.#one_of_decls[3], value);
        }
        get hasCanceledAt() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get _payment_info() {
            const cases: {
                [index: number]: "none" | "paymentInfo";
            } = {
                0: "none",
                5: "paymentInfo"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        get _finish_date() {
            const cases: {
                [index: number]: "none" | "finishDate";
            } = {
                0: "none",
                10: "finishDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [10])];
        }
        get _next_charge_date() {
            const cases: {
                [index: number]: "none" | "nextChargeDate";
            } = {
                0: "none",
                13: "nextChargeDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [13])];
        }
        get _canceled_at() {
            const cases: {
                [index: number]: "none" | "canceledAt";
            } = {
                0: "none",
                14: "canceledAt"
            };
            return cases[pb_1.Message.computeOneofCase(this, [14])];
        }
        static fromObject(data: {
            subscriptionId?: string;
            plan?: ReturnType<typeof Plan.prototype.toObject>;
            cycles?: ReturnType<typeof Cycle.prototype.toObject>[];
            currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
            paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
            metadata?: {
                [key: string]: string;
            };
            source?: SubscriptionSource;
            status?: Status;
            members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
            finishDate?: string;
            amount?: number;
            paymentLabel?: string;
            nextChargeDate?: string;
            canceledAt?: string;
        }): GetSubscriptionDetailsResponse {
            const message = new GetSubscriptionDetailsResponse({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            if (data.cycles != null) {
                message.cycles = data.cycles.map(item => Cycle.fromObject(item));
            }
            if (data.currentCycle != null) {
                message.currentCycle = Cycle.fromObject(data.currentCycle);
            }
            if (data.paymentInfo != null) {
                message.paymentInfo = dependency_3.payments.v1.PaymentDetails.fromObject(data.paymentInfo);
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.source != null) {
                message.source = data.source;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.members != null) {
                message.members = data.members.map(item => dependency_5.subscriptions.v1.SubscriptionMember.fromObject(item));
            }
            if (data.finishDate != null) {
                message.finishDate = data.finishDate;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.paymentLabel != null) {
                message.paymentLabel = data.paymentLabel;
            }
            if (data.nextChargeDate != null) {
                message.nextChargeDate = data.nextChargeDate;
            }
            if (data.canceledAt != null) {
                message.canceledAt = data.canceledAt;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                plan?: ReturnType<typeof Plan.prototype.toObject>;
                cycles?: ReturnType<typeof Cycle.prototype.toObject>[];
                currentCycle?: ReturnType<typeof Cycle.prototype.toObject>;
                paymentInfo?: ReturnType<typeof dependency_3.payments.v1.PaymentDetails.prototype.toObject>;
                metadata?: {
                    [key: string]: string;
                };
                source?: SubscriptionSource;
                status?: Status;
                members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
                finishDate?: string;
                amount?: number;
                paymentLabel?: string;
                nextChargeDate?: string;
                canceledAt?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            if (this.cycles != null) {
                data.cycles = this.cycles.map((item: Cycle) => item.toObject());
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            if (this.paymentInfo != null) {
                data.paymentInfo = this.paymentInfo.toObject();
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.source != null) {
                data.source = this.source;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.members != null) {
                data.members = this.members.map((item: dependency_5.subscriptions.v1.SubscriptionMember) => item.toObject());
            }
            if (this.finishDate != null) {
                data.finishDate = this.finishDate;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.paymentLabel != null) {
                data.paymentLabel = this.paymentLabel;
            }
            if (this.nextChargeDate != null) {
                data.nextChargeDate = this.nextChargeDate;
            }
            if (this.canceledAt != null) {
                data.canceledAt = this.canceledAt;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.hasPlan)
                writer.writeMessage(2, this.plan, () => this.plan.serialize(writer));
            if (this.cycles.length)
                writer.writeRepeatedMessage(3, this.cycles, (item: Cycle) => item.serialize(writer));
            if (this.hasCurrentCycle)
                writer.writeMessage(4, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (this.hasPaymentInfo)
                writer.writeMessage(5, this.paymentInfo, () => this.paymentInfo.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(6, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.source != SubscriptionSource.SUBSCRIPTION_SOURCE_UNSPECIFIED)
                writer.writeEnum(7, this.source);
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(8, this.status);
            if (this.members.length)
                writer.writeRepeatedMessage(9, this.members, (item: dependency_5.subscriptions.v1.SubscriptionMember) => item.serialize(writer));
            if (this.hasFinishDate)
                writer.writeString(10, this.finishDate);
            if (this.amount != 0)
                writer.writeInt64(11, this.amount);
            if (this.paymentLabel.length)
                writer.writeString(12, this.paymentLabel);
            if (this.hasNextChargeDate)
                writer.writeString(13, this.nextChargeDate);
            if (this.hasCanceledAt)
                writer.writeString(14, this.canceledAt);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionDetailsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionDetailsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.cycles, () => pb_1.Message.addToRepeatedWrapperField(message, 3, Cycle.deserialize(reader), Cycle));
                        break;
                    case 4:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = Cycle.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.paymentInfo, () => message.paymentInfo = dependency_3.payments.v1.PaymentDetails.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 7:
                        message.source = reader.readEnum();
                        break;
                    case 8:
                        message.status = reader.readEnum();
                        break;
                    case 9:
                        reader.readMessage(message.members, () => pb_1.Message.addToRepeatedWrapperField(message, 9, dependency_5.subscriptions.v1.SubscriptionMember.deserialize(reader), dependency_5.subscriptions.v1.SubscriptionMember));
                        break;
                    case 10:
                        message.finishDate = reader.readString();
                        break;
                    case 11:
                        message.amount = reader.readInt64();
                        break;
                    case 12:
                        message.paymentLabel = reader.readString();
                        break;
                    case 13:
                        message.nextChargeDate = reader.readString();
                        break;
                    case 14:
                        message.canceledAt = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionDetailsResponse {
            return GetSubscriptionDetailsResponse.deserialize(bytes);
        }
    }
    export class GetPartnerSubscriptionDetailsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
        }): GetPartnerSubscriptionDetailsRequest {
            const message = new GetPartnerSubscriptionDetailsRequest({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPartnerSubscriptionDetailsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPartnerSubscriptionDetailsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPartnerSubscriptionDetailsRequest {
            return GetPartnerSubscriptionDetailsRequest.deserialize(bytes);
        }
    }
    export class PartnerCycle extends pb_1.Message {
        #one_of_decls: number[][] = [[3]];
        constructor(data?: any[] | ({
            id?: string;
            startDate?: string;
            status?: CycleStatus;
            planName?: string;
            amount?: number;
        } & (({
            endDate?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get startDate() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set startDate(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get endDate() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set endDate(value: string) {
            pb_1.Message.setOneofField(this, 3, this.#one_of_decls[0], value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 4, CycleStatus.CYCLE_STATUS_UNSPECIFIED) as CycleStatus;
        }
        set status(value: CycleStatus) {
            pb_1.Message.setField(this, 4, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get _end_date() {
            const cases: {
                [index: number]: "none" | "endDate";
            } = {
                0: "none",
                3: "endDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        static fromObject(data: {
            id?: string;
            startDate?: string;
            endDate?: string;
            status?: CycleStatus;
            planName?: string;
            amount?: number;
        }): PartnerCycle {
            const message = new PartnerCycle({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.startDate != null) {
                message.startDate = data.startDate;
            }
            if (data.endDate != null) {
                message.endDate = data.endDate;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                startDate?: string;
                endDate?: string;
                status?: CycleStatus;
                planName?: string;
                amount?: number;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.startDate != null) {
                data.startDate = this.startDate;
            }
            if (this.endDate != null) {
                data.endDate = this.endDate;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.startDate.length)
                writer.writeString(2, this.startDate);
            if (this.hasEndDate)
                writer.writeString(3, this.endDate);
            if (this.status != CycleStatus.CYCLE_STATUS_UNSPECIFIED)
                writer.writeEnum(4, this.status);
            if (this.planName.length)
                writer.writeString(5, this.planName);
            if (this.amount != 0)
                writer.writeInt64(6, this.amount);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PartnerCycle {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PartnerCycle();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.startDate = reader.readString();
                        break;
                    case 3:
                        message.endDate = reader.readString();
                        break;
                    case 4:
                        message.status = reader.readEnum();
                        break;
                    case 5:
                        message.planName = reader.readString();
                        break;
                    case 6:
                        message.amount = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PartnerCycle {
            return PartnerCycle.deserialize(bytes);
        }
    }
    export class GetPartnerSubscriptionDetailsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [[12]];
        constructor(data?: any[] | ({
            subscriptionId?: string;
            userId?: string;
            name?: string;
            email?: string;
            plan?: Plan;
            status?: Status;
            amount?: number;
            members?: dependency_5.subscriptions.v1.SubscriptionMember[];
            currentCycle?: PartnerCycle;
            cycles?: PartnerCycle[];
            metadata?: Map<string, string>;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
        } & (({
            canceledAt?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [8, 10], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("members" in data && data.members != undefined) {
                    this.members = data.members;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
                if ("cycles" in data && data.cycles != undefined) {
                    this.cycles = data.cycles;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("canceledAt" in data && data.canceledAt != undefined) {
                    this.canceledAt = data.canceledAt;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 5) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 6, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get members() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_5.subscriptions.v1.SubscriptionMember, 8) as dependency_5.subscriptions.v1.SubscriptionMember[];
        }
        set members(value: dependency_5.subscriptions.v1.SubscriptionMember[]) {
            pb_1.Message.setRepeatedWrapperField(this, 8, value);
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, PartnerCycle, 9) as PartnerCycle;
        }
        set currentCycle(value: PartnerCycle) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get cycles() {
            return pb_1.Message.getRepeatedWrapperField(this, PartnerCycle, 10) as PartnerCycle[];
        }
        set cycles(value: PartnerCycle[]) {
            pb_1.Message.setRepeatedWrapperField(this, 10, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 11) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 11, value as any);
        }
        get canceledAt() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set canceledAt(value: string) {
            pb_1.Message.setOneofField(this, 12, this.#one_of_decls[0], value);
        }
        get hasCanceledAt() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 13) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 13, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 14) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 14, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get _canceled_at() {
            const cases: {
                [index: number]: "none" | "canceledAt";
            } = {
                0: "none",
                12: "canceledAt"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        static fromObject(data: {
            subscriptionId?: string;
            userId?: string;
            name?: string;
            email?: string;
            plan?: ReturnType<typeof Plan.prototype.toObject>;
            status?: Status;
            amount?: number;
            members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
            currentCycle?: ReturnType<typeof PartnerCycle.prototype.toObject>;
            cycles?: ReturnType<typeof PartnerCycle.prototype.toObject>[];
            metadata?: {
                [key: string]: string;
            };
            canceledAt?: string;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): GetPartnerSubscriptionDetailsResponse {
            const message = new GetPartnerSubscriptionDetailsResponse({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.members != null) {
                message.members = data.members.map(item => dependency_5.subscriptions.v1.SubscriptionMember.fromObject(item));
            }
            if (data.currentCycle != null) {
                message.currentCycle = PartnerCycle.fromObject(data.currentCycle);
            }
            if (data.cycles != null) {
                message.cycles = data.cycles.map(item => PartnerCycle.fromObject(item));
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.canceledAt != null) {
                message.canceledAt = data.canceledAt;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                userId?: string;
                name?: string;
                email?: string;
                plan?: ReturnType<typeof Plan.prototype.toObject>;
                status?: Status;
                amount?: number;
                members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
                currentCycle?: ReturnType<typeof PartnerCycle.prototype.toObject>;
                cycles?: ReturnType<typeof PartnerCycle.prototype.toObject>[];
                metadata?: {
                    [key: string]: string;
                };
                canceledAt?: string;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.members != null) {
                data.members = this.members.map((item: dependency_5.subscriptions.v1.SubscriptionMember) => item.toObject());
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            if (this.cycles != null) {
                data.cycles = this.cycles.map((item: PartnerCycle) => item.toObject());
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.canceledAt != null) {
                data.canceledAt = this.canceledAt;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.name.length)
                writer.writeString(3, this.name);
            if (this.email.length)
                writer.writeString(4, this.email);
            if (this.hasPlan)
                writer.writeMessage(5, this.plan, () => this.plan.serialize(writer));
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(6, this.status);
            if (this.amount != 0)
                writer.writeInt64(7, this.amount);
            if (this.members.length)
                writer.writeRepeatedMessage(8, this.members, (item: dependency_5.subscriptions.v1.SubscriptionMember) => item.serialize(writer));
            if (this.hasCurrentCycle)
                writer.writeMessage(9, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (this.cycles.length)
                writer.writeRepeatedMessage(10, this.cycles, (item: PartnerCycle) => item.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(11, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCanceledAt)
                writer.writeString(12, this.canceledAt);
            if (this.hasCreatedAt)
                writer.writeMessage(13, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(14, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetPartnerSubscriptionDetailsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetPartnerSubscriptionDetailsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        message.name = reader.readString();
                        break;
                    case 4:
                        message.email = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    case 6:
                        message.status = reader.readEnum();
                        break;
                    case 7:
                        message.amount = reader.readInt64();
                        break;
                    case 8:
                        reader.readMessage(message.members, () => pb_1.Message.addToRepeatedWrapperField(message, 8, dependency_5.subscriptions.v1.SubscriptionMember.deserialize(reader), dependency_5.subscriptions.v1.SubscriptionMember));
                        break;
                    case 9:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = PartnerCycle.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.cycles, () => pb_1.Message.addToRepeatedWrapperField(message, 10, PartnerCycle.deserialize(reader), PartnerCycle));
                        break;
                    case 11:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 12:
                        message.canceledAt = reader.readString();
                        break;
                    case 13:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 14:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetPartnerSubscriptionDetailsResponse {
            return GetPartnerSubscriptionDetailsResponse.deserialize(bytes);
        }
    }
    export class ListPartnerSubscriptionsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[2], [3], [4]];
        constructor(data?: any[] | ({
            status?: Status[];
            page?: number;
            pageSize?: number;
        } & (({
            createdAfter?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            createdBefore?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            canceled?: boolean;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("createdAfter" in data && data.createdAfter != undefined) {
                    this.createdAfter = data.createdAfter;
                }
                if ("createdBefore" in data && data.createdBefore != undefined) {
                    this.createdBefore = data.createdBefore;
                }
                if ("canceled" in data && data.canceled != undefined) {
                    this.canceled = data.canceled;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
            }
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as Status[];
        }
        set status(value: Status[]) {
            pb_1.Message.setField(this, 1, value);
        }
        get createdAfter() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAfter(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[0], value);
        }
        get hasCreatedAfter() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get createdBefore() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 3) as dependency_2.google.protobuf.Timestamp;
        }
        set createdBefore(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[1], value);
        }
        get hasCreatedBefore() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get canceled() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set canceled(value: boolean) {
            pb_1.Message.setOneofField(this, 4, this.#one_of_decls[2], value);
        }
        get hasCanceled() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get _created_after() {
            const cases: {
                [index: number]: "none" | "createdAfter";
            } = {
                0: "none",
                2: "createdAfter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _created_before() {
            const cases: {
                [index: number]: "none" | "createdBefore";
            } = {
                0: "none",
                3: "createdBefore"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _canceled() {
            const cases: {
                [index: number]: "none" | "canceled";
            } = {
                0: "none",
                4: "canceled"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        static fromObject(data: {
            status?: Status[];
            createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            canceled?: boolean;
            page?: number;
            pageSize?: number;
        }): ListPartnerSubscriptionsRequest {
            const message = new ListPartnerSubscriptionsRequest({});
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.createdAfter != null) {
                message.createdAfter = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAfter);
            }
            if (data.createdBefore != null) {
                message.createdBefore = dependency_2.google.protobuf.Timestamp.fromObject(data.createdBefore);
            }
            if (data.canceled != null) {
                message.canceled = data.canceled;
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            return message;
        }
        toObject() {
            const data: {
                status?: Status[];
                createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                canceled?: boolean;
                page?: number;
                pageSize?: number;
            } = {};
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.createdAfter != null) {
                data.createdAfter = this.createdAfter.toObject();
            }
            if (this.createdBefore != null) {
                data.createdBefore = this.createdBefore.toObject();
            }
            if (this.canceled != null) {
                data.canceled = this.canceled;
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.status.length)
                writer.writePackedEnum(1, this.status);
            if (this.hasCreatedAfter)
                writer.writeMessage(2, this.createdAfter, () => this.createdAfter.serialize(writer));
            if (this.hasCreatedBefore)
                writer.writeMessage(3, this.createdBefore, () => this.createdBefore.serialize(writer));
            if (this.hasCanceled)
                writer.writeBool(4, this.canceled);
            if (this.page != 0)
                writer.writeInt64(5, this.page);
            if (this.pageSize != 0)
                writer.writeInt64(6, this.pageSize);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPartnerSubscriptionsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPartnerSubscriptionsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.status = reader.readPackedEnum();
                        break;
                    case 2:
                        reader.readMessage(message.createdAfter, () => message.createdAfter = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.createdBefore, () => message.createdBefore = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        message.canceled = reader.readBool();
                        break;
                    case 5:
                        message.page = reader.readInt64();
                        break;
                    case 6:
                        message.pageSize = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPartnerSubscriptionsRequest {
            return ListPartnerSubscriptionsRequest.deserialize(bytes);
        }
    }
    export class PartnerSubscription extends pb_1.Message {
        #one_of_decls: number[][] = [[12]];
        constructor(data?: any[] | ({
            subscriptionId?: string;
            userId?: string;
            name?: string;
            email?: string;
            plan?: Plan;
            status?: Status;
            amount?: number;
            members?: dependency_5.subscriptions.v1.SubscriptionMember[];
            currentCycle?: PartnerCycle;
            cycles?: PartnerCycle[];
            metadata?: Map<string, string>;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
        } & (({
            canceledAt?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [8, 10], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("plan" in data && data.plan != undefined) {
                    this.plan = data.plan;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("members" in data && data.members != undefined) {
                    this.members = data.members;
                }
                if ("currentCycle" in data && data.currentCycle != undefined) {
                    this.currentCycle = data.currentCycle;
                }
                if ("cycles" in data && data.cycles != undefined) {
                    this.cycles = data.cycles;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("canceledAt" in data && data.canceledAt != undefined) {
                    this.canceledAt = data.canceledAt;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
            }
            if (!this.metadata)
                this.metadata = new Map();
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get plan() {
            return pb_1.Message.getWrapperField(this, Plan, 5) as Plan;
        }
        set plan(value: Plan) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasPlan() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 6, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 6, value);
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get members() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_5.subscriptions.v1.SubscriptionMember, 8) as dependency_5.subscriptions.v1.SubscriptionMember[];
        }
        set members(value: dependency_5.subscriptions.v1.SubscriptionMember[]) {
            pb_1.Message.setRepeatedWrapperField(this, 8, value);
        }
        get currentCycle() {
            return pb_1.Message.getWrapperField(this, PartnerCycle, 9) as PartnerCycle;
        }
        set currentCycle(value: PartnerCycle) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasCurrentCycle() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get cycles() {
            return pb_1.Message.getRepeatedWrapperField(this, PartnerCycle, 10) as PartnerCycle[];
        }
        set cycles(value: PartnerCycle[]) {
            pb_1.Message.setRepeatedWrapperField(this, 10, value);
        }
        get metadata() {
            return pb_1.Message.getField(this, 11) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 11, value as any);
        }
        get canceledAt() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set canceledAt(value: string) {
            pb_1.Message.setOneofField(this, 12, this.#one_of_decls[0], value);
        }
        get hasCanceledAt() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 13) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 13, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 13) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 14) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 14, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 14) != null;
        }
        get _canceled_at() {
            const cases: {
                [index: number]: "none" | "canceledAt";
            } = {
                0: "none",
                12: "canceledAt"
            };
            return cases[pb_1.Message.computeOneofCase(this, [12])];
        }
        static fromObject(data: {
            subscriptionId?: string;
            userId?: string;
            name?: string;
            email?: string;
            plan?: ReturnType<typeof Plan.prototype.toObject>;
            status?: Status;
            amount?: number;
            members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
            currentCycle?: ReturnType<typeof PartnerCycle.prototype.toObject>;
            cycles?: ReturnType<typeof PartnerCycle.prototype.toObject>[];
            metadata?: {
                [key: string]: string;
            };
            canceledAt?: string;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): PartnerSubscription {
            const message = new PartnerSubscription({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.plan != null) {
                message.plan = Plan.fromObject(data.plan);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.members != null) {
                message.members = data.members.map(item => dependency_5.subscriptions.v1.SubscriptionMember.fromObject(item));
            }
            if (data.currentCycle != null) {
                message.currentCycle = PartnerCycle.fromObject(data.currentCycle);
            }
            if (data.cycles != null) {
                message.cycles = data.cycles.map(item => PartnerCycle.fromObject(item));
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.canceledAt != null) {
                message.canceledAt = data.canceledAt;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                userId?: string;
                name?: string;
                email?: string;
                plan?: ReturnType<typeof Plan.prototype.toObject>;
                status?: Status;
                amount?: number;
                members?: ReturnType<typeof dependency_5.subscriptions.v1.SubscriptionMember.prototype.toObject>[];
                currentCycle?: ReturnType<typeof PartnerCycle.prototype.toObject>;
                cycles?: ReturnType<typeof PartnerCycle.prototype.toObject>[];
                metadata?: {
                    [key: string]: string;
                };
                canceledAt?: string;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.plan != null) {
                data.plan = this.plan.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.members != null) {
                data.members = this.members.map((item: dependency_5.subscriptions.v1.SubscriptionMember) => item.toObject());
            }
            if (this.currentCycle != null) {
                data.currentCycle = this.currentCycle.toObject();
            }
            if (this.cycles != null) {
                data.cycles = this.cycles.map((item: PartnerCycle) => item.toObject());
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.canceledAt != null) {
                data.canceledAt = this.canceledAt;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.userId.length)
                writer.writeString(2, this.userId);
            if (this.name.length)
                writer.writeString(3, this.name);
            if (this.email.length)
                writer.writeString(4, this.email);
            if (this.hasPlan)
                writer.writeMessage(5, this.plan, () => this.plan.serialize(writer));
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(6, this.status);
            if (this.amount != 0)
                writer.writeInt64(7, this.amount);
            if (this.members.length)
                writer.writeRepeatedMessage(8, this.members, (item: dependency_5.subscriptions.v1.SubscriptionMember) => item.serialize(writer));
            if (this.hasCurrentCycle)
                writer.writeMessage(9, this.currentCycle, () => this.currentCycle.serialize(writer));
            if (this.cycles.length)
                writer.writeRepeatedMessage(10, this.cycles, (item: PartnerCycle) => item.serialize(writer));
            for (const [key, value] of this.metadata) {
                writer.writeMessage(11, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCanceledAt)
                writer.writeString(12, this.canceledAt);
            if (this.hasCreatedAt)
                writer.writeMessage(13, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(14, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PartnerSubscription {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PartnerSubscription();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.userId = reader.readString();
                        break;
                    case 3:
                        message.name = reader.readString();
                        break;
                    case 4:
                        message.email = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.plan, () => message.plan = Plan.deserialize(reader));
                        break;
                    case 6:
                        message.status = reader.readEnum();
                        break;
                    case 7:
                        message.amount = reader.readInt64();
                        break;
                    case 8:
                        reader.readMessage(message.members, () => pb_1.Message.addToRepeatedWrapperField(message, 8, dependency_5.subscriptions.v1.SubscriptionMember.deserialize(reader), dependency_5.subscriptions.v1.SubscriptionMember));
                        break;
                    case 9:
                        reader.readMessage(message.currentCycle, () => message.currentCycle = PartnerCycle.deserialize(reader));
                        break;
                    case 10:
                        reader.readMessage(message.cycles, () => pb_1.Message.addToRepeatedWrapperField(message, 10, PartnerCycle.deserialize(reader), PartnerCycle));
                        break;
                    case 11:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 12:
                        message.canceledAt = reader.readString();
                        break;
                    case 13:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 14:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PartnerSubscription {
            return PartnerSubscription.deserialize(bytes);
        }
    }
    export class ListPartnerSubscriptionsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            items?: PartnerSubscription[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("items" in data && data.items != undefined) {
                    this.items = data.items;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
            }
        }
        get items() {
            return pb_1.Message.getRepeatedWrapperField(this, PartnerSubscription, 1) as PartnerSubscription[];
        }
        set items(value: PartnerSubscription[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            items?: ReturnType<typeof PartnerSubscription.prototype.toObject>[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }): ListPartnerSubscriptionsResponse {
            const message = new ListPartnerSubscriptionsResponse({});
            if (data.items != null) {
                message.items = data.items.map(item => PartnerSubscription.fromObject(item));
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            return message;
        }
        toObject() {
            const data: {
                items?: ReturnType<typeof PartnerSubscription.prototype.toObject>[];
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            } = {};
            if (this.items != null) {
                data.items = this.items.map((item: PartnerSubscription) => item.toObject());
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.items.length)
                writer.writeRepeatedMessage(1, this.items, (item: PartnerSubscription) => item.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(2, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(4, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(5, this.hasPrev);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListPartnerSubscriptionsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListPartnerSubscriptionsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.items, () => pb_1.Message.addToRepeatedWrapperField(message, 1, PartnerSubscription.deserialize(reader), PartnerSubscription));
                        break;
                    case 2:
                        message.totalCount = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.hasNext = reader.readBool();
                        break;
                    case 5:
                        message.hasPrev = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListPartnerSubscriptionsResponse {
            return ListPartnerSubscriptionsResponse.deserialize(bytes);
        }
    }
    export class ActiveSubscribersReportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1], [2]];
        constructor(data?: any[] | ({} & (({
            startDate?: string;
        }) | ({
            endDate?: string;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
            }
        }
        get startDate() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set startDate(value: string) {
            pb_1.Message.setOneofField(this, 1, this.#one_of_decls[0], value);
        }
        get hasStartDate() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get endDate() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set endDate(value: string) {
            pb_1.Message.setOneofField(this, 2, this.#one_of_decls[1], value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get _start_date() {
            const cases: {
                [index: number]: "none" | "startDate";
            } = {
                0: "none",
                1: "startDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        get _end_date() {
            const cases: {
                [index: number]: "none" | "endDate";
            } = {
                0: "none",
                2: "endDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        static fromObject(data: {
            startDate?: string;
            endDate?: string;
        }): ActiveSubscribersReportRequest {
            const message = new ActiveSubscribersReportRequest({});
            if (data.startDate != null) {
                message.startDate = data.startDate;
            }
            if (data.endDate != null) {
                message.endDate = data.endDate;
            }
            return message;
        }
        toObject() {
            const data: {
                startDate?: string;
                endDate?: string;
            } = {};
            if (this.startDate != null) {
                data.startDate = this.startDate;
            }
            if (this.endDate != null) {
                data.endDate = this.endDate;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasStartDate)
                writer.writeString(1, this.startDate);
            if (this.hasEndDate)
                writer.writeString(2, this.endDate);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActiveSubscribersReportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ActiveSubscribersReportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.startDate = reader.readString();
                        break;
                    case 2:
                        message.endDate = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ActiveSubscribersReportRequest {
            return ActiveSubscribersReportRequest.deserialize(bytes);
        }
    }
    export class ActiveSubscribersReportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            items?: SubscribersReportItem[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("items" in data && data.items != undefined) {
                    this.items = data.items;
                }
            }
        }
        get items() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscribersReportItem, 1) as SubscribersReportItem[];
        }
        set items(value: SubscribersReportItem[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            items?: ReturnType<typeof SubscribersReportItem.prototype.toObject>[];
        }): ActiveSubscribersReportResponse {
            const message = new ActiveSubscribersReportResponse({});
            if (data.items != null) {
                message.items = data.items.map(item => SubscribersReportItem.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                items?: ReturnType<typeof SubscribersReportItem.prototype.toObject>[];
            } = {};
            if (this.items != null) {
                data.items = this.items.map((item: SubscribersReportItem) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.items.length)
                writer.writeRepeatedMessage(1, this.items, (item: SubscribersReportItem) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActiveSubscribersReportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ActiveSubscribersReportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.items, () => pb_1.Message.addToRepeatedWrapperField(message, 1, SubscribersReportItem.deserialize(reader), SubscribersReportItem));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ActiveSubscribersReportResponse {
            return ActiveSubscribersReportResponse.deserialize(bytes);
        }
    }
    export class SubscribersReportItem extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            date?: dependency_2.google.protobuf.Timestamp;
            url?: string;
            rowCount?: number;
            error?: string;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            updatedAt?: dependency_2.google.protobuf.Timestamp;
            totalUsers?: number;
            totalGeneral?: number;
            status?: SubscribersReportStatus;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("date" in data && data.date != undefined) {
                    this.date = data.date;
                }
                if ("url" in data && data.url != undefined) {
                    this.url = data.url;
                }
                if ("rowCount" in data && data.rowCount != undefined) {
                    this.rowCount = data.rowCount;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("totalUsers" in data && data.totalUsers != undefined) {
                    this.totalUsers = data.totalUsers;
                }
                if ("totalGeneral" in data && data.totalGeneral != undefined) {
                    this.totalGeneral = data.totalGeneral;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
            }
        }
        get date() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 1) as dependency_2.google.protobuf.Timestamp;
        }
        set date(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasDate() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get url() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set url(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get rowCount() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set rowCount(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get error() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set error(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 5) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get totalUsers() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set totalUsers(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get totalGeneral() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set totalGeneral(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 9, SubscribersReportStatus.SUBSCRIBERS_REPORT_STATUS_UNSPECIFIED) as SubscribersReportStatus;
        }
        set status(value: SubscribersReportStatus) {
            pb_1.Message.setField(this, 9, value);
        }
        static fromObject(data: {
            date?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            url?: string;
            rowCount?: number;
            error?: string;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            totalUsers?: number;
            totalGeneral?: number;
            status?: SubscribersReportStatus;
        }): SubscribersReportItem {
            const message = new SubscribersReportItem({});
            if (data.date != null) {
                message.date = dependency_2.google.protobuf.Timestamp.fromObject(data.date);
            }
            if (data.url != null) {
                message.url = data.url;
            }
            if (data.rowCount != null) {
                message.rowCount = data.rowCount;
            }
            if (data.error != null) {
                message.error = data.error;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.totalUsers != null) {
                message.totalUsers = data.totalUsers;
            }
            if (data.totalGeneral != null) {
                message.totalGeneral = data.totalGeneral;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            return message;
        }
        toObject() {
            const data: {
                date?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                url?: string;
                rowCount?: number;
                error?: string;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                totalUsers?: number;
                totalGeneral?: number;
                status?: SubscribersReportStatus;
            } = {};
            if (this.date != null) {
                data.date = this.date.toObject();
            }
            if (this.url != null) {
                data.url = this.url;
            }
            if (this.rowCount != null) {
                data.rowCount = this.rowCount;
            }
            if (this.error != null) {
                data.error = this.error;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.totalUsers != null) {
                data.totalUsers = this.totalUsers;
            }
            if (this.totalGeneral != null) {
                data.totalGeneral = this.totalGeneral;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasDate)
                writer.writeMessage(1, this.date, () => this.date.serialize(writer));
            if (this.url.length)
                writer.writeString(2, this.url);
            if (this.rowCount != 0)
                writer.writeInt64(3, this.rowCount);
            if (this.error.length)
                writer.writeString(4, this.error);
            if (this.hasCreatedAt)
                writer.writeMessage(5, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(6, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.totalUsers != 0)
                writer.writeInt64(7, this.totalUsers);
            if (this.totalGeneral != 0)
                writer.writeInt64(8, this.totalGeneral);
            if (this.status != SubscribersReportStatus.SUBSCRIBERS_REPORT_STATUS_UNSPECIFIED)
                writer.writeEnum(9, this.status);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscribersReportItem {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscribersReportItem();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.date, () => message.date = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 2:
                        message.url = reader.readString();
                        break;
                    case 3:
                        message.rowCount = reader.readInt64();
                        break;
                    case 4:
                        message.error = reader.readString();
                        break;
                    case 5:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 6:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.totalUsers = reader.readInt64();
                        break;
                    case 8:
                        message.totalGeneral = reader.readInt64();
                        break;
                    case 9:
                        message.status = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscribersReportItem {
            return SubscribersReportItem.deserialize(bytes);
        }
    }
    export class SubscriptionReportItem extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
            adminName?: string;
            adminEmail?: string;
            planName?: string;
            eventType?: SubscriptionEventType;
            amountPaid?: number;
            date?: dependency_2.google.protobuf.Timestamp;
            subscriptionStatus?: Status;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("adminName" in data && data.adminName != undefined) {
                    this.adminName = data.adminName;
                }
                if ("adminEmail" in data && data.adminEmail != undefined) {
                    this.adminEmail = data.adminEmail;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("eventType" in data && data.eventType != undefined) {
                    this.eventType = data.eventType;
                }
                if ("amountPaid" in data && data.amountPaid != undefined) {
                    this.amountPaid = data.amountPaid;
                }
                if ("date" in data && data.date != undefined) {
                    this.date = data.date;
                }
                if ("subscriptionStatus" in data && data.subscriptionStatus != undefined) {
                    this.subscriptionStatus = data.subscriptionStatus;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get adminName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set adminName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get adminEmail() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set adminEmail(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get eventType() {
            return pb_1.Message.getFieldWithDefault(this, 5, SubscriptionEventType.SUBSCRIPTION_EVENT_TYPE_UNSPECIFIED) as SubscriptionEventType;
        }
        set eventType(value: SubscriptionEventType) {
            pb_1.Message.setField(this, 5, value);
        }
        get amountPaid() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set amountPaid(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get date() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 7) as dependency_2.google.protobuf.Timestamp;
        }
        set date(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasDate() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get subscriptionStatus() {
            return pb_1.Message.getFieldWithDefault(this, 8, Status.STATUS_UNSPECIFIED) as Status;
        }
        set subscriptionStatus(value: Status) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            subscriptionId?: string;
            adminName?: string;
            adminEmail?: string;
            planName?: string;
            eventType?: SubscriptionEventType;
            amountPaid?: number;
            date?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            subscriptionStatus?: Status;
        }): SubscriptionReportItem {
            const message = new SubscriptionReportItem({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.adminName != null) {
                message.adminName = data.adminName;
            }
            if (data.adminEmail != null) {
                message.adminEmail = data.adminEmail;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.eventType != null) {
                message.eventType = data.eventType;
            }
            if (data.amountPaid != null) {
                message.amountPaid = data.amountPaid;
            }
            if (data.date != null) {
                message.date = dependency_2.google.protobuf.Timestamp.fromObject(data.date);
            }
            if (data.subscriptionStatus != null) {
                message.subscriptionStatus = data.subscriptionStatus;
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                adminName?: string;
                adminEmail?: string;
                planName?: string;
                eventType?: SubscriptionEventType;
                amountPaid?: number;
                date?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                subscriptionStatus?: Status;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.adminName != null) {
                data.adminName = this.adminName;
            }
            if (this.adminEmail != null) {
                data.adminEmail = this.adminEmail;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.eventType != null) {
                data.eventType = this.eventType;
            }
            if (this.amountPaid != null) {
                data.amountPaid = this.amountPaid;
            }
            if (this.date != null) {
                data.date = this.date.toObject();
            }
            if (this.subscriptionStatus != null) {
                data.subscriptionStatus = this.subscriptionStatus;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.adminName.length)
                writer.writeString(2, this.adminName);
            if (this.adminEmail.length)
                writer.writeString(3, this.adminEmail);
            if (this.planName.length)
                writer.writeString(4, this.planName);
            if (this.eventType != SubscriptionEventType.SUBSCRIPTION_EVENT_TYPE_UNSPECIFIED)
                writer.writeEnum(5, this.eventType);
            if (this.amountPaid != 0)
                writer.writeInt64(6, this.amountPaid);
            if (this.hasDate)
                writer.writeMessage(7, this.date, () => this.date.serialize(writer));
            if (this.subscriptionStatus != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(8, this.subscriptionStatus);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionReportItem {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionReportItem();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.adminName = reader.readString();
                        break;
                    case 3:
                        message.adminEmail = reader.readString();
                        break;
                    case 4:
                        message.planName = reader.readString();
                        break;
                    case 5:
                        message.eventType = reader.readEnum();
                        break;
                    case 6:
                        message.amountPaid = reader.readInt64();
                        break;
                    case 7:
                        reader.readMessage(message.date, () => message.date = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 8:
                        message.subscriptionStatus = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionReportItem {
            return SubscriptionReportItem.deserialize(bytes);
        }
    }
    export class SubscriptionReportSummary extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            totalSubscribers?: number;
            newPurchases?: number;
            renewals?: number;
            newPurchasesPercentage?: number;
            renewalsPercentage?: number;
            totalRevenue?: number;
            avgTicketCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("totalSubscribers" in data && data.totalSubscribers != undefined) {
                    this.totalSubscribers = data.totalSubscribers;
                }
                if ("newPurchases" in data && data.newPurchases != undefined) {
                    this.newPurchases = data.newPurchases;
                }
                if ("renewals" in data && data.renewals != undefined) {
                    this.renewals = data.renewals;
                }
                if ("newPurchasesPercentage" in data && data.newPurchasesPercentage != undefined) {
                    this.newPurchasesPercentage = data.newPurchasesPercentage;
                }
                if ("renewalsPercentage" in data && data.renewalsPercentage != undefined) {
                    this.renewalsPercentage = data.renewalsPercentage;
                }
                if ("totalRevenue" in data && data.totalRevenue != undefined) {
                    this.totalRevenue = data.totalRevenue;
                }
                if ("avgTicketCents" in data && data.avgTicketCents != undefined) {
                    this.avgTicketCents = data.avgTicketCents;
                }
            }
        }
        get totalSubscribers() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set totalSubscribers(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get newPurchases() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set newPurchases(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get renewals() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set renewals(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get newPurchasesPercentage() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set newPurchasesPercentage(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get renewalsPercentage() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set renewalsPercentage(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get totalRevenue() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set totalRevenue(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get avgTicketCents() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set avgTicketCents(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            totalSubscribers?: number;
            newPurchases?: number;
            renewals?: number;
            newPurchasesPercentage?: number;
            renewalsPercentage?: number;
            totalRevenue?: number;
            avgTicketCents?: number;
        }): SubscriptionReportSummary {
            const message = new SubscriptionReportSummary({});
            if (data.totalSubscribers != null) {
                message.totalSubscribers = data.totalSubscribers;
            }
            if (data.newPurchases != null) {
                message.newPurchases = data.newPurchases;
            }
            if (data.renewals != null) {
                message.renewals = data.renewals;
            }
            if (data.newPurchasesPercentage != null) {
                message.newPurchasesPercentage = data.newPurchasesPercentage;
            }
            if (data.renewalsPercentage != null) {
                message.renewalsPercentage = data.renewalsPercentage;
            }
            if (data.totalRevenue != null) {
                message.totalRevenue = data.totalRevenue;
            }
            if (data.avgTicketCents != null) {
                message.avgTicketCents = data.avgTicketCents;
            }
            return message;
        }
        toObject() {
            const data: {
                totalSubscribers?: number;
                newPurchases?: number;
                renewals?: number;
                newPurchasesPercentage?: number;
                renewalsPercentage?: number;
                totalRevenue?: number;
                avgTicketCents?: number;
            } = {};
            if (this.totalSubscribers != null) {
                data.totalSubscribers = this.totalSubscribers;
            }
            if (this.newPurchases != null) {
                data.newPurchases = this.newPurchases;
            }
            if (this.renewals != null) {
                data.renewals = this.renewals;
            }
            if (this.newPurchasesPercentage != null) {
                data.newPurchasesPercentage = this.newPurchasesPercentage;
            }
            if (this.renewalsPercentage != null) {
                data.renewalsPercentage = this.renewalsPercentage;
            }
            if (this.totalRevenue != null) {
                data.totalRevenue = this.totalRevenue;
            }
            if (this.avgTicketCents != null) {
                data.avgTicketCents = this.avgTicketCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.totalSubscribers != 0)
                writer.writeInt32(1, this.totalSubscribers);
            if (this.newPurchases != 0)
                writer.writeInt32(2, this.newPurchases);
            if (this.renewals != 0)
                writer.writeInt32(3, this.renewals);
            if (this.newPurchasesPercentage != 0)
                writer.writeFloat(4, this.newPurchasesPercentage);
            if (this.renewalsPercentage != 0)
                writer.writeFloat(5, this.renewalsPercentage);
            if (this.totalRevenue != 0)
                writer.writeInt64(6, this.totalRevenue);
            if (this.avgTicketCents != 0)
                writer.writeInt64(7, this.avgTicketCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionReportSummary {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionReportSummary();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.totalSubscribers = reader.readInt32();
                        break;
                    case 2:
                        message.newPurchases = reader.readInt32();
                        break;
                    case 3:
                        message.renewals = reader.readInt32();
                        break;
                    case 4:
                        message.newPurchasesPercentage = reader.readFloat();
                        break;
                    case 5:
                        message.renewalsPercentage = reader.readFloat();
                        break;
                    case 6:
                        message.totalRevenue = reader.readInt64();
                        break;
                    case 7:
                        message.avgTicketCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionReportSummary {
            return SubscriptionReportSummary.deserialize(bytes);
        }
    }
    export class SubscriptionSnapshot extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            activeCount?: number;
            pastDueCount?: number;
            canceledCount?: number;
            pausedCount?: number;
            expiredCount?: number;
            freeCount?: number;
            courtesyCount?: number;
            legacyCount?: number;
            estimatedMrrCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("activeCount" in data && data.activeCount != undefined) {
                    this.activeCount = data.activeCount;
                }
                if ("pastDueCount" in data && data.pastDueCount != undefined) {
                    this.pastDueCount = data.pastDueCount;
                }
                if ("canceledCount" in data && data.canceledCount != undefined) {
                    this.canceledCount = data.canceledCount;
                }
                if ("pausedCount" in data && data.pausedCount != undefined) {
                    this.pausedCount = data.pausedCount;
                }
                if ("expiredCount" in data && data.expiredCount != undefined) {
                    this.expiredCount = data.expiredCount;
                }
                if ("freeCount" in data && data.freeCount != undefined) {
                    this.freeCount = data.freeCount;
                }
                if ("courtesyCount" in data && data.courtesyCount != undefined) {
                    this.courtesyCount = data.courtesyCount;
                }
                if ("legacyCount" in data && data.legacyCount != undefined) {
                    this.legacyCount = data.legacyCount;
                }
                if ("estimatedMrrCents" in data && data.estimatedMrrCents != undefined) {
                    this.estimatedMrrCents = data.estimatedMrrCents;
                }
            }
        }
        get activeCount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set activeCount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get pastDueCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set pastDueCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get canceledCount() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set canceledCount(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get pausedCount() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set pausedCount(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get expiredCount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set expiredCount(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get freeCount() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set freeCount(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get courtesyCount() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set courtesyCount(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get legacyCount() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set legacyCount(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        get estimatedMrrCents() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set estimatedMrrCents(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        static fromObject(data: {
            activeCount?: number;
            pastDueCount?: number;
            canceledCount?: number;
            pausedCount?: number;
            expiredCount?: number;
            freeCount?: number;
            courtesyCount?: number;
            legacyCount?: number;
            estimatedMrrCents?: number;
        }): SubscriptionSnapshot {
            const message = new SubscriptionSnapshot({});
            if (data.activeCount != null) {
                message.activeCount = data.activeCount;
            }
            if (data.pastDueCount != null) {
                message.pastDueCount = data.pastDueCount;
            }
            if (data.canceledCount != null) {
                message.canceledCount = data.canceledCount;
            }
            if (data.pausedCount != null) {
                message.pausedCount = data.pausedCount;
            }
            if (data.expiredCount != null) {
                message.expiredCount = data.expiredCount;
            }
            if (data.freeCount != null) {
                message.freeCount = data.freeCount;
            }
            if (data.courtesyCount != null) {
                message.courtesyCount = data.courtesyCount;
            }
            if (data.legacyCount != null) {
                message.legacyCount = data.legacyCount;
            }
            if (data.estimatedMrrCents != null) {
                message.estimatedMrrCents = data.estimatedMrrCents;
            }
            return message;
        }
        toObject() {
            const data: {
                activeCount?: number;
                pastDueCount?: number;
                canceledCount?: number;
                pausedCount?: number;
                expiredCount?: number;
                freeCount?: number;
                courtesyCount?: number;
                legacyCount?: number;
                estimatedMrrCents?: number;
            } = {};
            if (this.activeCount != null) {
                data.activeCount = this.activeCount;
            }
            if (this.pastDueCount != null) {
                data.pastDueCount = this.pastDueCount;
            }
            if (this.canceledCount != null) {
                data.canceledCount = this.canceledCount;
            }
            if (this.pausedCount != null) {
                data.pausedCount = this.pausedCount;
            }
            if (this.expiredCount != null) {
                data.expiredCount = this.expiredCount;
            }
            if (this.freeCount != null) {
                data.freeCount = this.freeCount;
            }
            if (this.courtesyCount != null) {
                data.courtesyCount = this.courtesyCount;
            }
            if (this.legacyCount != null) {
                data.legacyCount = this.legacyCount;
            }
            if (this.estimatedMrrCents != null) {
                data.estimatedMrrCents = this.estimatedMrrCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.activeCount != 0)
                writer.writeInt32(1, this.activeCount);
            if (this.pastDueCount != 0)
                writer.writeInt32(2, this.pastDueCount);
            if (this.canceledCount != 0)
                writer.writeInt32(3, this.canceledCount);
            if (this.pausedCount != 0)
                writer.writeInt32(4, this.pausedCount);
            if (this.expiredCount != 0)
                writer.writeInt32(5, this.expiredCount);
            if (this.freeCount != 0)
                writer.writeInt32(6, this.freeCount);
            if (this.courtesyCount != 0)
                writer.writeInt32(7, this.courtesyCount);
            if (this.legacyCount != 0)
                writer.writeInt32(8, this.legacyCount);
            if (this.estimatedMrrCents != 0)
                writer.writeInt64(9, this.estimatedMrrCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionSnapshot {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionSnapshot();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.activeCount = reader.readInt32();
                        break;
                    case 2:
                        message.pastDueCount = reader.readInt32();
                        break;
                    case 3:
                        message.canceledCount = reader.readInt32();
                        break;
                    case 4:
                        message.pausedCount = reader.readInt32();
                        break;
                    case 5:
                        message.expiredCount = reader.readInt32();
                        break;
                    case 6:
                        message.freeCount = reader.readInt32();
                        break;
                    case 7:
                        message.courtesyCount = reader.readInt32();
                        break;
                    case 8:
                        message.legacyCount = reader.readInt32();
                        break;
                    case 9:
                        message.estimatedMrrCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionSnapshot {
            return SubscriptionSnapshot.deserialize(bytes);
        }
    }
    export class SubscriptionTimeSeriesPoint extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            period?: string;
            newSubscriptions?: number;
            cancellations?: number;
            netGrowth?: number;
            revenueCents?: number;
            newPurchases?: number;
            renewals?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("period" in data && data.period != undefined) {
                    this.period = data.period;
                }
                if ("newSubscriptions" in data && data.newSubscriptions != undefined) {
                    this.newSubscriptions = data.newSubscriptions;
                }
                if ("cancellations" in data && data.cancellations != undefined) {
                    this.cancellations = data.cancellations;
                }
                if ("netGrowth" in data && data.netGrowth != undefined) {
                    this.netGrowth = data.netGrowth;
                }
                if ("revenueCents" in data && data.revenueCents != undefined) {
                    this.revenueCents = data.revenueCents;
                }
                if ("newPurchases" in data && data.newPurchases != undefined) {
                    this.newPurchases = data.newPurchases;
                }
                if ("renewals" in data && data.renewals != undefined) {
                    this.renewals = data.renewals;
                }
            }
        }
        get period() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set period(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get newSubscriptions() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set newSubscriptions(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get cancellations() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set cancellations(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get netGrowth() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set netGrowth(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get revenueCents() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set revenueCents(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get newPurchases() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set newPurchases(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get renewals() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set renewals(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            period?: string;
            newSubscriptions?: number;
            cancellations?: number;
            netGrowth?: number;
            revenueCents?: number;
            newPurchases?: number;
            renewals?: number;
        }): SubscriptionTimeSeriesPoint {
            const message = new SubscriptionTimeSeriesPoint({});
            if (data.period != null) {
                message.period = data.period;
            }
            if (data.newSubscriptions != null) {
                message.newSubscriptions = data.newSubscriptions;
            }
            if (data.cancellations != null) {
                message.cancellations = data.cancellations;
            }
            if (data.netGrowth != null) {
                message.netGrowth = data.netGrowth;
            }
            if (data.revenueCents != null) {
                message.revenueCents = data.revenueCents;
            }
            if (data.newPurchases != null) {
                message.newPurchases = data.newPurchases;
            }
            if (data.renewals != null) {
                message.renewals = data.renewals;
            }
            return message;
        }
        toObject() {
            const data: {
                period?: string;
                newSubscriptions?: number;
                cancellations?: number;
                netGrowth?: number;
                revenueCents?: number;
                newPurchases?: number;
                renewals?: number;
            } = {};
            if (this.period != null) {
                data.period = this.period;
            }
            if (this.newSubscriptions != null) {
                data.newSubscriptions = this.newSubscriptions;
            }
            if (this.cancellations != null) {
                data.cancellations = this.cancellations;
            }
            if (this.netGrowth != null) {
                data.netGrowth = this.netGrowth;
            }
            if (this.revenueCents != null) {
                data.revenueCents = this.revenueCents;
            }
            if (this.newPurchases != null) {
                data.newPurchases = this.newPurchases;
            }
            if (this.renewals != null) {
                data.renewals = this.renewals;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.period.length)
                writer.writeString(1, this.period);
            if (this.newSubscriptions != 0)
                writer.writeInt32(2, this.newSubscriptions);
            if (this.cancellations != 0)
                writer.writeInt32(3, this.cancellations);
            if (this.netGrowth != 0)
                writer.writeInt32(4, this.netGrowth);
            if (this.revenueCents != 0)
                writer.writeInt64(5, this.revenueCents);
            if (this.newPurchases != 0)
                writer.writeInt32(6, this.newPurchases);
            if (this.renewals != 0)
                writer.writeInt32(7, this.renewals);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionTimeSeriesPoint {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionTimeSeriesPoint();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.period = reader.readString();
                        break;
                    case 2:
                        message.newSubscriptions = reader.readInt32();
                        break;
                    case 3:
                        message.cancellations = reader.readInt32();
                        break;
                    case 4:
                        message.netGrowth = reader.readInt32();
                        break;
                    case 5:
                        message.revenueCents = reader.readInt64();
                        break;
                    case 6:
                        message.newPurchases = reader.readInt32();
                        break;
                    case 7:
                        message.renewals = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionTimeSeriesPoint {
            return SubscriptionTimeSeriesPoint.deserialize(bytes);
        }
    }
    export class PlanBreakdown extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planName?: string;
            activeCount?: number;
            revenueCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("activeCount" in data && data.activeCount != undefined) {
                    this.activeCount = data.activeCount;
                }
                if ("revenueCents" in data && data.revenueCents != undefined) {
                    this.revenueCents = data.revenueCents;
                }
            }
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get activeCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set activeCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get revenueCents() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set revenueCents(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            planName?: string;
            activeCount?: number;
            revenueCents?: number;
        }): PlanBreakdown {
            const message = new PlanBreakdown({});
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.activeCount != null) {
                message.activeCount = data.activeCount;
            }
            if (data.revenueCents != null) {
                message.revenueCents = data.revenueCents;
            }
            return message;
        }
        toObject() {
            const data: {
                planName?: string;
                activeCount?: number;
                revenueCents?: number;
            } = {};
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.activeCount != null) {
                data.activeCount = this.activeCount;
            }
            if (this.revenueCents != null) {
                data.revenueCents = this.revenueCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planName.length)
                writer.writeString(1, this.planName);
            if (this.activeCount != 0)
                writer.writeInt32(2, this.activeCount);
            if (this.revenueCents != 0)
                writer.writeInt64(3, this.revenueCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanBreakdown {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanBreakdown();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planName = reader.readString();
                        break;
                    case 2:
                        message.activeCount = reader.readInt32();
                        break;
                    case 3:
                        message.revenueCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanBreakdown {
            return PlanBreakdown.deserialize(bytes);
        }
    }
    export class GetRetentionReportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            from?: dependency_2.google.protobuf.Timestamp;
            to?: dependency_2.google.protobuf.Timestamp;
            planIds?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("from" in data && data.from != undefined) {
                    this.from = data.from;
                }
                if ("to" in data && data.to != undefined) {
                    this.to = data.to;
                }
                if ("planIds" in data && data.planIds != undefined) {
                    this.planIds = data.planIds;
                }
            }
        }
        get from() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 1) as dependency_2.google.protobuf.Timestamp;
        }
        set from(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasFrom() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get to() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set to(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasTo() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get planIds() {
            return pb_1.Message.getFieldWithDefault(this, 3, []) as string[];
        }
        set planIds(value: string[]) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            from?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            to?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            planIds?: string[];
        }): GetRetentionReportRequest {
            const message = new GetRetentionReportRequest({});
            if (data.from != null) {
                message.from = dependency_2.google.protobuf.Timestamp.fromObject(data.from);
            }
            if (data.to != null) {
                message.to = dependency_2.google.protobuf.Timestamp.fromObject(data.to);
            }
            if (data.planIds != null) {
                message.planIds = data.planIds;
            }
            return message;
        }
        toObject() {
            const data: {
                from?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                to?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                planIds?: string[];
            } = {};
            if (this.from != null) {
                data.from = this.from.toObject();
            }
            if (this.to != null) {
                data.to = this.to.toObject();
            }
            if (this.planIds != null) {
                data.planIds = this.planIds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasFrom)
                writer.writeMessage(1, this.from, () => this.from.serialize(writer));
            if (this.hasTo)
                writer.writeMessage(2, this.to, () => this.to.serialize(writer));
            if (this.planIds.length)
                writer.writeRepeatedString(3, this.planIds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetRetentionReportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetRetentionReportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.from, () => message.from = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.to, () => message.to = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetRetentionReportRequest {
            return GetRetentionReportRequest.deserialize(bytes);
        }
    }
    export class GetRetentionReportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            current?: RetentionWindow;
            previous?: RetentionWindow;
            participants?: RetentionWindow;
            nonParticipants?: RetentionWindow;
            appliedDiscounts?: CampaignAppliedDiscount[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("current" in data && data.current != undefined) {
                    this.current = data.current;
                }
                if ("previous" in data && data.previous != undefined) {
                    this.previous = data.previous;
                }
                if ("participants" in data && data.participants != undefined) {
                    this.participants = data.participants;
                }
                if ("nonParticipants" in data && data.nonParticipants != undefined) {
                    this.nonParticipants = data.nonParticipants;
                }
                if ("appliedDiscounts" in data && data.appliedDiscounts != undefined) {
                    this.appliedDiscounts = data.appliedDiscounts;
                }
            }
        }
        get current() {
            return pb_1.Message.getWrapperField(this, RetentionWindow, 1) as RetentionWindow;
        }
        set current(value: RetentionWindow) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasCurrent() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get previous() {
            return pb_1.Message.getWrapperField(this, RetentionWindow, 2) as RetentionWindow;
        }
        set previous(value: RetentionWindow) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasPrevious() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get participants() {
            return pb_1.Message.getWrapperField(this, RetentionWindow, 3) as RetentionWindow;
        }
        set participants(value: RetentionWindow) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasParticipants() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get nonParticipants() {
            return pb_1.Message.getWrapperField(this, RetentionWindow, 4) as RetentionWindow;
        }
        set nonParticipants(value: RetentionWindow) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasNonParticipants() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get appliedDiscounts() {
            return pb_1.Message.getRepeatedWrapperField(this, CampaignAppliedDiscount, 5) as CampaignAppliedDiscount[];
        }
        set appliedDiscounts(value: CampaignAppliedDiscount[]) {
            pb_1.Message.setRepeatedWrapperField(this, 5, value);
        }
        static fromObject(data: {
            current?: ReturnType<typeof RetentionWindow.prototype.toObject>;
            previous?: ReturnType<typeof RetentionWindow.prototype.toObject>;
            participants?: ReturnType<typeof RetentionWindow.prototype.toObject>;
            nonParticipants?: ReturnType<typeof RetentionWindow.prototype.toObject>;
            appliedDiscounts?: ReturnType<typeof CampaignAppliedDiscount.prototype.toObject>[];
        }): GetRetentionReportResponse {
            const message = new GetRetentionReportResponse({});
            if (data.current != null) {
                message.current = RetentionWindow.fromObject(data.current);
            }
            if (data.previous != null) {
                message.previous = RetentionWindow.fromObject(data.previous);
            }
            if (data.participants != null) {
                message.participants = RetentionWindow.fromObject(data.participants);
            }
            if (data.nonParticipants != null) {
                message.nonParticipants = RetentionWindow.fromObject(data.nonParticipants);
            }
            if (data.appliedDiscounts != null) {
                message.appliedDiscounts = data.appliedDiscounts.map(item => CampaignAppliedDiscount.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                current?: ReturnType<typeof RetentionWindow.prototype.toObject>;
                previous?: ReturnType<typeof RetentionWindow.prototype.toObject>;
                participants?: ReturnType<typeof RetentionWindow.prototype.toObject>;
                nonParticipants?: ReturnType<typeof RetentionWindow.prototype.toObject>;
                appliedDiscounts?: ReturnType<typeof CampaignAppliedDiscount.prototype.toObject>[];
            } = {};
            if (this.current != null) {
                data.current = this.current.toObject();
            }
            if (this.previous != null) {
                data.previous = this.previous.toObject();
            }
            if (this.participants != null) {
                data.participants = this.participants.toObject();
            }
            if (this.nonParticipants != null) {
                data.nonParticipants = this.nonParticipants.toObject();
            }
            if (this.appliedDiscounts != null) {
                data.appliedDiscounts = this.appliedDiscounts.map((item: CampaignAppliedDiscount) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasCurrent)
                writer.writeMessage(1, this.current, () => this.current.serialize(writer));
            if (this.hasPrevious)
                writer.writeMessage(2, this.previous, () => this.previous.serialize(writer));
            if (this.hasParticipants)
                writer.writeMessage(3, this.participants, () => this.participants.serialize(writer));
            if (this.hasNonParticipants)
                writer.writeMessage(4, this.nonParticipants, () => this.nonParticipants.serialize(writer));
            if (this.appliedDiscounts.length)
                writer.writeRepeatedMessage(5, this.appliedDiscounts, (item: CampaignAppliedDiscount) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetRetentionReportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetRetentionReportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.current, () => message.current = RetentionWindow.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.previous, () => message.previous = RetentionWindow.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.participants, () => message.participants = RetentionWindow.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.nonParticipants, () => message.nonParticipants = RetentionWindow.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.appliedDiscounts, () => pb_1.Message.addToRepeatedWrapperField(message, 5, CampaignAppliedDiscount.deserialize(reader), CampaignAppliedDiscount));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetRetentionReportResponse {
            return GetRetentionReportResponse.deserialize(bytes);
        }
    }
    export class RetentionWindow extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            activeBase?: number;
            cancellations?: number;
            cancellationsByReason?: Map<string, number>;
            upgrades?: number;
            upgradesWithCampaign?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("activeBase" in data && data.activeBase != undefined) {
                    this.activeBase = data.activeBase;
                }
                if ("cancellations" in data && data.cancellations != undefined) {
                    this.cancellations = data.cancellations;
                }
                if ("cancellationsByReason" in data && data.cancellationsByReason != undefined) {
                    this.cancellationsByReason = data.cancellationsByReason;
                }
                if ("upgrades" in data && data.upgrades != undefined) {
                    this.upgrades = data.upgrades;
                }
                if ("upgradesWithCampaign" in data && data.upgradesWithCampaign != undefined) {
                    this.upgradesWithCampaign = data.upgradesWithCampaign;
                }
            }
            if (!this.cancellationsByReason)
                this.cancellationsByReason = new Map();
        }
        get activeBase() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set activeBase(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get cancellations() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set cancellations(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get cancellationsByReason() {
            return pb_1.Message.getField(this, 3) as any as Map<string, number>;
        }
        set cancellationsByReason(value: Map<string, number>) {
            pb_1.Message.setField(this, 3, value as any);
        }
        get upgrades() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set upgrades(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get upgradesWithCampaign() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set upgradesWithCampaign(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            activeBase?: number;
            cancellations?: number;
            cancellationsByReason?: {
                [key: string]: number;
            };
            upgrades?: number;
            upgradesWithCampaign?: number;
        }): RetentionWindow {
            const message = new RetentionWindow({});
            if (data.activeBase != null) {
                message.activeBase = data.activeBase;
            }
            if (data.cancellations != null) {
                message.cancellations = data.cancellations;
            }
            if (typeof data.cancellationsByReason == "object") {
                message.cancellationsByReason = new Map(Object.entries(data.cancellationsByReason));
            }
            if (data.upgrades != null) {
                message.upgrades = data.upgrades;
            }
            if (data.upgradesWithCampaign != null) {
                message.upgradesWithCampaign = data.upgradesWithCampaign;
            }
            return message;
        }
        toObject() {
            const data: {
                activeBase?: number;
                cancellations?: number;
                cancellationsByReason?: {
                    [key: string]: number;
                };
                upgrades?: number;
                upgradesWithCampaign?: number;
            } = {};
            if (this.activeBase != null) {
                data.activeBase = this.activeBase;
            }
            if (this.cancellations != null) {
                data.cancellations = this.cancellations;
            }
            if (this.cancellationsByReason != null) {
                data.cancellationsByReason = (Object.fromEntries)(this.cancellationsByReason);
            }
            if (this.upgrades != null) {
                data.upgrades = this.upgrades;
            }
            if (this.upgradesWithCampaign != null) {
                data.upgradesWithCampaign = this.upgradesWithCampaign;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.activeBase != 0)
                writer.writeInt32(1, this.activeBase);
            if (this.cancellations != 0)
                writer.writeInt32(2, this.cancellations);
            for (const [key, value] of this.cancellationsByReason) {
                writer.writeMessage(3, this.cancellationsByReason, () => {
                    writer.writeString(1, key);
                    writer.writeInt32(2, value);
                });
            }
            if (this.upgrades != 0)
                writer.writeInt32(4, this.upgrades);
            if (this.upgradesWithCampaign != 0)
                writer.writeInt32(5, this.upgradesWithCampaign);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RetentionWindow {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RetentionWindow();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.activeBase = reader.readInt32();
                        break;
                    case 2:
                        message.cancellations = reader.readInt32();
                        break;
                    case 3:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.cancellationsByReason as any, reader, reader.readString, reader.readInt32));
                        break;
                    case 4:
                        message.upgrades = reader.readInt32();
                        break;
                    case 5:
                        message.upgradesWithCampaign = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): RetentionWindow {
            return RetentionWindow.deserialize(bytes);
        }
    }
    export class CampaignAppliedDiscount extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            charges?: number;
            discountCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("charges" in data && data.charges != undefined) {
                    this.charges = data.charges;
                }
                if ("discountCents" in data && data.discountCents != undefined) {
                    this.discountCents = data.discountCents;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get charges() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set charges(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get discountCents() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set discountCents(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            campaignId?: string;
            charges?: number;
            discountCents?: number;
        }): CampaignAppliedDiscount {
            const message = new CampaignAppliedDiscount({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.charges != null) {
                message.charges = data.charges;
            }
            if (data.discountCents != null) {
                message.discountCents = data.discountCents;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                charges?: number;
                discountCents?: number;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.charges != null) {
                data.charges = this.charges;
            }
            if (this.discountCents != null) {
                data.discountCents = this.discountCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.charges != 0)
                writer.writeInt32(2, this.charges);
            if (this.discountCents != 0)
                writer.writeInt64(3, this.discountCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CampaignAppliedDiscount {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CampaignAppliedDiscount();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.charges = reader.readInt32();
                        break;
                    case 3:
                        message.discountCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CampaignAppliedDiscount {
            return CampaignAppliedDiscount.deserialize(bytes);
        }
    }
    export class GetSubscriptionReportRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[1], [2], [4], [5]];
        constructor(data?: any[] | ({
            status?: Status[];
            page?: number;
            pageSize?: number;
            planIds?: string[];
        } & (({
            startDate?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            endDate?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            minAmount?: number;
        }) | ({
            maxAmount?: number;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3, 8], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("startDate" in data && data.startDate != undefined) {
                    this.startDate = data.startDate;
                }
                if ("endDate" in data && data.endDate != undefined) {
                    this.endDate = data.endDate;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("minAmount" in data && data.minAmount != undefined) {
                    this.minAmount = data.minAmount;
                }
                if ("maxAmount" in data && data.maxAmount != undefined) {
                    this.maxAmount = data.maxAmount;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
                if ("planIds" in data && data.planIds != undefined) {
                    this.planIds = data.planIds;
                }
            }
        }
        get startDate() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 1) as dependency_2.google.protobuf.Timestamp;
        }
        set startDate(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 1, this.#one_of_decls[0], value);
        }
        get hasStartDate() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get endDate() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set endDate(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 2, this.#one_of_decls[1], value);
        }
        get hasEndDate() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 3, []) as Status[];
        }
        set status(value: Status[]) {
            pb_1.Message.setField(this, 3, value);
        }
        get minAmount() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set minAmount(value: number) {
            pb_1.Message.setOneofField(this, 4, this.#one_of_decls[2], value);
        }
        get hasMinAmount() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get maxAmount() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set maxAmount(value: number) {
            pb_1.Message.setOneofField(this, 5, this.#one_of_decls[3], value);
        }
        get hasMaxAmount() {
            return pb_1.Message.getField(this, 5) != null;
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get planIds() {
            return pb_1.Message.getFieldWithDefault(this, 8, []) as string[];
        }
        set planIds(value: string[]) {
            pb_1.Message.setField(this, 8, value);
        }
        get _start_date() {
            const cases: {
                [index: number]: "none" | "startDate";
            } = {
                0: "none",
                1: "startDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [1])];
        }
        get _end_date() {
            const cases: {
                [index: number]: "none" | "endDate";
            } = {
                0: "none",
                2: "endDate"
            };
            return cases[pb_1.Message.computeOneofCase(this, [2])];
        }
        get _min_amount() {
            const cases: {
                [index: number]: "none" | "minAmount";
            } = {
                0: "none",
                4: "minAmount"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        get _max_amount() {
            const cases: {
                [index: number]: "none" | "maxAmount";
            } = {
                0: "none",
                5: "maxAmount"
            };
            return cases[pb_1.Message.computeOneofCase(this, [5])];
        }
        static fromObject(data: {
            startDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            endDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            status?: Status[];
            minAmount?: number;
            maxAmount?: number;
            page?: number;
            pageSize?: number;
            planIds?: string[];
        }): GetSubscriptionReportRequest {
            const message = new GetSubscriptionReportRequest({});
            if (data.startDate != null) {
                message.startDate = dependency_2.google.protobuf.Timestamp.fromObject(data.startDate);
            }
            if (data.endDate != null) {
                message.endDate = dependency_2.google.protobuf.Timestamp.fromObject(data.endDate);
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.minAmount != null) {
                message.minAmount = data.minAmount;
            }
            if (data.maxAmount != null) {
                message.maxAmount = data.maxAmount;
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            if (data.planIds != null) {
                message.planIds = data.planIds;
            }
            return message;
        }
        toObject() {
            const data: {
                startDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                endDate?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                status?: Status[];
                minAmount?: number;
                maxAmount?: number;
                page?: number;
                pageSize?: number;
                planIds?: string[];
            } = {};
            if (this.startDate != null) {
                data.startDate = this.startDate.toObject();
            }
            if (this.endDate != null) {
                data.endDate = this.endDate.toObject();
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.minAmount != null) {
                data.minAmount = this.minAmount;
            }
            if (this.maxAmount != null) {
                data.maxAmount = this.maxAmount;
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            if (this.planIds != null) {
                data.planIds = this.planIds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasStartDate)
                writer.writeMessage(1, this.startDate, () => this.startDate.serialize(writer));
            if (this.hasEndDate)
                writer.writeMessage(2, this.endDate, () => this.endDate.serialize(writer));
            if (this.status.length)
                writer.writePackedEnum(3, this.status);
            if (this.hasMinAmount)
                writer.writeInt64(4, this.minAmount);
            if (this.hasMaxAmount)
                writer.writeInt64(5, this.maxAmount);
            if (this.page != 0)
                writer.writeInt64(6, this.page);
            if (this.pageSize != 0)
                writer.writeInt64(7, this.pageSize);
            if (this.planIds.length)
                writer.writeRepeatedString(8, this.planIds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionReportRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionReportRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.startDate, () => message.startDate = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.endDate, () => message.endDate = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        message.status = reader.readPackedEnum();
                        break;
                    case 4:
                        message.minAmount = reader.readInt64();
                        break;
                    case 5:
                        message.maxAmount = reader.readInt64();
                        break;
                    case 6:
                        message.page = reader.readInt64();
                        break;
                    case 7:
                        message.pageSize = reader.readInt64();
                        break;
                    case 8:
                        pb_1.Message.addToRepeatedField(message, 8, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionReportRequest {
            return GetSubscriptionReportRequest.deserialize(bytes);
        }
    }
    export class GetSubscriptionReportResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            items?: SubscriptionReportItem[];
            summary?: SubscriptionReportSummary;
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
            snapshot?: SubscriptionSnapshot;
            timeSeries?: SubscriptionTimeSeriesPoint[];
            byPlan?: PlanBreakdown[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 8, 9], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("items" in data && data.items != undefined) {
                    this.items = data.items;
                }
                if ("summary" in data && data.summary != undefined) {
                    this.summary = data.summary;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
                if ("snapshot" in data && data.snapshot != undefined) {
                    this.snapshot = data.snapshot;
                }
                if ("timeSeries" in data && data.timeSeries != undefined) {
                    this.timeSeries = data.timeSeries;
                }
                if ("byPlan" in data && data.byPlan != undefined) {
                    this.byPlan = data.byPlan;
                }
            }
        }
        get items() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionReportItem, 1) as SubscriptionReportItem[];
        }
        set items(value: SubscriptionReportItem[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get summary() {
            return pb_1.Message.getWrapperField(this, SubscriptionReportSummary, 2) as SubscriptionReportSummary;
        }
        set summary(value: SubscriptionReportSummary) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasSummary() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 6, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 6, value);
        }
        get snapshot() {
            return pb_1.Message.getWrapperField(this, SubscriptionSnapshot, 7) as SubscriptionSnapshot;
        }
        set snapshot(value: SubscriptionSnapshot) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get hasSnapshot() {
            return pb_1.Message.getField(this, 7) != null;
        }
        get timeSeries() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionTimeSeriesPoint, 8) as SubscriptionTimeSeriesPoint[];
        }
        set timeSeries(value: SubscriptionTimeSeriesPoint[]) {
            pb_1.Message.setRepeatedWrapperField(this, 8, value);
        }
        get byPlan() {
            return pb_1.Message.getRepeatedWrapperField(this, PlanBreakdown, 9) as PlanBreakdown[];
        }
        set byPlan(value: PlanBreakdown[]) {
            pb_1.Message.setRepeatedWrapperField(this, 9, value);
        }
        static fromObject(data: {
            items?: ReturnType<typeof SubscriptionReportItem.prototype.toObject>[];
            summary?: ReturnType<typeof SubscriptionReportSummary.prototype.toObject>;
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
            snapshot?: ReturnType<typeof SubscriptionSnapshot.prototype.toObject>;
            timeSeries?: ReturnType<typeof SubscriptionTimeSeriesPoint.prototype.toObject>[];
            byPlan?: ReturnType<typeof PlanBreakdown.prototype.toObject>[];
        }): GetSubscriptionReportResponse {
            const message = new GetSubscriptionReportResponse({});
            if (data.items != null) {
                message.items = data.items.map(item => SubscriptionReportItem.fromObject(item));
            }
            if (data.summary != null) {
                message.summary = SubscriptionReportSummary.fromObject(data.summary);
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            if (data.snapshot != null) {
                message.snapshot = SubscriptionSnapshot.fromObject(data.snapshot);
            }
            if (data.timeSeries != null) {
                message.timeSeries = data.timeSeries.map(item => SubscriptionTimeSeriesPoint.fromObject(item));
            }
            if (data.byPlan != null) {
                message.byPlan = data.byPlan.map(item => PlanBreakdown.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                items?: ReturnType<typeof SubscriptionReportItem.prototype.toObject>[];
                summary?: ReturnType<typeof SubscriptionReportSummary.prototype.toObject>;
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
                snapshot?: ReturnType<typeof SubscriptionSnapshot.prototype.toObject>;
                timeSeries?: ReturnType<typeof SubscriptionTimeSeriesPoint.prototype.toObject>[];
                byPlan?: ReturnType<typeof PlanBreakdown.prototype.toObject>[];
            } = {};
            if (this.items != null) {
                data.items = this.items.map((item: SubscriptionReportItem) => item.toObject());
            }
            if (this.summary != null) {
                data.summary = this.summary.toObject();
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            if (this.snapshot != null) {
                data.snapshot = this.snapshot.toObject();
            }
            if (this.timeSeries != null) {
                data.timeSeries = this.timeSeries.map((item: SubscriptionTimeSeriesPoint) => item.toObject());
            }
            if (this.byPlan != null) {
                data.byPlan = this.byPlan.map((item: PlanBreakdown) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.items.length)
                writer.writeRepeatedMessage(1, this.items, (item: SubscriptionReportItem) => item.serialize(writer));
            if (this.hasSummary)
                writer.writeMessage(2, this.summary, () => this.summary.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(3, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(4, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(5, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(6, this.hasPrev);
            if (this.hasSnapshot)
                writer.writeMessage(7, this.snapshot, () => this.snapshot.serialize(writer));
            if (this.timeSeries.length)
                writer.writeRepeatedMessage(8, this.timeSeries, (item: SubscriptionTimeSeriesPoint) => item.serialize(writer));
            if (this.byPlan.length)
                writer.writeRepeatedMessage(9, this.byPlan, (item: PlanBreakdown) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSubscriptionReportResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSubscriptionReportResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.items, () => pb_1.Message.addToRepeatedWrapperField(message, 1, SubscriptionReportItem.deserialize(reader), SubscriptionReportItem));
                        break;
                    case 2:
                        reader.readMessage(message.summary, () => message.summary = SubscriptionReportSummary.deserialize(reader));
                        break;
                    case 3:
                        message.totalCount = reader.readInt32();
                        break;
                    case 4:
                        message.totalPages = reader.readInt32();
                        break;
                    case 5:
                        message.hasNext = reader.readBool();
                        break;
                    case 6:
                        message.hasPrev = reader.readBool();
                        break;
                    case 7:
                        reader.readMessage(message.snapshot, () => message.snapshot = SubscriptionSnapshot.deserialize(reader));
                        break;
                    case 8:
                        reader.readMessage(message.timeSeries, () => pb_1.Message.addToRepeatedWrapperField(message, 8, SubscriptionTimeSeriesPoint.deserialize(reader), SubscriptionTimeSeriesPoint));
                        break;
                    case 9:
                        reader.readMessage(message.byPlan, () => pb_1.Message.addToRepeatedWrapperField(message, 9, PlanBreakdown.deserialize(reader), PlanBreakdown));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSubscriptionReportResponse {
            return GetSubscriptionReportResponse.deserialize(bytes);
        }
    }
    export class ListSubscriptionsWithCycleProblemsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [[3], [4]];
        constructor(data?: any[] | ({
            problemTypes?: CycleProblemType[];
            step?: string[];
            page?: number;
            pageSize?: number;
        } & (({
            createdAfter?: dependency_2.google.protobuf.Timestamp;
        }) | ({
            createdBefore?: dependency_2.google.protobuf.Timestamp;
        })))) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("problemTypes" in data && data.problemTypes != undefined) {
                    this.problemTypes = data.problemTypes;
                }
                if ("step" in data && data.step != undefined) {
                    this.step = data.step;
                }
                if ("createdAfter" in data && data.createdAfter != undefined) {
                    this.createdAfter = data.createdAfter;
                }
                if ("createdBefore" in data && data.createdBefore != undefined) {
                    this.createdBefore = data.createdBefore;
                }
                if ("page" in data && data.page != undefined) {
                    this.page = data.page;
                }
                if ("pageSize" in data && data.pageSize != undefined) {
                    this.pageSize = data.pageSize;
                }
            }
        }
        get problemTypes() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as CycleProblemType[];
        }
        set problemTypes(value: CycleProblemType[]) {
            pb_1.Message.setField(this, 1, value);
        }
        get step() {
            return pb_1.Message.getFieldWithDefault(this, 2, []) as string[];
        }
        set step(value: string[]) {
            pb_1.Message.setField(this, 2, value);
        }
        get createdAfter() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 3) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAfter(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 3, this.#one_of_decls[0], value);
        }
        get hasCreatedAfter() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get createdBefore() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set createdBefore(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setOneofWrapperField(this, 4, this.#one_of_decls[1], value);
        }
        get hasCreatedBefore() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get page() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set page(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get pageSize() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set pageSize(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get _created_after() {
            const cases: {
                [index: number]: "none" | "createdAfter";
            } = {
                0: "none",
                3: "createdAfter"
            };
            return cases[pb_1.Message.computeOneofCase(this, [3])];
        }
        get _created_before() {
            const cases: {
                [index: number]: "none" | "createdBefore";
            } = {
                0: "none",
                4: "createdBefore"
            };
            return cases[pb_1.Message.computeOneofCase(this, [4])];
        }
        static fromObject(data: {
            problemTypes?: CycleProblemType[];
            step?: string[];
            createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            page?: number;
            pageSize?: number;
        }): ListSubscriptionsWithCycleProblemsRequest {
            const message = new ListSubscriptionsWithCycleProblemsRequest({});
            if (data.problemTypes != null) {
                message.problemTypes = data.problemTypes;
            }
            if (data.step != null) {
                message.step = data.step;
            }
            if (data.createdAfter != null) {
                message.createdAfter = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAfter);
            }
            if (data.createdBefore != null) {
                message.createdBefore = dependency_2.google.protobuf.Timestamp.fromObject(data.createdBefore);
            }
            if (data.page != null) {
                message.page = data.page;
            }
            if (data.pageSize != null) {
                message.pageSize = data.pageSize;
            }
            return message;
        }
        toObject() {
            const data: {
                problemTypes?: CycleProblemType[];
                step?: string[];
                createdAfter?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                createdBefore?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                page?: number;
                pageSize?: number;
            } = {};
            if (this.problemTypes != null) {
                data.problemTypes = this.problemTypes;
            }
            if (this.step != null) {
                data.step = this.step;
            }
            if (this.createdAfter != null) {
                data.createdAfter = this.createdAfter.toObject();
            }
            if (this.createdBefore != null) {
                data.createdBefore = this.createdBefore.toObject();
            }
            if (this.page != null) {
                data.page = this.page;
            }
            if (this.pageSize != null) {
                data.pageSize = this.pageSize;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.problemTypes.length)
                writer.writePackedEnum(1, this.problemTypes);
            if (this.step.length)
                writer.writeRepeatedString(2, this.step);
            if (this.hasCreatedAfter)
                writer.writeMessage(3, this.createdAfter, () => this.createdAfter.serialize(writer));
            if (this.hasCreatedBefore)
                writer.writeMessage(4, this.createdBefore, () => this.createdBefore.serialize(writer));
            if (this.page != 0)
                writer.writeInt64(5, this.page);
            if (this.pageSize != 0)
                writer.writeInt64(6, this.pageSize);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionsWithCycleProblemsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionsWithCycleProblemsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.problemTypes = reader.readPackedEnum();
                        break;
                    case 2:
                        pb_1.Message.addToRepeatedField(message, 2, reader.readString());
                        break;
                    case 3:
                        reader.readMessage(message.createdAfter, () => message.createdAfter = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        reader.readMessage(message.createdBefore, () => message.createdBefore = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        message.page = reader.readInt64();
                        break;
                    case 6:
                        message.pageSize = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionsWithCycleProblemsRequest {
            return ListSubscriptionsWithCycleProblemsRequest.deserialize(bytes);
        }
    }
    export class CycleProblemEntry extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            step?: CycleStepHistoryEntry;
            type?: CycleProblemType;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("step" in data && data.step != undefined) {
                    this.step = data.step;
                }
                if ("type" in data && data.type != undefined) {
                    this.type = data.type;
                }
            }
        }
        get step() {
            return pb_1.Message.getWrapperField(this, CycleStepHistoryEntry, 1) as CycleStepHistoryEntry;
        }
        set step(value: CycleStepHistoryEntry) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasStep() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get type() {
            return pb_1.Message.getFieldWithDefault(this, 2, CycleProblemType.CYCLE_PROBLEM_TYPE_UNSPECIFIED) as CycleProblemType;
        }
        set type(value: CycleProblemType) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            step?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>;
            type?: CycleProblemType;
        }): CycleProblemEntry {
            const message = new CycleProblemEntry({});
            if (data.step != null) {
                message.step = CycleStepHistoryEntry.fromObject(data.step);
            }
            if (data.type != null) {
                message.type = data.type;
            }
            return message;
        }
        toObject() {
            const data: {
                step?: ReturnType<typeof CycleStepHistoryEntry.prototype.toObject>;
                type?: CycleProblemType;
            } = {};
            if (this.step != null) {
                data.step = this.step.toObject();
            }
            if (this.type != null) {
                data.type = this.type;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasStep)
                writer.writeMessage(1, this.step, () => this.step.serialize(writer));
            if (this.type != CycleProblemType.CYCLE_PROBLEM_TYPE_UNSPECIFIED)
                writer.writeEnum(2, this.type);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CycleProblemEntry {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CycleProblemEntry();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.step, () => message.step = CycleStepHistoryEntry.deserialize(reader));
                        break;
                    case 2:
                        message.type = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CycleProblemEntry {
            return CycleProblemEntry.deserialize(bytes);
        }
    }
    export class SubscriptionCycleProblems extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cycleId?: string;
            planName?: string;
            cycleStatus?: CycleStatus;
            createdAt?: dependency_2.google.protobuf.Timestamp;
            problems?: CycleProblemEntry[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cycleId" in data && data.cycleId != undefined) {
                    this.cycleId = data.cycleId;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("cycleStatus" in data && data.cycleStatus != undefined) {
                    this.cycleStatus = data.cycleStatus;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("problems" in data && data.problems != undefined) {
                    this.problems = data.problems;
                }
            }
        }
        get cycleId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set cycleId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get cycleStatus() {
            return pb_1.Message.getFieldWithDefault(this, 3, CycleStatus.CYCLE_STATUS_UNSPECIFIED) as CycleStatus;
        }
        set cycleStatus(value: CycleStatus) {
            pb_1.Message.setField(this, 3, value);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get problems() {
            return pb_1.Message.getRepeatedWrapperField(this, CycleProblemEntry, 5) as CycleProblemEntry[];
        }
        set problems(value: CycleProblemEntry[]) {
            pb_1.Message.setRepeatedWrapperField(this, 5, value);
        }
        static fromObject(data: {
            cycleId?: string;
            planName?: string;
            cycleStatus?: CycleStatus;
            createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            problems?: ReturnType<typeof CycleProblemEntry.prototype.toObject>[];
        }): SubscriptionCycleProblems {
            const message = new SubscriptionCycleProblems({});
            if (data.cycleId != null) {
                message.cycleId = data.cycleId;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.cycleStatus != null) {
                message.cycleStatus = data.cycleStatus;
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_2.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.problems != null) {
                message.problems = data.problems.map(item => CycleProblemEntry.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                cycleId?: string;
                planName?: string;
                cycleStatus?: CycleStatus;
                createdAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                problems?: ReturnType<typeof CycleProblemEntry.prototype.toObject>[];
            } = {};
            if (this.cycleId != null) {
                data.cycleId = this.cycleId;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.cycleStatus != null) {
                data.cycleStatus = this.cycleStatus;
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.problems != null) {
                data.problems = this.problems.map((item: CycleProblemEntry) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cycleId.length)
                writer.writeString(1, this.cycleId);
            if (this.planName.length)
                writer.writeString(2, this.planName);
            if (this.cycleStatus != CycleStatus.CYCLE_STATUS_UNSPECIFIED)
                writer.writeEnum(3, this.cycleStatus);
            if (this.hasCreatedAt)
                writer.writeMessage(4, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.problems.length)
                writer.writeRepeatedMessage(5, this.problems, (item: CycleProblemEntry) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionCycleProblems {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionCycleProblems();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.cycleId = reader.readString();
                        break;
                    case 2:
                        message.planName = reader.readString();
                        break;
                    case 3:
                        message.cycleStatus = reader.readEnum();
                        break;
                    case 4:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.problems, () => pb_1.Message.addToRepeatedWrapperField(message, 5, CycleProblemEntry.deserialize(reader), CycleProblemEntry));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionCycleProblems {
            return SubscriptionCycleProblems.deserialize(bytes);
        }
    }
    export class SubscriptionWithCycleProblems extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            subscriptionId?: string;
            subscriptionStatus?: Status;
            ownerName?: string;
            ownerEmail?: string;
            planName?: string;
            cycles?: SubscriptionCycleProblems[];
            problemCycleCount?: number;
            latestProblemAt?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("subscriptionId" in data && data.subscriptionId != undefined) {
                    this.subscriptionId = data.subscriptionId;
                }
                if ("subscriptionStatus" in data && data.subscriptionStatus != undefined) {
                    this.subscriptionStatus = data.subscriptionStatus;
                }
                if ("ownerName" in data && data.ownerName != undefined) {
                    this.ownerName = data.ownerName;
                }
                if ("ownerEmail" in data && data.ownerEmail != undefined) {
                    this.ownerEmail = data.ownerEmail;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("cycles" in data && data.cycles != undefined) {
                    this.cycles = data.cycles;
                }
                if ("problemCycleCount" in data && data.problemCycleCount != undefined) {
                    this.problemCycleCount = data.problemCycleCount;
                }
                if ("latestProblemAt" in data && data.latestProblemAt != undefined) {
                    this.latestProblemAt = data.latestProblemAt;
                }
            }
        }
        get subscriptionId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set subscriptionId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get subscriptionStatus() {
            return pb_1.Message.getFieldWithDefault(this, 2, Status.STATUS_UNSPECIFIED) as Status;
        }
        set subscriptionStatus(value: Status) {
            pb_1.Message.setField(this, 2, value);
        }
        get ownerName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set ownerName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get ownerEmail() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set ownerEmail(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get cycles() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionCycleProblems, 6) as SubscriptionCycleProblems[];
        }
        set cycles(value: SubscriptionCycleProblems[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get problemCycleCount() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set problemCycleCount(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get latestProblemAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 8) as dependency_2.google.protobuf.Timestamp;
        }
        set latestProblemAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasLatestProblemAt() {
            return pb_1.Message.getField(this, 8) != null;
        }
        static fromObject(data: {
            subscriptionId?: string;
            subscriptionStatus?: Status;
            ownerName?: string;
            ownerEmail?: string;
            planName?: string;
            cycles?: ReturnType<typeof SubscriptionCycleProblems.prototype.toObject>[];
            problemCycleCount?: number;
            latestProblemAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): SubscriptionWithCycleProblems {
            const message = new SubscriptionWithCycleProblems({});
            if (data.subscriptionId != null) {
                message.subscriptionId = data.subscriptionId;
            }
            if (data.subscriptionStatus != null) {
                message.subscriptionStatus = data.subscriptionStatus;
            }
            if (data.ownerName != null) {
                message.ownerName = data.ownerName;
            }
            if (data.ownerEmail != null) {
                message.ownerEmail = data.ownerEmail;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.cycles != null) {
                message.cycles = data.cycles.map(item => SubscriptionCycleProblems.fromObject(item));
            }
            if (data.problemCycleCount != null) {
                message.problemCycleCount = data.problemCycleCount;
            }
            if (data.latestProblemAt != null) {
                message.latestProblemAt = dependency_2.google.protobuf.Timestamp.fromObject(data.latestProblemAt);
            }
            return message;
        }
        toObject() {
            const data: {
                subscriptionId?: string;
                subscriptionStatus?: Status;
                ownerName?: string;
                ownerEmail?: string;
                planName?: string;
                cycles?: ReturnType<typeof SubscriptionCycleProblems.prototype.toObject>[];
                problemCycleCount?: number;
                latestProblemAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.subscriptionId != null) {
                data.subscriptionId = this.subscriptionId;
            }
            if (this.subscriptionStatus != null) {
                data.subscriptionStatus = this.subscriptionStatus;
            }
            if (this.ownerName != null) {
                data.ownerName = this.ownerName;
            }
            if (this.ownerEmail != null) {
                data.ownerEmail = this.ownerEmail;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.cycles != null) {
                data.cycles = this.cycles.map((item: SubscriptionCycleProblems) => item.toObject());
            }
            if (this.problemCycleCount != null) {
                data.problemCycleCount = this.problemCycleCount;
            }
            if (this.latestProblemAt != null) {
                data.latestProblemAt = this.latestProblemAt.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.subscriptionId.length)
                writer.writeString(1, this.subscriptionId);
            if (this.subscriptionStatus != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(2, this.subscriptionStatus);
            if (this.ownerName.length)
                writer.writeString(3, this.ownerName);
            if (this.ownerEmail.length)
                writer.writeString(4, this.ownerEmail);
            if (this.planName.length)
                writer.writeString(5, this.planName);
            if (this.cycles.length)
                writer.writeRepeatedMessage(6, this.cycles, (item: SubscriptionCycleProblems) => item.serialize(writer));
            if (this.problemCycleCount != 0)
                writer.writeInt32(7, this.problemCycleCount);
            if (this.hasLatestProblemAt)
                writer.writeMessage(8, this.latestProblemAt, () => this.latestProblemAt.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubscriptionWithCycleProblems {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SubscriptionWithCycleProblems();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.subscriptionId = reader.readString();
                        break;
                    case 2:
                        message.subscriptionStatus = reader.readEnum();
                        break;
                    case 3:
                        message.ownerName = reader.readString();
                        break;
                    case 4:
                        message.ownerEmail = reader.readString();
                        break;
                    case 5:
                        message.planName = reader.readString();
                        break;
                    case 6:
                        reader.readMessage(message.cycles, () => pb_1.Message.addToRepeatedWrapperField(message, 6, SubscriptionCycleProblems.deserialize(reader), SubscriptionCycleProblems));
                        break;
                    case 7:
                        message.problemCycleCount = reader.readInt32();
                        break;
                    case 8:
                        reader.readMessage(message.latestProblemAt, () => message.latestProblemAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SubscriptionWithCycleProblems {
            return SubscriptionWithCycleProblems.deserialize(bytes);
        }
    }
    export class ListSubscriptionsWithCycleProblemsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            items?: SubscriptionWithCycleProblems[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("items" in data && data.items != undefined) {
                    this.items = data.items;
                }
                if ("totalCount" in data && data.totalCount != undefined) {
                    this.totalCount = data.totalCount;
                }
                if ("totalPages" in data && data.totalPages != undefined) {
                    this.totalPages = data.totalPages;
                }
                if ("hasNext" in data && data.hasNext != undefined) {
                    this.hasNext = data.hasNext;
                }
                if ("hasPrev" in data && data.hasPrev != undefined) {
                    this.hasPrev = data.hasPrev;
                }
            }
        }
        get items() {
            return pb_1.Message.getRepeatedWrapperField(this, SubscriptionWithCycleProblems, 1) as SubscriptionWithCycleProblems[];
        }
        set items(value: SubscriptionWithCycleProblems[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get totalCount() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set totalCount(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get totalPages() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalPages(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get hasNext() {
            return pb_1.Message.getFieldWithDefault(this, 4, false) as boolean;
        }
        set hasNext(value: boolean) {
            pb_1.Message.setField(this, 4, value);
        }
        get hasPrev() {
            return pb_1.Message.getFieldWithDefault(this, 5, false) as boolean;
        }
        set hasPrev(value: boolean) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            items?: ReturnType<typeof SubscriptionWithCycleProblems.prototype.toObject>[];
            totalCount?: number;
            totalPages?: number;
            hasNext?: boolean;
            hasPrev?: boolean;
        }): ListSubscriptionsWithCycleProblemsResponse {
            const message = new ListSubscriptionsWithCycleProblemsResponse({});
            if (data.items != null) {
                message.items = data.items.map(item => SubscriptionWithCycleProblems.fromObject(item));
            }
            if (data.totalCount != null) {
                message.totalCount = data.totalCount;
            }
            if (data.totalPages != null) {
                message.totalPages = data.totalPages;
            }
            if (data.hasNext != null) {
                message.hasNext = data.hasNext;
            }
            if (data.hasPrev != null) {
                message.hasPrev = data.hasPrev;
            }
            return message;
        }
        toObject() {
            const data: {
                items?: ReturnType<typeof SubscriptionWithCycleProblems.prototype.toObject>[];
                totalCount?: number;
                totalPages?: number;
                hasNext?: boolean;
                hasPrev?: boolean;
            } = {};
            if (this.items != null) {
                data.items = this.items.map((item: SubscriptionWithCycleProblems) => item.toObject());
            }
            if (this.totalCount != null) {
                data.totalCount = this.totalCount;
            }
            if (this.totalPages != null) {
                data.totalPages = this.totalPages;
            }
            if (this.hasNext != null) {
                data.hasNext = this.hasNext;
            }
            if (this.hasPrev != null) {
                data.hasPrev = this.hasPrev;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.items.length)
                writer.writeRepeatedMessage(1, this.items, (item: SubscriptionWithCycleProblems) => item.serialize(writer));
            if (this.totalCount != 0)
                writer.writeInt32(2, this.totalCount);
            if (this.totalPages != 0)
                writer.writeInt32(3, this.totalPages);
            if (this.hasNext != false)
                writer.writeBool(4, this.hasNext);
            if (this.hasPrev != false)
                writer.writeBool(5, this.hasPrev);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ListSubscriptionsWithCycleProblemsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new ListSubscriptionsWithCycleProblemsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.items, () => pb_1.Message.addToRepeatedWrapperField(message, 1, SubscriptionWithCycleProblems.deserialize(reader), SubscriptionWithCycleProblems));
                        break;
                    case 2:
                        message.totalCount = reader.readInt32();
                        break;
                    case 3:
                        message.totalPages = reader.readInt32();
                        break;
                    case 4:
                        message.hasNext = reader.readBool();
                        break;
                    case 5:
                        message.hasPrev = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): ListSubscriptionsWithCycleProblemsResponse {
            return ListSubscriptionsWithCycleProblemsResponse.deserialize(bytes);
        }
    }
    export class PlanConsolidatedItem extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planId?: string;
            planName?: string;
            activeUsers?: number;
            unitValue?: number;
            totalValue?: number;
            users?: UserPlan[];
            periodDays?: number;
            cycleValue?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("activeUsers" in data && data.activeUsers != undefined) {
                    this.activeUsers = data.activeUsers;
                }
                if ("unitValue" in data && data.unitValue != undefined) {
                    this.unitValue = data.unitValue;
                }
                if ("totalValue" in data && data.totalValue != undefined) {
                    this.totalValue = data.totalValue;
                }
                if ("users" in data && data.users != undefined) {
                    this.users = data.users;
                }
                if ("periodDays" in data && data.periodDays != undefined) {
                    this.periodDays = data.periodDays;
                }
                if ("cycleValue" in data && data.cycleValue != undefined) {
                    this.cycleValue = data.cycleValue;
                }
            }
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get activeUsers() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set activeUsers(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get unitValue() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set unitValue(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get totalValue() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set totalValue(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get users() {
            return pb_1.Message.getRepeatedWrapperField(this, UserPlan, 6) as UserPlan[];
        }
        set users(value: UserPlan[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get periodDays() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set periodDays(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get cycleValue() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set cycleValue(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            planId?: string;
            planName?: string;
            activeUsers?: number;
            unitValue?: number;
            totalValue?: number;
            users?: ReturnType<typeof UserPlan.prototype.toObject>[];
            periodDays?: number;
            cycleValue?: number;
        }): PlanConsolidatedItem {
            const message = new PlanConsolidatedItem({});
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.activeUsers != null) {
                message.activeUsers = data.activeUsers;
            }
            if (data.unitValue != null) {
                message.unitValue = data.unitValue;
            }
            if (data.totalValue != null) {
                message.totalValue = data.totalValue;
            }
            if (data.users != null) {
                message.users = data.users.map(item => UserPlan.fromObject(item));
            }
            if (data.periodDays != null) {
                message.periodDays = data.periodDays;
            }
            if (data.cycleValue != null) {
                message.cycleValue = data.cycleValue;
            }
            return message;
        }
        toObject() {
            const data: {
                planId?: string;
                planName?: string;
                activeUsers?: number;
                unitValue?: number;
                totalValue?: number;
                users?: ReturnType<typeof UserPlan.prototype.toObject>[];
                periodDays?: number;
                cycleValue?: number;
            } = {};
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.activeUsers != null) {
                data.activeUsers = this.activeUsers;
            }
            if (this.unitValue != null) {
                data.unitValue = this.unitValue;
            }
            if (this.totalValue != null) {
                data.totalValue = this.totalValue;
            }
            if (this.users != null) {
                data.users = this.users.map((item: UserPlan) => item.toObject());
            }
            if (this.periodDays != null) {
                data.periodDays = this.periodDays;
            }
            if (this.cycleValue != null) {
                data.cycleValue = this.cycleValue;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planId.length)
                writer.writeString(1, this.planId);
            if (this.planName.length)
                writer.writeString(2, this.planName);
            if (this.activeUsers != 0)
                writer.writeUint32(3, this.activeUsers);
            if (this.unitValue != 0)
                writer.writeInt64(4, this.unitValue);
            if (this.totalValue != 0)
                writer.writeInt64(5, this.totalValue);
            if (this.users.length)
                writer.writeRepeatedMessage(6, this.users, (item: UserPlan) => item.serialize(writer));
            if (this.periodDays != 0)
                writer.writeInt64(7, this.periodDays);
            if (this.cycleValue != 0)
                writer.writeInt64(8, this.cycleValue);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanConsolidatedItem {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanConsolidatedItem();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planId = reader.readString();
                        break;
                    case 2:
                        message.planName = reader.readString();
                        break;
                    case 3:
                        message.activeUsers = reader.readUint32();
                        break;
                    case 4:
                        message.unitValue = reader.readInt64();
                        break;
                    case 5:
                        message.totalValue = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.users, () => pb_1.Message.addToRepeatedWrapperField(message, 6, UserPlan.deserialize(reader), UserPlan));
                        break;
                    case 7:
                        message.periodDays = reader.readInt64();
                        break;
                    case 8:
                        message.cycleValue = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanConsolidatedItem {
            return PlanConsolidatedItem.deserialize(bytes);
        }
    }
    export class UserPlan extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            name?: string;
            email?: string;
            unitValue?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("email" in data && data.email != undefined) {
                    this.email = data.email;
                }
                if ("unitValue" in data && data.unitValue != undefined) {
                    this.unitValue = data.unitValue;
                }
            }
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get email() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set email(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get unitValue() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set unitValue(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            name?: string;
            email?: string;
            unitValue?: number;
        }): UserPlan {
            const message = new UserPlan({});
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.email != null) {
                message.email = data.email;
            }
            if (data.unitValue != null) {
                message.unitValue = data.unitValue;
            }
            return message;
        }
        toObject() {
            const data: {
                name?: string;
                email?: string;
                unitValue?: number;
            } = {};
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.email != null) {
                data.email = this.email;
            }
            if (this.unitValue != null) {
                data.unitValue = this.unitValue;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.name.length)
                writer.writeString(1, this.name);
            if (this.email.length)
                writer.writeString(2, this.email);
            if (this.unitValue != 0)
                writer.writeInt64(3, this.unitValue);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): UserPlan {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new UserPlan();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.name = reader.readString();
                        break;
                    case 2:
                        message.email = reader.readString();
                        break;
                    case 3:
                        message.unitValue = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): UserPlan {
            return UserPlan.deserialize(bytes);
        }
    }
    export class GetMyOffersRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planIds?: string[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planIds" in data && data.planIds != undefined) {
                    this.planIds = data.planIds;
                }
            }
        }
        get planIds() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as string[];
        }
        set planIds(value: string[]) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            planIds?: string[];
        }): GetMyOffersRequest {
            const message = new GetMyOffersRequest({});
            if (data.planIds != null) {
                message.planIds = data.planIds;
            }
            return message;
        }
        toObject() {
            const data: {
                planIds?: string[];
            } = {};
            if (this.planIds != null) {
                data.planIds = this.planIds;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planIds.length)
                writer.writeRepeatedString(1, this.planIds);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetMyOffersRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetMyOffersRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        pb_1.Message.addToRepeatedField(message, 1, reader.readString());
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetMyOffersRequest {
            return GetMyOffersRequest.deserialize(bytes);
        }
    }
    export class PlanOffer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            planId?: string;
            campaignId?: string;
            campaignName?: string;
            campaignType?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            finalAmountCents?: number;
            validUntil?: dependency_2.google.protobuf.Timestamp;
            effectiveDiscountPercent?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("campaignType" in data && data.campaignType != undefined) {
                    this.campaignType = data.campaignType;
                }
                if ("discountPercent" in data && data.discountPercent != undefined) {
                    this.discountPercent = data.discountPercent;
                }
                if ("discountMaxCents" in data && data.discountMaxCents != undefined) {
                    this.discountMaxCents = data.discountMaxCents;
                }
                if ("baseAmountCents" in data && data.baseAmountCents != undefined) {
                    this.baseAmountCents = data.baseAmountCents;
                }
                if ("discountAmountCents" in data && data.discountAmountCents != undefined) {
                    this.discountAmountCents = data.discountAmountCents;
                }
                if ("finalAmountCents" in data && data.finalAmountCents != undefined) {
                    this.finalAmountCents = data.finalAmountCents;
                }
                if ("validUntil" in data && data.validUntil != undefined) {
                    this.validUntil = data.validUntil;
                }
                if ("effectiveDiscountPercent" in data && data.effectiveDiscountPercent != undefined) {
                    this.effectiveDiscountPercent = data.effectiveDiscountPercent;
                }
            }
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get campaignType() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set campaignType(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get discountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set discountPercent(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get discountMaxCents() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set discountMaxCents(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get baseAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set baseAmountCents(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get discountAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 8, 0) as number;
        }
        set discountAmountCents(value: number) {
            pb_1.Message.setField(this, 8, value);
        }
        get finalAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 9, 0) as number;
        }
        set finalAmountCents(value: number) {
            pb_1.Message.setField(this, 9, value);
        }
        get validUntil() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 10) as dependency_2.google.protobuf.Timestamp;
        }
        set validUntil(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 10, value);
        }
        get hasValidUntil() {
            return pb_1.Message.getField(this, 10) != null;
        }
        get effectiveDiscountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 11, 0) as number;
        }
        set effectiveDiscountPercent(value: number) {
            pb_1.Message.setField(this, 11, value);
        }
        static fromObject(data: {
            planId?: string;
            campaignId?: string;
            campaignName?: string;
            campaignType?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            finalAmountCents?: number;
            validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            effectiveDiscountPercent?: number;
        }): PlanOffer {
            const message = new PlanOffer({});
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.campaignType != null) {
                message.campaignType = data.campaignType;
            }
            if (data.discountPercent != null) {
                message.discountPercent = data.discountPercent;
            }
            if (data.discountMaxCents != null) {
                message.discountMaxCents = data.discountMaxCents;
            }
            if (data.baseAmountCents != null) {
                message.baseAmountCents = data.baseAmountCents;
            }
            if (data.discountAmountCents != null) {
                message.discountAmountCents = data.discountAmountCents;
            }
            if (data.finalAmountCents != null) {
                message.finalAmountCents = data.finalAmountCents;
            }
            if (data.validUntil != null) {
                message.validUntil = dependency_2.google.protobuf.Timestamp.fromObject(data.validUntil);
            }
            if (data.effectiveDiscountPercent != null) {
                message.effectiveDiscountPercent = data.effectiveDiscountPercent;
            }
            return message;
        }
        toObject() {
            const data: {
                planId?: string;
                campaignId?: string;
                campaignName?: string;
                campaignType?: string;
                discountPercent?: number;
                discountMaxCents?: number;
                baseAmountCents?: number;
                discountAmountCents?: number;
                finalAmountCents?: number;
                validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                effectiveDiscountPercent?: number;
            } = {};
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.campaignType != null) {
                data.campaignType = this.campaignType;
            }
            if (this.discountPercent != null) {
                data.discountPercent = this.discountPercent;
            }
            if (this.discountMaxCents != null) {
                data.discountMaxCents = this.discountMaxCents;
            }
            if (this.baseAmountCents != null) {
                data.baseAmountCents = this.baseAmountCents;
            }
            if (this.discountAmountCents != null) {
                data.discountAmountCents = this.discountAmountCents;
            }
            if (this.finalAmountCents != null) {
                data.finalAmountCents = this.finalAmountCents;
            }
            if (this.validUntil != null) {
                data.validUntil = this.validUntil.toObject();
            }
            if (this.effectiveDiscountPercent != null) {
                data.effectiveDiscountPercent = this.effectiveDiscountPercent;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.planId.length)
                writer.writeString(1, this.planId);
            if (this.campaignId.length)
                writer.writeString(2, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(3, this.campaignName);
            if (this.campaignType.length)
                writer.writeString(4, this.campaignType);
            if (this.discountPercent != 0)
                writer.writeInt32(5, this.discountPercent);
            if (this.discountMaxCents != 0)
                writer.writeInt64(6, this.discountMaxCents);
            if (this.baseAmountCents != 0)
                writer.writeInt64(7, this.baseAmountCents);
            if (this.discountAmountCents != 0)
                writer.writeInt64(8, this.discountAmountCents);
            if (this.finalAmountCents != 0)
                writer.writeInt64(9, this.finalAmountCents);
            if (this.hasValidUntil)
                writer.writeMessage(10, this.validUntil, () => this.validUntil.serialize(writer));
            if (this.effectiveDiscountPercent != 0)
                writer.writeDouble(11, this.effectiveDiscountPercent);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PlanOffer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PlanOffer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.planId = reader.readString();
                        break;
                    case 2:
                        message.campaignId = reader.readString();
                        break;
                    case 3:
                        message.campaignName = reader.readString();
                        break;
                    case 4:
                        message.campaignType = reader.readString();
                        break;
                    case 5:
                        message.discountPercent = reader.readInt32();
                        break;
                    case 6:
                        message.discountMaxCents = reader.readInt64();
                        break;
                    case 7:
                        message.baseAmountCents = reader.readInt64();
                        break;
                    case 8:
                        message.discountAmountCents = reader.readInt64();
                        break;
                    case 9:
                        message.finalAmountCents = reader.readInt64();
                        break;
                    case 10:
                        reader.readMessage(message.validUntil, () => message.validUntil = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 11:
                        message.effectiveDiscountPercent = reader.readDouble();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): PlanOffer {
            return PlanOffer.deserialize(bytes);
        }
    }
    export class GetMyOffersResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            offers?: PlanOffer[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("offers" in data && data.offers != undefined) {
                    this.offers = data.offers;
                }
            }
        }
        get offers() {
            return pb_1.Message.getRepeatedWrapperField(this, PlanOffer, 1) as PlanOffer[];
        }
        set offers(value: PlanOffer[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            offers?: ReturnType<typeof PlanOffer.prototype.toObject>[];
        }): GetMyOffersResponse {
            const message = new GetMyOffersResponse({});
            if (data.offers != null) {
                message.offers = data.offers.map(item => PlanOffer.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                offers?: ReturnType<typeof PlanOffer.prototype.toObject>[];
            } = {};
            if (this.offers != null) {
                data.offers = this.offers.map((item: PlanOffer) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.offers.length)
                writer.writeRepeatedMessage(1, this.offers, (item: PlanOffer) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetMyOffersResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetMyOffersResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.offers, () => pb_1.Message.addToRepeatedWrapperField(message, 1, PlanOffer.deserialize(reader), PlanOffer));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetMyOffersResponse {
            return GetMyOffersResponse.deserialize(bytes);
        }
    }
    export class GetMyBenefitsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetMyBenefitsRequest {
            const message = new GetMyBenefitsRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetMyBenefitsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetMyBenefitsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetMyBenefitsRequest {
            return GetMyBenefitsRequest.deserialize(bytes);
        }
    }
    export class MyBenefit extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            campaignName?: string;
            status?: string;
            validFrom?: dependency_2.google.protobuf.Timestamp;
            validUntil?: dependency_2.google.protobuf.Timestamp;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("validFrom" in data && data.validFrom != undefined) {
                    this.validFrom = data.validFrom;
                }
                if ("validUntil" in data && data.validUntil != undefined) {
                    this.validUntil = data.validUntil;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set status(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get validFrom() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 4) as dependency_2.google.protobuf.Timestamp;
        }
        set validFrom(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasValidFrom() {
            return pb_1.Message.getField(this, 4) != null;
        }
        get validUntil() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 5) as dependency_2.google.protobuf.Timestamp;
        }
        set validUntil(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 5, value);
        }
        get hasValidUntil() {
            return pb_1.Message.getField(this, 5) != null;
        }
        static fromObject(data: {
            campaignId?: string;
            campaignName?: string;
            status?: string;
            validFrom?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
        }): MyBenefit {
            const message = new MyBenefit({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (data.validFrom != null) {
                message.validFrom = dependency_2.google.protobuf.Timestamp.fromObject(data.validFrom);
            }
            if (data.validUntil != null) {
                message.validUntil = dependency_2.google.protobuf.Timestamp.fromObject(data.validUntil);
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                campaignName?: string;
                status?: string;
                validFrom?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                validUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.validFrom != null) {
                data.validFrom = this.validFrom.toObject();
            }
            if (this.validUntil != null) {
                data.validUntil = this.validUntil.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(2, this.campaignName);
            if (this.status.length)
                writer.writeString(3, this.status);
            if (this.hasValidFrom)
                writer.writeMessage(4, this.validFrom, () => this.validFrom.serialize(writer));
            if (this.hasValidUntil)
                writer.writeMessage(5, this.validUntil, () => this.validUntil.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MyBenefit {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MyBenefit();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.campaignName = reader.readString();
                        break;
                    case 3:
                        message.status = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.validFrom, () => message.validFrom = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 5:
                        reader.readMessage(message.validUntil, () => message.validUntil = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MyBenefit {
            return MyBenefit.deserialize(bytes);
        }
    }
    export class MyRedemption extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            redeemedAt?: dependency_2.google.protobuf.Timestamp;
            effectiveDiscountPercent?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("discountPercent" in data && data.discountPercent != undefined) {
                    this.discountPercent = data.discountPercent;
                }
                if ("baseAmountCents" in data && data.baseAmountCents != undefined) {
                    this.baseAmountCents = data.baseAmountCents;
                }
                if ("discountAmountCents" in data && data.discountAmountCents != undefined) {
                    this.discountAmountCents = data.discountAmountCents;
                }
                if ("redeemedAt" in data && data.redeemedAt != undefined) {
                    this.redeemedAt = data.redeemedAt;
                }
                if ("effectiveDiscountPercent" in data && data.effectiveDiscountPercent != undefined) {
                    this.effectiveDiscountPercent = data.effectiveDiscountPercent;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get discountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set discountPercent(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get baseAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set baseAmountCents(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get discountAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set discountAmountCents(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get redeemedAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 6) as dependency_2.google.protobuf.Timestamp;
        }
        set redeemedAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 6, value);
        }
        get hasRedeemedAt() {
            return pb_1.Message.getField(this, 6) != null;
        }
        get effectiveDiscountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set effectiveDiscountPercent(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        static fromObject(data: {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            redeemedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            effectiveDiscountPercent?: number;
        }): MyRedemption {
            const message = new MyRedemption({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.discountPercent != null) {
                message.discountPercent = data.discountPercent;
            }
            if (data.baseAmountCents != null) {
                message.baseAmountCents = data.baseAmountCents;
            }
            if (data.discountAmountCents != null) {
                message.discountAmountCents = data.discountAmountCents;
            }
            if (data.redeemedAt != null) {
                message.redeemedAt = dependency_2.google.protobuf.Timestamp.fromObject(data.redeemedAt);
            }
            if (data.effectiveDiscountPercent != null) {
                message.effectiveDiscountPercent = data.effectiveDiscountPercent;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                campaignName?: string;
                discountPercent?: number;
                baseAmountCents?: number;
                discountAmountCents?: number;
                redeemedAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                effectiveDiscountPercent?: number;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.discountPercent != null) {
                data.discountPercent = this.discountPercent;
            }
            if (this.baseAmountCents != null) {
                data.baseAmountCents = this.baseAmountCents;
            }
            if (this.discountAmountCents != null) {
                data.discountAmountCents = this.discountAmountCents;
            }
            if (this.redeemedAt != null) {
                data.redeemedAt = this.redeemedAt.toObject();
            }
            if (this.effectiveDiscountPercent != null) {
                data.effectiveDiscountPercent = this.effectiveDiscountPercent;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(2, this.campaignName);
            if (this.discountPercent != 0)
                writer.writeInt32(3, this.discountPercent);
            if (this.baseAmountCents != 0)
                writer.writeInt64(4, this.baseAmountCents);
            if (this.discountAmountCents != 0)
                writer.writeInt64(5, this.discountAmountCents);
            if (this.hasRedeemedAt)
                writer.writeMessage(6, this.redeemedAt, () => this.redeemedAt.serialize(writer));
            if (this.effectiveDiscountPercent != 0)
                writer.writeDouble(7, this.effectiveDiscountPercent);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): MyRedemption {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new MyRedemption();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.campaignName = reader.readString();
                        break;
                    case 3:
                        message.discountPercent = reader.readInt32();
                        break;
                    case 4:
                        message.baseAmountCents = reader.readInt64();
                        break;
                    case 5:
                        message.discountAmountCents = reader.readInt64();
                        break;
                    case 6:
                        reader.readMessage(message.redeemedAt, () => message.redeemedAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 7:
                        message.effectiveDiscountPercent = reader.readDouble();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): MyRedemption {
            return MyRedemption.deserialize(bytes);
        }
    }
    export class GetMyBenefitsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            benefits?: MyBenefit[];
            redemptions?: MyRedemption[];
            totalSavedCents?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1, 2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("benefits" in data && data.benefits != undefined) {
                    this.benefits = data.benefits;
                }
                if ("redemptions" in data && data.redemptions != undefined) {
                    this.redemptions = data.redemptions;
                }
                if ("totalSavedCents" in data && data.totalSavedCents != undefined) {
                    this.totalSavedCents = data.totalSavedCents;
                }
            }
        }
        get benefits() {
            return pb_1.Message.getRepeatedWrapperField(this, MyBenefit, 1) as MyBenefit[];
        }
        set benefits(value: MyBenefit[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        get redemptions() {
            return pb_1.Message.getRepeatedWrapperField(this, MyRedemption, 2) as MyRedemption[];
        }
        set redemptions(value: MyRedemption[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        get totalSavedCents() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set totalSavedCents(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            benefits?: ReturnType<typeof MyBenefit.prototype.toObject>[];
            redemptions?: ReturnType<typeof MyRedemption.prototype.toObject>[];
            totalSavedCents?: number;
        }): GetMyBenefitsResponse {
            const message = new GetMyBenefitsResponse({});
            if (data.benefits != null) {
                message.benefits = data.benefits.map(item => MyBenefit.fromObject(item));
            }
            if (data.redemptions != null) {
                message.redemptions = data.redemptions.map(item => MyRedemption.fromObject(item));
            }
            if (data.totalSavedCents != null) {
                message.totalSavedCents = data.totalSavedCents;
            }
            return message;
        }
        toObject() {
            const data: {
                benefits?: ReturnType<typeof MyBenefit.prototype.toObject>[];
                redemptions?: ReturnType<typeof MyRedemption.prototype.toObject>[];
                totalSavedCents?: number;
            } = {};
            if (this.benefits != null) {
                data.benefits = this.benefits.map((item: MyBenefit) => item.toObject());
            }
            if (this.redemptions != null) {
                data.redemptions = this.redemptions.map((item: MyRedemption) => item.toObject());
            }
            if (this.totalSavedCents != null) {
                data.totalSavedCents = this.totalSavedCents;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.benefits.length)
                writer.writeRepeatedMessage(1, this.benefits, (item: MyBenefit) => item.serialize(writer));
            if (this.redemptions.length)
                writer.writeRepeatedMessage(2, this.redemptions, (item: MyRedemption) => item.serialize(writer));
            if (this.totalSavedCents != 0)
                writer.writeInt64(3, this.totalSavedCents);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetMyBenefitsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetMyBenefitsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.benefits, () => pb_1.Message.addToRepeatedWrapperField(message, 1, MyBenefit.deserialize(reader), MyBenefit));
                        break;
                    case 2:
                        reader.readMessage(message.redemptions, () => pb_1.Message.addToRepeatedWrapperField(message, 2, MyRedemption.deserialize(reader), MyRedemption));
                        break;
                    case 3:
                        message.totalSavedCents = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetMyBenefitsResponse {
            return GetMyBenefitsResponse.deserialize(bytes);
        }
    }
    export class GetCancellationOfferRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetCancellationOfferRequest {
            const message = new GetCancellationOfferRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCancellationOfferRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCancellationOfferRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCancellationOfferRequest {
            return GetCancellationOfferRequest.deserialize(bytes);
        }
    }
    export class CancellationOffer extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            nextChargeAmountCents?: number;
            nextChargeAt?: dependency_2.google.protobuf.Timestamp;
            discountValidUntil?: dependency_2.google.protobuf.Timestamp;
            planId?: string;
            planName?: string;
            creditsEndsInDays?: number;
            effectiveDiscountPercent?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("campaignName" in data && data.campaignName != undefined) {
                    this.campaignName = data.campaignName;
                }
                if ("discountPercent" in data && data.discountPercent != undefined) {
                    this.discountPercent = data.discountPercent;
                }
                if ("discountMaxCents" in data && data.discountMaxCents != undefined) {
                    this.discountMaxCents = data.discountMaxCents;
                }
                if ("baseAmountCents" in data && data.baseAmountCents != undefined) {
                    this.baseAmountCents = data.baseAmountCents;
                }
                if ("discountAmountCents" in data && data.discountAmountCents != undefined) {
                    this.discountAmountCents = data.discountAmountCents;
                }
                if ("nextChargeAmountCents" in data && data.nextChargeAmountCents != undefined) {
                    this.nextChargeAmountCents = data.nextChargeAmountCents;
                }
                if ("nextChargeAt" in data && data.nextChargeAt != undefined) {
                    this.nextChargeAt = data.nextChargeAt;
                }
                if ("discountValidUntil" in data && data.discountValidUntil != undefined) {
                    this.discountValidUntil = data.discountValidUntil;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("planName" in data && data.planName != undefined) {
                    this.planName = data.planName;
                }
                if ("creditsEndsInDays" in data && data.creditsEndsInDays != undefined) {
                    this.creditsEndsInDays = data.creditsEndsInDays;
                }
                if ("effectiveDiscountPercent" in data && data.effectiveDiscountPercent != undefined) {
                    this.effectiveDiscountPercent = data.effectiveDiscountPercent;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get campaignName() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set campaignName(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get discountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set discountPercent(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        get discountMaxCents() {
            return pb_1.Message.getFieldWithDefault(this, 4, 0) as number;
        }
        set discountMaxCents(value: number) {
            pb_1.Message.setField(this, 4, value);
        }
        get baseAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 5, 0) as number;
        }
        set baseAmountCents(value: number) {
            pb_1.Message.setField(this, 5, value);
        }
        get discountAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 6, 0) as number;
        }
        set discountAmountCents(value: number) {
            pb_1.Message.setField(this, 6, value);
        }
        get nextChargeAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 7, 0) as number;
        }
        set nextChargeAmountCents(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get nextChargeAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 8) as dependency_2.google.protobuf.Timestamp;
        }
        set nextChargeAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 8, value);
        }
        get hasNextChargeAt() {
            return pb_1.Message.getField(this, 8) != null;
        }
        get discountValidUntil() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 9) as dependency_2.google.protobuf.Timestamp;
        }
        set discountValidUntil(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 9, value);
        }
        get hasDiscountValidUntil() {
            return pb_1.Message.getField(this, 9) != null;
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get planName() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set planName(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get creditsEndsInDays() {
            return pb_1.Message.getFieldWithDefault(this, 12, 0) as number;
        }
        set creditsEndsInDays(value: number) {
            pb_1.Message.setField(this, 12, value);
        }
        get effectiveDiscountPercent() {
            return pb_1.Message.getFieldWithDefault(this, 13, 0) as number;
        }
        set effectiveDiscountPercent(value: number) {
            pb_1.Message.setField(this, 13, value);
        }
        static fromObject(data: {
            campaignId?: string;
            campaignName?: string;
            discountPercent?: number;
            discountMaxCents?: number;
            baseAmountCents?: number;
            discountAmountCents?: number;
            nextChargeAmountCents?: number;
            nextChargeAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            discountValidUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            planId?: string;
            planName?: string;
            creditsEndsInDays?: number;
            effectiveDiscountPercent?: number;
        }): CancellationOffer {
            const message = new CancellationOffer({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.campaignName != null) {
                message.campaignName = data.campaignName;
            }
            if (data.discountPercent != null) {
                message.discountPercent = data.discountPercent;
            }
            if (data.discountMaxCents != null) {
                message.discountMaxCents = data.discountMaxCents;
            }
            if (data.baseAmountCents != null) {
                message.baseAmountCents = data.baseAmountCents;
            }
            if (data.discountAmountCents != null) {
                message.discountAmountCents = data.discountAmountCents;
            }
            if (data.nextChargeAmountCents != null) {
                message.nextChargeAmountCents = data.nextChargeAmountCents;
            }
            if (data.nextChargeAt != null) {
                message.nextChargeAt = dependency_2.google.protobuf.Timestamp.fromObject(data.nextChargeAt);
            }
            if (data.discountValidUntil != null) {
                message.discountValidUntil = dependency_2.google.protobuf.Timestamp.fromObject(data.discountValidUntil);
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.planName != null) {
                message.planName = data.planName;
            }
            if (data.creditsEndsInDays != null) {
                message.creditsEndsInDays = data.creditsEndsInDays;
            }
            if (data.effectiveDiscountPercent != null) {
                message.effectiveDiscountPercent = data.effectiveDiscountPercent;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                campaignName?: string;
                discountPercent?: number;
                discountMaxCents?: number;
                baseAmountCents?: number;
                discountAmountCents?: number;
                nextChargeAmountCents?: number;
                nextChargeAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                discountValidUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                planId?: string;
                planName?: string;
                creditsEndsInDays?: number;
                effectiveDiscountPercent?: number;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.campaignName != null) {
                data.campaignName = this.campaignName;
            }
            if (this.discountPercent != null) {
                data.discountPercent = this.discountPercent;
            }
            if (this.discountMaxCents != null) {
                data.discountMaxCents = this.discountMaxCents;
            }
            if (this.baseAmountCents != null) {
                data.baseAmountCents = this.baseAmountCents;
            }
            if (this.discountAmountCents != null) {
                data.discountAmountCents = this.discountAmountCents;
            }
            if (this.nextChargeAmountCents != null) {
                data.nextChargeAmountCents = this.nextChargeAmountCents;
            }
            if (this.nextChargeAt != null) {
                data.nextChargeAt = this.nextChargeAt.toObject();
            }
            if (this.discountValidUntil != null) {
                data.discountValidUntil = this.discountValidUntil.toObject();
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.planName != null) {
                data.planName = this.planName;
            }
            if (this.creditsEndsInDays != null) {
                data.creditsEndsInDays = this.creditsEndsInDays;
            }
            if (this.effectiveDiscountPercent != null) {
                data.effectiveDiscountPercent = this.effectiveDiscountPercent;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.campaignName.length)
                writer.writeString(2, this.campaignName);
            if (this.discountPercent != 0)
                writer.writeInt32(3, this.discountPercent);
            if (this.discountMaxCents != 0)
                writer.writeInt64(4, this.discountMaxCents);
            if (this.baseAmountCents != 0)
                writer.writeInt64(5, this.baseAmountCents);
            if (this.discountAmountCents != 0)
                writer.writeInt64(6, this.discountAmountCents);
            if (this.nextChargeAmountCents != 0)
                writer.writeInt64(7, this.nextChargeAmountCents);
            if (this.hasNextChargeAt)
                writer.writeMessage(8, this.nextChargeAt, () => this.nextChargeAt.serialize(writer));
            if (this.hasDiscountValidUntil)
                writer.writeMessage(9, this.discountValidUntil, () => this.discountValidUntil.serialize(writer));
            if (this.planId.length)
                writer.writeString(10, this.planId);
            if (this.planName.length)
                writer.writeString(11, this.planName);
            if (this.creditsEndsInDays != 0)
                writer.writeInt64(12, this.creditsEndsInDays);
            if (this.effectiveDiscountPercent != 0)
                writer.writeDouble(13, this.effectiveDiscountPercent);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancellationOffer {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancellationOffer();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.campaignName = reader.readString();
                        break;
                    case 3:
                        message.discountPercent = reader.readInt32();
                        break;
                    case 4:
                        message.discountMaxCents = reader.readInt64();
                        break;
                    case 5:
                        message.baseAmountCents = reader.readInt64();
                        break;
                    case 6:
                        message.discountAmountCents = reader.readInt64();
                        break;
                    case 7:
                        message.nextChargeAmountCents = reader.readInt64();
                        break;
                    case 8:
                        reader.readMessage(message.nextChargeAt, () => message.nextChargeAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 9:
                        reader.readMessage(message.discountValidUntil, () => message.discountValidUntil = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 10:
                        message.planId = reader.readString();
                        break;
                    case 11:
                        message.planName = reader.readString();
                        break;
                    case 12:
                        message.creditsEndsInDays = reader.readInt64();
                        break;
                    case 13:
                        message.effectiveDiscountPercent = reader.readDouble();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CancellationOffer {
            return CancellationOffer.deserialize(bytes);
        }
    }
    export class GetCancellationOfferResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            offer?: CancellationOffer;
            offers?: CancellationOffer[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("offer" in data && data.offer != undefined) {
                    this.offer = data.offer;
                }
                if ("offers" in data && data.offers != undefined) {
                    this.offers = data.offers;
                }
            }
        }
        get offer() {
            return pb_1.Message.getWrapperField(this, CancellationOffer, 1) as CancellationOffer;
        }
        set offer(value: CancellationOffer) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasOffer() {
            return pb_1.Message.getField(this, 1) != null;
        }
        get offers() {
            return pb_1.Message.getRepeatedWrapperField(this, CancellationOffer, 2) as CancellationOffer[];
        }
        set offers(value: CancellationOffer[]) {
            pb_1.Message.setRepeatedWrapperField(this, 2, value);
        }
        static fromObject(data: {
            offer?: ReturnType<typeof CancellationOffer.prototype.toObject>;
            offers?: ReturnType<typeof CancellationOffer.prototype.toObject>[];
        }): GetCancellationOfferResponse {
            const message = new GetCancellationOfferResponse({});
            if (data.offer != null) {
                message.offer = CancellationOffer.fromObject(data.offer);
            }
            if (data.offers != null) {
                message.offers = data.offers.map(item => CancellationOffer.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                offer?: ReturnType<typeof CancellationOffer.prototype.toObject>;
                offers?: ReturnType<typeof CancellationOffer.prototype.toObject>[];
            } = {};
            if (this.offer != null) {
                data.offer = this.offer.toObject();
            }
            if (this.offers != null) {
                data.offers = this.offers.map((item: CancellationOffer) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasOffer)
                writer.writeMessage(1, this.offer, () => this.offer.serialize(writer));
            if (this.offers.length)
                writer.writeRepeatedMessage(2, this.offers, (item: CancellationOffer) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCancellationOfferResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCancellationOfferResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.offer, () => message.offer = CancellationOffer.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.offers, () => pb_1.Message.addToRepeatedWrapperField(message, 2, CancellationOffer.deserialize(reader), CancellationOffer));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCancellationOfferResponse {
            return GetCancellationOfferResponse.deserialize(bytes);
        }
    }
    export class AcceptCancellationOfferRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            campaignId?: string;
            planId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("campaignId" in data && data.campaignId != undefined) {
                    this.campaignId = data.campaignId;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
            }
        }
        get campaignId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set campaignId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            campaignId?: string;
            planId?: string;
        }): AcceptCancellationOfferRequest {
            const message = new AcceptCancellationOfferRequest({});
            if (data.campaignId != null) {
                message.campaignId = data.campaignId;
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            return message;
        }
        toObject() {
            const data: {
                campaignId?: string;
                planId?: string;
            } = {};
            if (this.campaignId != null) {
                data.campaignId = this.campaignId;
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.campaignId.length)
                writer.writeString(1, this.campaignId);
            if (this.planId.length)
                writer.writeString(2, this.planId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AcceptCancellationOfferRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AcceptCancellationOfferRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.campaignId = reader.readString();
                        break;
                    case 2:
                        message.planId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AcceptCancellationOfferRequest {
            return AcceptCancellationOfferRequest.deserialize(bytes);
        }
    }
    export class AcceptCancellationOfferResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            nextChargeAmountCents?: number;
            nextChargeAt?: dependency_2.google.protobuf.Timestamp;
            discountValidUntil?: dependency_2.google.protobuf.Timestamp;
            planId?: string;
            checkoutId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("nextChargeAmountCents" in data && data.nextChargeAmountCents != undefined) {
                    this.nextChargeAmountCents = data.nextChargeAmountCents;
                }
                if ("nextChargeAt" in data && data.nextChargeAt != undefined) {
                    this.nextChargeAt = data.nextChargeAt;
                }
                if ("discountValidUntil" in data && data.discountValidUntil != undefined) {
                    this.discountValidUntil = data.discountValidUntil;
                }
                if ("planId" in data && data.planId != undefined) {
                    this.planId = data.planId;
                }
                if ("checkoutId" in data && data.checkoutId != undefined) {
                    this.checkoutId = data.checkoutId;
                }
            }
        }
        get nextChargeAmountCents() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set nextChargeAmountCents(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get nextChargeAt() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 2) as dependency_2.google.protobuf.Timestamp;
        }
        set nextChargeAt(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        get hasNextChargeAt() {
            return pb_1.Message.getField(this, 2) != null;
        }
        get discountValidUntil() {
            return pb_1.Message.getWrapperField(this, dependency_2.google.protobuf.Timestamp, 3) as dependency_2.google.protobuf.Timestamp;
        }
        set discountValidUntil(value: dependency_2.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasDiscountValidUntil() {
            return pb_1.Message.getField(this, 3) != null;
        }
        get planId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set planId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get checkoutId() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set checkoutId(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        static fromObject(data: {
            nextChargeAmountCents?: number;
            nextChargeAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            discountValidUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
            planId?: string;
            checkoutId?: string;
        }): AcceptCancellationOfferResponse {
            const message = new AcceptCancellationOfferResponse({});
            if (data.nextChargeAmountCents != null) {
                message.nextChargeAmountCents = data.nextChargeAmountCents;
            }
            if (data.nextChargeAt != null) {
                message.nextChargeAt = dependency_2.google.protobuf.Timestamp.fromObject(data.nextChargeAt);
            }
            if (data.discountValidUntil != null) {
                message.discountValidUntil = dependency_2.google.protobuf.Timestamp.fromObject(data.discountValidUntil);
            }
            if (data.planId != null) {
                message.planId = data.planId;
            }
            if (data.checkoutId != null) {
                message.checkoutId = data.checkoutId;
            }
            return message;
        }
        toObject() {
            const data: {
                nextChargeAmountCents?: number;
                nextChargeAt?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                discountValidUntil?: ReturnType<typeof dependency_2.google.protobuf.Timestamp.prototype.toObject>;
                planId?: string;
                checkoutId?: string;
            } = {};
            if (this.nextChargeAmountCents != null) {
                data.nextChargeAmountCents = this.nextChargeAmountCents;
            }
            if (this.nextChargeAt != null) {
                data.nextChargeAt = this.nextChargeAt.toObject();
            }
            if (this.discountValidUntil != null) {
                data.discountValidUntil = this.discountValidUntil.toObject();
            }
            if (this.planId != null) {
                data.planId = this.planId;
            }
            if (this.checkoutId != null) {
                data.checkoutId = this.checkoutId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.nextChargeAmountCents != 0)
                writer.writeInt64(1, this.nextChargeAmountCents);
            if (this.hasNextChargeAt)
                writer.writeMessage(2, this.nextChargeAt, () => this.nextChargeAt.serialize(writer));
            if (this.hasDiscountValidUntil)
                writer.writeMessage(3, this.discountValidUntil, () => this.discountValidUntil.serialize(writer));
            if (this.planId.length)
                writer.writeString(4, this.planId);
            if (this.checkoutId.length)
                writer.writeString(5, this.checkoutId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): AcceptCancellationOfferResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new AcceptCancellationOfferResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.nextChargeAmountCents = reader.readInt64();
                        break;
                    case 2:
                        reader.readMessage(message.nextChargeAt, () => message.nextChargeAt = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 3:
                        reader.readMessage(message.discountValidUntil, () => message.discountValidUntil = dependency_2.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 4:
                        message.planId = reader.readString();
                        break;
                    case 5:
                        message.checkoutId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): AcceptCancellationOfferResponse {
            return AcceptCancellationOfferResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedSubscriptionServiceService {
        static definition = {
            SubmitLeadInquiry: {
                path: "/subscriptions.v1.SubscriptionService/SubmitLeadInquiry",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: SubmitLeadInquiryRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => SubmitLeadInquiryRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: SubmitLeadInquiryResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => SubmitLeadInquiryResponse.deserialize(new Uint8Array(bytes))
            },
            CreateSubscriptionFreeAdmin: {
                path: "/subscriptions.v1.SubscriptionService/CreateSubscriptionFreeAdmin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateSubscriptionFreeAdminRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateSubscriptionFreeAdminRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateSubscriptionFreeAdminResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateSubscriptionFreeAdminResponse.deserialize(new Uint8Array(bytes))
            },
            CreateSubscriptionAdmin: {
                path: "/subscriptions.v1.SubscriptionService/CreateSubscriptionAdmin",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateSubscriptionAdminRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateSubscriptionAdminRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateSubscriptionAdminResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateSubscriptionAdminResponse.deserialize(new Uint8Array(bytes))
            },
            RequestPayment: {
                path: "/subscriptions.v1.SubscriptionService/RequestPayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RequestPaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RequestPaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RequestPaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RequestPaymentResponse.deserialize(new Uint8Array(bytes))
            },
            CreateSubscription: {
                path: "/subscriptions.v1.SubscriptionService/CreateSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscription: {
                path: "/subscriptions.v1.SubscriptionService/GetSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteSubscription: {
                path: "/subscriptions.v1.SubscriptionService/DeleteSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            ListSubscription: {
                path: "/subscriptions.v1.SubscriptionService/ListSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscriptionDetails: {
                path: "/subscriptions.v1.SubscriptionService/GetSubscriptionDetails",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionDetailsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionDetailsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionDetailsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionDetailsResponse.deserialize(new Uint8Array(bytes))
            },
            GetCurrentSubscription: {
                path: "/subscriptions.v1.SubscriptionService/GetCurrentSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetCurrentSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetCurrentSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetCurrentSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetCurrentSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            GetActiveSubscription: {
                path: "/subscriptions.v1.SubscriptionService/GetActiveSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetActiveSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetActiveSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetActiveSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetActiveSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            CancelSubscriptionInvitation: {
                path: "/subscriptions.v1.SubscriptionService/CancelSubscriptionInvitation",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CancelSubscriptionInvitationRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CancelSubscriptionInvitationRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CancelSubscriptionInvitationResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CancelSubscriptionInvitationResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscriptionInvitation: {
                path: "/subscriptions.v1.SubscriptionService/GetSubscriptionInvitation",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionInvitationRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionInvitationRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionInvitationResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionInvitationResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateSubscription: {
                path: "/subscriptions.v1.SubscriptionService/UpdateSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            MergeSubscriptionMetadata: {
                path: "/subscriptions.v1.SubscriptionService/MergeSubscriptionMetadata",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: MergeSubscriptionMetadataRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => MergeSubscriptionMetadataRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: MergeSubscriptionMetadataResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => MergeSubscriptionMetadataResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateCurrentCycle: {
                path: "/subscriptions.v1.SubscriptionService/UpdateCurrentCycle",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateCurrentCycleRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateCurrentCycleRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateCurrentCycleResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateCurrentCycleResponse.deserialize(new Uint8Array(bytes))
            },
            AppendCycleStepHistory: {
                path: "/subscriptions.v1.SubscriptionService/AppendCycleStepHistory",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: AppendCycleStepHistoryRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => AppendCycleStepHistoryRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AppendCycleStepHistoryResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AppendCycleStepHistoryResponse.deserialize(new Uint8Array(bytes))
            },
            DeactivateSubscription: {
                path: "/subscriptions.v1.SubscriptionService/DeactivateSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeactivateSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeactivateSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeactivateSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeactivateSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            UpgradePlan: {
                path: "/subscriptions.v1.SubscriptionService/UpgradePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpgradePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpgradePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpgradePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpgradePlanResponse.deserialize(new Uint8Array(bytes))
            },
            DowngradePlan: {
                path: "/subscriptions.v1.SubscriptionService/DowngradePlan",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DowngradePlanRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DowngradePlanRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DowngradePlanResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DowngradePlanResponse.deserialize(new Uint8Array(bytes))
            },
            GetActiveSubscribersReport: {
                path: "/subscriptions.v1.SubscriptionService/GetActiveSubscribersReport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ActiveSubscribersReportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ActiveSubscribersReportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ActiveSubscribersReportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ActiveSubscribersReportResponse.deserialize(new Uint8Array(bytes))
            },
            ListSubscriptionsSlim: {
                path: "/subscriptions.v1.SubscriptionService/ListSubscriptionsSlim",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListSubscriptionsSlimRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListSubscriptionsSlimRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListSubscriptionsSlimResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListSubscriptionsSlimResponse.deserialize(new Uint8Array(bytes))
            },
            UpdateDefaultPayment: {
                path: "/subscriptions.v1.SubscriptionService/UpdateDefaultPayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: UpdateDefaultPaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => UpdateDefaultPaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: UpdateDefaultPaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => UpdateDefaultPaymentResponse.deserialize(new Uint8Array(bytes))
            },
            GetDefaultPayment: {
                path: "/subscriptions.v1.SubscriptionService/GetDefaultPayment",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetDefaultPaymentRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetDefaultPaymentRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetDefaultPaymentResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetDefaultPaymentResponse.deserialize(new Uint8Array(bytes))
            },
            RequestSubscriptionExport: {
                path: "/subscriptions.v1.SubscriptionService/RequestSubscriptionExport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RequestSubscriptionExportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RequestSubscriptionExportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RequestSubscriptionExportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RequestSubscriptionExportResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscriptionExport: {
                path: "/subscriptions.v1.SubscriptionService/GetSubscriptionExport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionExportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionExportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionExportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionExportResponse.deserialize(new Uint8Array(bytes))
            },
            GetUserSubscription: {
                path: "/subscriptions.v1.SubscriptionService/GetUserSubscription",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetUserSubscriptionRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetUserSubscriptionRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetUserSubscriptionResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetUserSubscriptionResponse.deserialize(new Uint8Array(bytes))
            },
            GetMyOffers: {
                path: "/subscriptions.v1.SubscriptionService/GetMyOffers",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetMyOffersRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetMyOffersRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetMyOffersResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetMyOffersResponse.deserialize(new Uint8Array(bytes))
            },
            GetMyBenefits: {
                path: "/subscriptions.v1.SubscriptionService/GetMyBenefits",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetMyBenefitsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetMyBenefitsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetMyBenefitsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetMyBenefitsResponse.deserialize(new Uint8Array(bytes))
            },
            GetCancellationOffer: {
                path: "/subscriptions.v1.SubscriptionService/GetCancellationOffer",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetCancellationOfferRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetCancellationOfferRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetCancellationOfferResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetCancellationOfferResponse.deserialize(new Uint8Array(bytes))
            },
            AcceptCancellationOffer: {
                path: "/subscriptions.v1.SubscriptionService/AcceptCancellationOffer",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: AcceptCancellationOfferRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => AcceptCancellationOfferRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: AcceptCancellationOfferResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => AcceptCancellationOfferResponse.deserialize(new Uint8Array(bytes))
            },
            GetSubscriptionReport: {
                path: "/subscriptions.v1.SubscriptionService/GetSubscriptionReport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSubscriptionReportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSubscriptionReportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSubscriptionReportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSubscriptionReportResponse.deserialize(new Uint8Array(bytes))
            },
            GetRetentionReport: {
                path: "/subscriptions.v1.SubscriptionService/GetRetentionReport",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetRetentionReportRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetRetentionReportRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetRetentionReportResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetRetentionReportResponse.deserialize(new Uint8Array(bytes))
            },
            ListSubscriptionsWithCycleProblems: {
                path: "/subscriptions.v1.SubscriptionService/ListSubscriptionsWithCycleProblems",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListSubscriptionsWithCycleProblemsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListSubscriptionsWithCycleProblemsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListSubscriptionsWithCycleProblemsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListSubscriptionsWithCycleProblemsResponse.deserialize(new Uint8Array(bytes))
            },
            GetPartnerSubscriptionDetails: {
                path: "/subscriptions.v1.SubscriptionService/GetPartnerSubscriptionDetails",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetPartnerSubscriptionDetailsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetPartnerSubscriptionDetailsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetPartnerSubscriptionDetailsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetPartnerSubscriptionDetailsResponse.deserialize(new Uint8Array(bytes))
            },
            ListPartnerSubscriptions: {
                path: "/subscriptions.v1.SubscriptionService/ListPartnerSubscriptions",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: ListPartnerSubscriptionsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => ListPartnerSubscriptionsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: ListPartnerSubscriptionsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => ListPartnerSubscriptionsResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract SubmitLeadInquiry(call: grpc_1.ServerUnaryCall<SubmitLeadInquiryRequest, SubmitLeadInquiryResponse>, callback: grpc_1.sendUnaryData<SubmitLeadInquiryResponse>): void;
        abstract CreateSubscriptionFreeAdmin(call: grpc_1.ServerUnaryCall<CreateSubscriptionFreeAdminRequest, CreateSubscriptionFreeAdminResponse>, callback: grpc_1.sendUnaryData<CreateSubscriptionFreeAdminResponse>): void;
        abstract CreateSubscriptionAdmin(call: grpc_1.ServerUnaryCall<CreateSubscriptionAdminRequest, CreateSubscriptionAdminResponse>, callback: grpc_1.sendUnaryData<CreateSubscriptionAdminResponse>): void;
        abstract RequestPayment(call: grpc_1.ServerUnaryCall<RequestPaymentRequest, RequestPaymentResponse>, callback: grpc_1.sendUnaryData<RequestPaymentResponse>): void;
        abstract CreateSubscription(call: grpc_1.ServerUnaryCall<CreateSubscriptionRequest, CreateSubscriptionResponse>, callback: grpc_1.sendUnaryData<CreateSubscriptionResponse>): void;
        abstract GetSubscription(call: grpc_1.ServerUnaryCall<GetSubscriptionRequest, GetSubscriptionResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionResponse>): void;
        abstract DeleteSubscription(call: grpc_1.ServerUnaryCall<DeleteSubscriptionRequest, DeleteSubscriptionResponse>, callback: grpc_1.sendUnaryData<DeleteSubscriptionResponse>): void;
        abstract ListSubscription(call: grpc_1.ServerUnaryCall<ListSubscriptionRequest, ListSubscriptionResponse>, callback: grpc_1.sendUnaryData<ListSubscriptionResponse>): void;
        abstract GetSubscriptionDetails(call: grpc_1.ServerUnaryCall<GetSubscriptionDetailsRequest, GetSubscriptionDetailsResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionDetailsResponse>): void;
        abstract GetCurrentSubscription(call: grpc_1.ServerUnaryCall<GetCurrentSubscriptionRequest, GetCurrentSubscriptionResponse>, callback: grpc_1.sendUnaryData<GetCurrentSubscriptionResponse>): void;
        abstract GetActiveSubscription(call: grpc_1.ServerUnaryCall<GetActiveSubscriptionRequest, GetActiveSubscriptionResponse>, callback: grpc_1.sendUnaryData<GetActiveSubscriptionResponse>): void;
        abstract CancelSubscriptionInvitation(call: grpc_1.ServerUnaryCall<CancelSubscriptionInvitationRequest, CancelSubscriptionInvitationResponse>, callback: grpc_1.sendUnaryData<CancelSubscriptionInvitationResponse>): void;
        abstract GetSubscriptionInvitation(call: grpc_1.ServerUnaryCall<GetSubscriptionInvitationRequest, GetSubscriptionInvitationResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionInvitationResponse>): void;
        abstract UpdateSubscription(call: grpc_1.ServerUnaryCall<UpdateSubscriptionRequest, UpdateSubscriptionResponse>, callback: grpc_1.sendUnaryData<UpdateSubscriptionResponse>): void;
        abstract MergeSubscriptionMetadata(call: grpc_1.ServerUnaryCall<MergeSubscriptionMetadataRequest, MergeSubscriptionMetadataResponse>, callback: grpc_1.sendUnaryData<MergeSubscriptionMetadataResponse>): void;
        abstract UpdateCurrentCycle(call: grpc_1.ServerUnaryCall<UpdateCurrentCycleRequest, UpdateCurrentCycleResponse>, callback: grpc_1.sendUnaryData<UpdateCurrentCycleResponse>): void;
        abstract AppendCycleStepHistory(call: grpc_1.ServerUnaryCall<AppendCycleStepHistoryRequest, AppendCycleStepHistoryResponse>, callback: grpc_1.sendUnaryData<AppendCycleStepHistoryResponse>): void;
        abstract DeactivateSubscription(call: grpc_1.ServerUnaryCall<DeactivateSubscriptionRequest, DeactivateSubscriptionResponse>, callback: grpc_1.sendUnaryData<DeactivateSubscriptionResponse>): void;
        abstract UpgradePlan(call: grpc_1.ServerUnaryCall<UpgradePlanRequest, UpgradePlanResponse>, callback: grpc_1.sendUnaryData<UpgradePlanResponse>): void;
        abstract DowngradePlan(call: grpc_1.ServerUnaryCall<DowngradePlanRequest, DowngradePlanResponse>, callback: grpc_1.sendUnaryData<DowngradePlanResponse>): void;
        abstract GetActiveSubscribersReport(call: grpc_1.ServerUnaryCall<ActiveSubscribersReportRequest, ActiveSubscribersReportResponse>, callback: grpc_1.sendUnaryData<ActiveSubscribersReportResponse>): void;
        abstract ListSubscriptionsSlim(call: grpc_1.ServerUnaryCall<ListSubscriptionsSlimRequest, ListSubscriptionsSlimResponse>, callback: grpc_1.sendUnaryData<ListSubscriptionsSlimResponse>): void;
        abstract UpdateDefaultPayment(call: grpc_1.ServerUnaryCall<UpdateDefaultPaymentRequest, UpdateDefaultPaymentResponse>, callback: grpc_1.sendUnaryData<UpdateDefaultPaymentResponse>): void;
        abstract GetDefaultPayment(call: grpc_1.ServerUnaryCall<GetDefaultPaymentRequest, GetDefaultPaymentResponse>, callback: grpc_1.sendUnaryData<GetDefaultPaymentResponse>): void;
        abstract RequestSubscriptionExport(call: grpc_1.ServerUnaryCall<RequestSubscriptionExportRequest, RequestSubscriptionExportResponse>, callback: grpc_1.sendUnaryData<RequestSubscriptionExportResponse>): void;
        abstract GetSubscriptionExport(call: grpc_1.ServerUnaryCall<GetSubscriptionExportRequest, GetSubscriptionExportResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionExportResponse>): void;
        abstract GetUserSubscription(call: grpc_1.ServerUnaryCall<GetUserSubscriptionRequest, GetUserSubscriptionResponse>, callback: grpc_1.sendUnaryData<GetUserSubscriptionResponse>): void;
        abstract GetMyOffers(call: grpc_1.ServerUnaryCall<GetMyOffersRequest, GetMyOffersResponse>, callback: grpc_1.sendUnaryData<GetMyOffersResponse>): void;
        abstract GetMyBenefits(call: grpc_1.ServerUnaryCall<GetMyBenefitsRequest, GetMyBenefitsResponse>, callback: grpc_1.sendUnaryData<GetMyBenefitsResponse>): void;
        abstract GetCancellationOffer(call: grpc_1.ServerUnaryCall<GetCancellationOfferRequest, GetCancellationOfferResponse>, callback: grpc_1.sendUnaryData<GetCancellationOfferResponse>): void;
        abstract AcceptCancellationOffer(call: grpc_1.ServerUnaryCall<AcceptCancellationOfferRequest, AcceptCancellationOfferResponse>, callback: grpc_1.sendUnaryData<AcceptCancellationOfferResponse>): void;
        abstract GetSubscriptionReport(call: grpc_1.ServerUnaryCall<GetSubscriptionReportRequest, GetSubscriptionReportResponse>, callback: grpc_1.sendUnaryData<GetSubscriptionReportResponse>): void;
        abstract GetRetentionReport(call: grpc_1.ServerUnaryCall<GetRetentionReportRequest, GetRetentionReportResponse>, callback: grpc_1.sendUnaryData<GetRetentionReportResponse>): void;
        abstract ListSubscriptionsWithCycleProblems(call: grpc_1.ServerUnaryCall<ListSubscriptionsWithCycleProblemsRequest, ListSubscriptionsWithCycleProblemsResponse>, callback: grpc_1.sendUnaryData<ListSubscriptionsWithCycleProblemsResponse>): void;
        abstract GetPartnerSubscriptionDetails(call: grpc_1.ServerUnaryCall<GetPartnerSubscriptionDetailsRequest, GetPartnerSubscriptionDetailsResponse>, callback: grpc_1.sendUnaryData<GetPartnerSubscriptionDetailsResponse>): void;
        abstract ListPartnerSubscriptions(call: grpc_1.ServerUnaryCall<ListPartnerSubscriptionsRequest, ListPartnerSubscriptionsResponse>, callback: grpc_1.sendUnaryData<ListPartnerSubscriptionsResponse>): void;
    }
    export class SubscriptionServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static SubmitLeadInquiry = new grpc_web_1.MethodDescriptor<SubmitLeadInquiryRequest, SubmitLeadInquiryResponse>("/subscriptions.v1.SubscriptionService/SubmitLeadInquiry", grpc_web_1.MethodType.UNARY, SubmitLeadInquiryRequest, SubmitLeadInquiryResponse, (message: SubmitLeadInquiryRequest) => message.serialize(), SubmitLeadInquiryResponse.deserialize);
        SubmitLeadInquiry(message: SubmitLeadInquiryRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<SubmitLeadInquiryRequest, SubmitLeadInquiryResponse>(this._address + "/subscriptions.v1.SubscriptionService/SubmitLeadInquiry", message, metadata || {}, SubscriptionServiceClient.SubmitLeadInquiry);
        }
        private static CreateSubscriptionFreeAdmin = new grpc_web_1.MethodDescriptor<CreateSubscriptionFreeAdminRequest, CreateSubscriptionFreeAdminResponse>("/subscriptions.v1.SubscriptionService/CreateSubscriptionFreeAdmin", grpc_web_1.MethodType.UNARY, CreateSubscriptionFreeAdminRequest, CreateSubscriptionFreeAdminResponse, (message: CreateSubscriptionFreeAdminRequest) => message.serialize(), CreateSubscriptionFreeAdminResponse.deserialize);
        CreateSubscriptionFreeAdmin(message: CreateSubscriptionFreeAdminRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateSubscriptionFreeAdminRequest, CreateSubscriptionFreeAdminResponse>(this._address + "/subscriptions.v1.SubscriptionService/CreateSubscriptionFreeAdmin", message, metadata || {}, SubscriptionServiceClient.CreateSubscriptionFreeAdmin);
        }
        private static CreateSubscriptionAdmin = new grpc_web_1.MethodDescriptor<CreateSubscriptionAdminRequest, CreateSubscriptionAdminResponse>("/subscriptions.v1.SubscriptionService/CreateSubscriptionAdmin", grpc_web_1.MethodType.UNARY, CreateSubscriptionAdminRequest, CreateSubscriptionAdminResponse, (message: CreateSubscriptionAdminRequest) => message.serialize(), CreateSubscriptionAdminResponse.deserialize);
        CreateSubscriptionAdmin(message: CreateSubscriptionAdminRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateSubscriptionAdminRequest, CreateSubscriptionAdminResponse>(this._address + "/subscriptions.v1.SubscriptionService/CreateSubscriptionAdmin", message, metadata || {}, SubscriptionServiceClient.CreateSubscriptionAdmin);
        }
        private static RequestPayment = new grpc_web_1.MethodDescriptor<RequestPaymentRequest, RequestPaymentResponse>("/subscriptions.v1.SubscriptionService/RequestPayment", grpc_web_1.MethodType.UNARY, RequestPaymentRequest, RequestPaymentResponse, (message: RequestPaymentRequest) => message.serialize(), RequestPaymentResponse.deserialize);
        RequestPayment(message: RequestPaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<RequestPaymentRequest, RequestPaymentResponse>(this._address + "/subscriptions.v1.SubscriptionService/RequestPayment", message, metadata || {}, SubscriptionServiceClient.RequestPayment);
        }
        private static CreateSubscription = new grpc_web_1.MethodDescriptor<CreateSubscriptionRequest, CreateSubscriptionResponse>("/subscriptions.v1.SubscriptionService/CreateSubscription", grpc_web_1.MethodType.UNARY, CreateSubscriptionRequest, CreateSubscriptionResponse, (message: CreateSubscriptionRequest) => message.serialize(), CreateSubscriptionResponse.deserialize);
        CreateSubscription(message: CreateSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CreateSubscriptionRequest, CreateSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/CreateSubscription", message, metadata || {}, SubscriptionServiceClient.CreateSubscription);
        }
        private static GetSubscription = new grpc_web_1.MethodDescriptor<GetSubscriptionRequest, GetSubscriptionResponse>("/subscriptions.v1.SubscriptionService/GetSubscription", grpc_web_1.MethodType.UNARY, GetSubscriptionRequest, GetSubscriptionResponse, (message: GetSubscriptionRequest) => message.serialize(), GetSubscriptionResponse.deserialize);
        GetSubscription(message: GetSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionRequest, GetSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetSubscription", message, metadata || {}, SubscriptionServiceClient.GetSubscription);
        }
        private static DeleteSubscription = new grpc_web_1.MethodDescriptor<DeleteSubscriptionRequest, DeleteSubscriptionResponse>("/subscriptions.v1.SubscriptionService/DeleteSubscription", grpc_web_1.MethodType.UNARY, DeleteSubscriptionRequest, DeleteSubscriptionResponse, (message: DeleteSubscriptionRequest) => message.serialize(), DeleteSubscriptionResponse.deserialize);
        DeleteSubscription(message: DeleteSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteSubscriptionRequest, DeleteSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/DeleteSubscription", message, metadata || {}, SubscriptionServiceClient.DeleteSubscription);
        }
        private static ListSubscription = new grpc_web_1.MethodDescriptor<ListSubscriptionRequest, ListSubscriptionResponse>("/subscriptions.v1.SubscriptionService/ListSubscription", grpc_web_1.MethodType.UNARY, ListSubscriptionRequest, ListSubscriptionResponse, (message: ListSubscriptionRequest) => message.serialize(), ListSubscriptionResponse.deserialize);
        ListSubscription(message: ListSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListSubscriptionRequest, ListSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/ListSubscription", message, metadata || {}, SubscriptionServiceClient.ListSubscription);
        }
        private static GetSubscriptionDetails = new grpc_web_1.MethodDescriptor<GetSubscriptionDetailsRequest, GetSubscriptionDetailsResponse>("/subscriptions.v1.SubscriptionService/GetSubscriptionDetails", grpc_web_1.MethodType.UNARY, GetSubscriptionDetailsRequest, GetSubscriptionDetailsResponse, (message: GetSubscriptionDetailsRequest) => message.serialize(), GetSubscriptionDetailsResponse.deserialize);
        GetSubscriptionDetails(message: GetSubscriptionDetailsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionDetailsRequest, GetSubscriptionDetailsResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetSubscriptionDetails", message, metadata || {}, SubscriptionServiceClient.GetSubscriptionDetails);
        }
        private static GetCurrentSubscription = new grpc_web_1.MethodDescriptor<GetCurrentSubscriptionRequest, GetCurrentSubscriptionResponse>("/subscriptions.v1.SubscriptionService/GetCurrentSubscription", grpc_web_1.MethodType.UNARY, GetCurrentSubscriptionRequest, GetCurrentSubscriptionResponse, (message: GetCurrentSubscriptionRequest) => message.serialize(), GetCurrentSubscriptionResponse.deserialize);
        GetCurrentSubscription(message: GetCurrentSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetCurrentSubscriptionRequest, GetCurrentSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetCurrentSubscription", message, metadata || {}, SubscriptionServiceClient.GetCurrentSubscription);
        }
        private static GetActiveSubscription = new grpc_web_1.MethodDescriptor<GetActiveSubscriptionRequest, GetActiveSubscriptionResponse>("/subscriptions.v1.SubscriptionService/GetActiveSubscription", grpc_web_1.MethodType.UNARY, GetActiveSubscriptionRequest, GetActiveSubscriptionResponse, (message: GetActiveSubscriptionRequest) => message.serialize(), GetActiveSubscriptionResponse.deserialize);
        GetActiveSubscription(message: GetActiveSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetActiveSubscriptionRequest, GetActiveSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetActiveSubscription", message, metadata || {}, SubscriptionServiceClient.GetActiveSubscription);
        }
        private static CancelSubscriptionInvitation = new grpc_web_1.MethodDescriptor<CancelSubscriptionInvitationRequest, CancelSubscriptionInvitationResponse>("/subscriptions.v1.SubscriptionService/CancelSubscriptionInvitation", grpc_web_1.MethodType.UNARY, CancelSubscriptionInvitationRequest, CancelSubscriptionInvitationResponse, (message: CancelSubscriptionInvitationRequest) => message.serialize(), CancelSubscriptionInvitationResponse.deserialize);
        CancelSubscriptionInvitation(message: CancelSubscriptionInvitationRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<CancelSubscriptionInvitationRequest, CancelSubscriptionInvitationResponse>(this._address + "/subscriptions.v1.SubscriptionService/CancelSubscriptionInvitation", message, metadata || {}, SubscriptionServiceClient.CancelSubscriptionInvitation);
        }
        private static GetSubscriptionInvitation = new grpc_web_1.MethodDescriptor<GetSubscriptionInvitationRequest, GetSubscriptionInvitationResponse>("/subscriptions.v1.SubscriptionService/GetSubscriptionInvitation", grpc_web_1.MethodType.UNARY, GetSubscriptionInvitationRequest, GetSubscriptionInvitationResponse, (message: GetSubscriptionInvitationRequest) => message.serialize(), GetSubscriptionInvitationResponse.deserialize);
        GetSubscriptionInvitation(message: GetSubscriptionInvitationRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionInvitationRequest, GetSubscriptionInvitationResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetSubscriptionInvitation", message, metadata || {}, SubscriptionServiceClient.GetSubscriptionInvitation);
        }
        private static UpdateSubscription = new grpc_web_1.MethodDescriptor<UpdateSubscriptionRequest, UpdateSubscriptionResponse>("/subscriptions.v1.SubscriptionService/UpdateSubscription", grpc_web_1.MethodType.UNARY, UpdateSubscriptionRequest, UpdateSubscriptionResponse, (message: UpdateSubscriptionRequest) => message.serialize(), UpdateSubscriptionResponse.deserialize);
        UpdateSubscription(message: UpdateSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateSubscriptionRequest, UpdateSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/UpdateSubscription", message, metadata || {}, SubscriptionServiceClient.UpdateSubscription);
        }
        private static MergeSubscriptionMetadata = new grpc_web_1.MethodDescriptor<MergeSubscriptionMetadataRequest, MergeSubscriptionMetadataResponse>("/subscriptions.v1.SubscriptionService/MergeSubscriptionMetadata", grpc_web_1.MethodType.UNARY, MergeSubscriptionMetadataRequest, MergeSubscriptionMetadataResponse, (message: MergeSubscriptionMetadataRequest) => message.serialize(), MergeSubscriptionMetadataResponse.deserialize);
        MergeSubscriptionMetadata(message: MergeSubscriptionMetadataRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<MergeSubscriptionMetadataRequest, MergeSubscriptionMetadataResponse>(this._address + "/subscriptions.v1.SubscriptionService/MergeSubscriptionMetadata", message, metadata || {}, SubscriptionServiceClient.MergeSubscriptionMetadata);
        }
        private static UpdateCurrentCycle = new grpc_web_1.MethodDescriptor<UpdateCurrentCycleRequest, UpdateCurrentCycleResponse>("/subscriptions.v1.SubscriptionService/UpdateCurrentCycle", grpc_web_1.MethodType.UNARY, UpdateCurrentCycleRequest, UpdateCurrentCycleResponse, (message: UpdateCurrentCycleRequest) => message.serialize(), UpdateCurrentCycleResponse.deserialize);
        UpdateCurrentCycle(message: UpdateCurrentCycleRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateCurrentCycleRequest, UpdateCurrentCycleResponse>(this._address + "/subscriptions.v1.SubscriptionService/UpdateCurrentCycle", message, metadata || {}, SubscriptionServiceClient.UpdateCurrentCycle);
        }
        private static AppendCycleStepHistory = new grpc_web_1.MethodDescriptor<AppendCycleStepHistoryRequest, AppendCycleStepHistoryResponse>("/subscriptions.v1.SubscriptionService/AppendCycleStepHistory", grpc_web_1.MethodType.UNARY, AppendCycleStepHistoryRequest, AppendCycleStepHistoryResponse, (message: AppendCycleStepHistoryRequest) => message.serialize(), AppendCycleStepHistoryResponse.deserialize);
        AppendCycleStepHistory(message: AppendCycleStepHistoryRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<AppendCycleStepHistoryRequest, AppendCycleStepHistoryResponse>(this._address + "/subscriptions.v1.SubscriptionService/AppendCycleStepHistory", message, metadata || {}, SubscriptionServiceClient.AppendCycleStepHistory);
        }
        private static DeactivateSubscription = new grpc_web_1.MethodDescriptor<DeactivateSubscriptionRequest, DeactivateSubscriptionResponse>("/subscriptions.v1.SubscriptionService/DeactivateSubscription", grpc_web_1.MethodType.UNARY, DeactivateSubscriptionRequest, DeactivateSubscriptionResponse, (message: DeactivateSubscriptionRequest) => message.serialize(), DeactivateSubscriptionResponse.deserialize);
        DeactivateSubscription(message: DeactivateSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeactivateSubscriptionRequest, DeactivateSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/DeactivateSubscription", message, metadata || {}, SubscriptionServiceClient.DeactivateSubscription);
        }
        private static UpgradePlan = new grpc_web_1.MethodDescriptor<UpgradePlanRequest, UpgradePlanResponse>("/subscriptions.v1.SubscriptionService/UpgradePlan", grpc_web_1.MethodType.UNARY, UpgradePlanRequest, UpgradePlanResponse, (message: UpgradePlanRequest) => message.serialize(), UpgradePlanResponse.deserialize);
        UpgradePlan(message: UpgradePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpgradePlanRequest, UpgradePlanResponse>(this._address + "/subscriptions.v1.SubscriptionService/UpgradePlan", message, metadata || {}, SubscriptionServiceClient.UpgradePlan);
        }
        private static DowngradePlan = new grpc_web_1.MethodDescriptor<DowngradePlanRequest, DowngradePlanResponse>("/subscriptions.v1.SubscriptionService/DowngradePlan", grpc_web_1.MethodType.UNARY, DowngradePlanRequest, DowngradePlanResponse, (message: DowngradePlanRequest) => message.serialize(), DowngradePlanResponse.deserialize);
        DowngradePlan(message: DowngradePlanRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DowngradePlanRequest, DowngradePlanResponse>(this._address + "/subscriptions.v1.SubscriptionService/DowngradePlan", message, metadata || {}, SubscriptionServiceClient.DowngradePlan);
        }
        private static GetActiveSubscribersReport = new grpc_web_1.MethodDescriptor<ActiveSubscribersReportRequest, ActiveSubscribersReportResponse>("/subscriptions.v1.SubscriptionService/GetActiveSubscribersReport", grpc_web_1.MethodType.UNARY, ActiveSubscribersReportRequest, ActiveSubscribersReportResponse, (message: ActiveSubscribersReportRequest) => message.serialize(), ActiveSubscribersReportResponse.deserialize);
        GetActiveSubscribersReport(message: ActiveSubscribersReportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ActiveSubscribersReportRequest, ActiveSubscribersReportResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetActiveSubscribersReport", message, metadata || {}, SubscriptionServiceClient.GetActiveSubscribersReport);
        }
        private static ListSubscriptionsSlim = new grpc_web_1.MethodDescriptor<ListSubscriptionsSlimRequest, ListSubscriptionsSlimResponse>("/subscriptions.v1.SubscriptionService/ListSubscriptionsSlim", grpc_web_1.MethodType.UNARY, ListSubscriptionsSlimRequest, ListSubscriptionsSlimResponse, (message: ListSubscriptionsSlimRequest) => message.serialize(), ListSubscriptionsSlimResponse.deserialize);
        ListSubscriptionsSlim(message: ListSubscriptionsSlimRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListSubscriptionsSlimRequest, ListSubscriptionsSlimResponse>(this._address + "/subscriptions.v1.SubscriptionService/ListSubscriptionsSlim", message, metadata || {}, SubscriptionServiceClient.ListSubscriptionsSlim);
        }
        private static UpdateDefaultPayment = new grpc_web_1.MethodDescriptor<UpdateDefaultPaymentRequest, UpdateDefaultPaymentResponse>("/subscriptions.v1.SubscriptionService/UpdateDefaultPayment", grpc_web_1.MethodType.UNARY, UpdateDefaultPaymentRequest, UpdateDefaultPaymentResponse, (message: UpdateDefaultPaymentRequest) => message.serialize(), UpdateDefaultPaymentResponse.deserialize);
        UpdateDefaultPayment(message: UpdateDefaultPaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<UpdateDefaultPaymentRequest, UpdateDefaultPaymentResponse>(this._address + "/subscriptions.v1.SubscriptionService/UpdateDefaultPayment", message, metadata || {}, SubscriptionServiceClient.UpdateDefaultPayment);
        }
        private static GetDefaultPayment = new grpc_web_1.MethodDescriptor<GetDefaultPaymentRequest, GetDefaultPaymentResponse>("/subscriptions.v1.SubscriptionService/GetDefaultPayment", grpc_web_1.MethodType.UNARY, GetDefaultPaymentRequest, GetDefaultPaymentResponse, (message: GetDefaultPaymentRequest) => message.serialize(), GetDefaultPaymentResponse.deserialize);
        GetDefaultPayment(message: GetDefaultPaymentRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetDefaultPaymentRequest, GetDefaultPaymentResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetDefaultPayment", message, metadata || {}, SubscriptionServiceClient.GetDefaultPayment);
        }
        private static RequestSubscriptionExport = new grpc_web_1.MethodDescriptor<RequestSubscriptionExportRequest, RequestSubscriptionExportResponse>("/subscriptions.v1.SubscriptionService/RequestSubscriptionExport", grpc_web_1.MethodType.UNARY, RequestSubscriptionExportRequest, RequestSubscriptionExportResponse, (message: RequestSubscriptionExportRequest) => message.serialize(), RequestSubscriptionExportResponse.deserialize);
        RequestSubscriptionExport(message: RequestSubscriptionExportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<RequestSubscriptionExportRequest, RequestSubscriptionExportResponse>(this._address + "/subscriptions.v1.SubscriptionService/RequestSubscriptionExport", message, metadata || {}, SubscriptionServiceClient.RequestSubscriptionExport);
        }
        private static GetSubscriptionExport = new grpc_web_1.MethodDescriptor<GetSubscriptionExportRequest, GetSubscriptionExportResponse>("/subscriptions.v1.SubscriptionService/GetSubscriptionExport", grpc_web_1.MethodType.UNARY, GetSubscriptionExportRequest, GetSubscriptionExportResponse, (message: GetSubscriptionExportRequest) => message.serialize(), GetSubscriptionExportResponse.deserialize);
        GetSubscriptionExport(message: GetSubscriptionExportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionExportRequest, GetSubscriptionExportResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetSubscriptionExport", message, metadata || {}, SubscriptionServiceClient.GetSubscriptionExport);
        }
        private static GetUserSubscription = new grpc_web_1.MethodDescriptor<GetUserSubscriptionRequest, GetUserSubscriptionResponse>("/subscriptions.v1.SubscriptionService/GetUserSubscription", grpc_web_1.MethodType.UNARY, GetUserSubscriptionRequest, GetUserSubscriptionResponse, (message: GetUserSubscriptionRequest) => message.serialize(), GetUserSubscriptionResponse.deserialize);
        GetUserSubscription(message: GetUserSubscriptionRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetUserSubscriptionRequest, GetUserSubscriptionResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetUserSubscription", message, metadata || {}, SubscriptionServiceClient.GetUserSubscription);
        }
        private static GetMyOffers = new grpc_web_1.MethodDescriptor<GetMyOffersRequest, GetMyOffersResponse>("/subscriptions.v1.SubscriptionService/GetMyOffers", grpc_web_1.MethodType.UNARY, GetMyOffersRequest, GetMyOffersResponse, (message: GetMyOffersRequest) => message.serialize(), GetMyOffersResponse.deserialize);
        GetMyOffers(message: GetMyOffersRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetMyOffersRequest, GetMyOffersResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetMyOffers", message, metadata || {}, SubscriptionServiceClient.GetMyOffers);
        }
        private static GetMyBenefits = new grpc_web_1.MethodDescriptor<GetMyBenefitsRequest, GetMyBenefitsResponse>("/subscriptions.v1.SubscriptionService/GetMyBenefits", grpc_web_1.MethodType.UNARY, GetMyBenefitsRequest, GetMyBenefitsResponse, (message: GetMyBenefitsRequest) => message.serialize(), GetMyBenefitsResponse.deserialize);
        GetMyBenefits(message: GetMyBenefitsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetMyBenefitsRequest, GetMyBenefitsResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetMyBenefits", message, metadata || {}, SubscriptionServiceClient.GetMyBenefits);
        }
        private static GetCancellationOffer = new grpc_web_1.MethodDescriptor<GetCancellationOfferRequest, GetCancellationOfferResponse>("/subscriptions.v1.SubscriptionService/GetCancellationOffer", grpc_web_1.MethodType.UNARY, GetCancellationOfferRequest, GetCancellationOfferResponse, (message: GetCancellationOfferRequest) => message.serialize(), GetCancellationOfferResponse.deserialize);
        GetCancellationOffer(message: GetCancellationOfferRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetCancellationOfferRequest, GetCancellationOfferResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetCancellationOffer", message, metadata || {}, SubscriptionServiceClient.GetCancellationOffer);
        }
        private static AcceptCancellationOffer = new grpc_web_1.MethodDescriptor<AcceptCancellationOfferRequest, AcceptCancellationOfferResponse>("/subscriptions.v1.SubscriptionService/AcceptCancellationOffer", grpc_web_1.MethodType.UNARY, AcceptCancellationOfferRequest, AcceptCancellationOfferResponse, (message: AcceptCancellationOfferRequest) => message.serialize(), AcceptCancellationOfferResponse.deserialize);
        AcceptCancellationOffer(message: AcceptCancellationOfferRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<AcceptCancellationOfferRequest, AcceptCancellationOfferResponse>(this._address + "/subscriptions.v1.SubscriptionService/AcceptCancellationOffer", message, metadata || {}, SubscriptionServiceClient.AcceptCancellationOffer);
        }
        private static GetSubscriptionReport = new grpc_web_1.MethodDescriptor<GetSubscriptionReportRequest, GetSubscriptionReportResponse>("/subscriptions.v1.SubscriptionService/GetSubscriptionReport", grpc_web_1.MethodType.UNARY, GetSubscriptionReportRequest, GetSubscriptionReportResponse, (message: GetSubscriptionReportRequest) => message.serialize(), GetSubscriptionReportResponse.deserialize);
        GetSubscriptionReport(message: GetSubscriptionReportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSubscriptionReportRequest, GetSubscriptionReportResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetSubscriptionReport", message, metadata || {}, SubscriptionServiceClient.GetSubscriptionReport);
        }
        private static GetRetentionReport = new grpc_web_1.MethodDescriptor<GetRetentionReportRequest, GetRetentionReportResponse>("/subscriptions.v1.SubscriptionService/GetRetentionReport", grpc_web_1.MethodType.UNARY, GetRetentionReportRequest, GetRetentionReportResponse, (message: GetRetentionReportRequest) => message.serialize(), GetRetentionReportResponse.deserialize);
        GetRetentionReport(message: GetRetentionReportRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetRetentionReportRequest, GetRetentionReportResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetRetentionReport", message, metadata || {}, SubscriptionServiceClient.GetRetentionReport);
        }
        private static ListSubscriptionsWithCycleProblems = new grpc_web_1.MethodDescriptor<ListSubscriptionsWithCycleProblemsRequest, ListSubscriptionsWithCycleProblemsResponse>("/subscriptions.v1.SubscriptionService/ListSubscriptionsWithCycleProblems", grpc_web_1.MethodType.UNARY, ListSubscriptionsWithCycleProblemsRequest, ListSubscriptionsWithCycleProblemsResponse, (message: ListSubscriptionsWithCycleProblemsRequest) => message.serialize(), ListSubscriptionsWithCycleProblemsResponse.deserialize);
        ListSubscriptionsWithCycleProblems(message: ListSubscriptionsWithCycleProblemsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListSubscriptionsWithCycleProblemsRequest, ListSubscriptionsWithCycleProblemsResponse>(this._address + "/subscriptions.v1.SubscriptionService/ListSubscriptionsWithCycleProblems", message, metadata || {}, SubscriptionServiceClient.ListSubscriptionsWithCycleProblems);
        }
        private static GetPartnerSubscriptionDetails = new grpc_web_1.MethodDescriptor<GetPartnerSubscriptionDetailsRequest, GetPartnerSubscriptionDetailsResponse>("/subscriptions.v1.SubscriptionService/GetPartnerSubscriptionDetails", grpc_web_1.MethodType.UNARY, GetPartnerSubscriptionDetailsRequest, GetPartnerSubscriptionDetailsResponse, (message: GetPartnerSubscriptionDetailsRequest) => message.serialize(), GetPartnerSubscriptionDetailsResponse.deserialize);
        GetPartnerSubscriptionDetails(message: GetPartnerSubscriptionDetailsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetPartnerSubscriptionDetailsRequest, GetPartnerSubscriptionDetailsResponse>(this._address + "/subscriptions.v1.SubscriptionService/GetPartnerSubscriptionDetails", message, metadata || {}, SubscriptionServiceClient.GetPartnerSubscriptionDetails);
        }
        private static ListPartnerSubscriptions = new grpc_web_1.MethodDescriptor<ListPartnerSubscriptionsRequest, ListPartnerSubscriptionsResponse>("/subscriptions.v1.SubscriptionService/ListPartnerSubscriptions", grpc_web_1.MethodType.UNARY, ListPartnerSubscriptionsRequest, ListPartnerSubscriptionsResponse, (message: ListPartnerSubscriptionsRequest) => message.serialize(), ListPartnerSubscriptionsResponse.deserialize);
        ListPartnerSubscriptions(message: ListPartnerSubscriptionsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<ListPartnerSubscriptionsRequest, ListPartnerSubscriptionsResponse>(this._address + "/subscriptions.v1.SubscriptionService/ListPartnerSubscriptions", message, metadata || {}, SubscriptionServiceClient.ListPartnerSubscriptions);
        }
    }
}
